var jl = Object.defineProperty, Al = Object.defineProperties;
var _l = Object.getOwnPropertyDescriptors;
var St = Object.getOwnPropertySymbols;
var Os = Object.prototype.hasOwnProperty, Ps = Object.prototype.propertyIsEnumerable;
var Es = (e) => {
  throw TypeError(e);
};
var ii = (e, t, s) => t in e ? jl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, K = (e, t) => {
  for (var s in t || (t = {}))
    Os.call(t, s) && ii(e, s, t[s]);
  if (St)
    for (var s of St(t))
      Ps.call(t, s) && ii(e, s, t[s]);
  return e;
}, he = (e, t) => Al(e, _l(t));
var it = (e, t) => {
  var s = {};
  for (var l in e)
    Os.call(e, l) && t.indexOf(l) < 0 && (s[l] = e[l]);
  if (e != null && St)
    for (var l of St(e))
      t.indexOf(l) < 0 && Ps.call(e, l) && (s[l] = e[l]);
  return s;
};
var z = (e, t, s) => ii(e, typeof t != "symbol" ? t + "" : t, s), Qs = (e, t, s) => t.has(e) || Es("Cannot " + s);
var Bs = (e, t, s) => (Qs(e, t, "read from private field"), s ? s.call(e) : t.get(e)), Ds = (e, t, s) => t.has(e) ? Es("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, s), js = (e, t, s, l) => (Qs(e, t, "write to private field"), l ? l.call(e, s) : t.set(e, s), s);
var pe = (e, t, s) => new Promise((l, c) => {
  var u = (m) => {
    try {
      b(s.next(m));
    } catch (h) {
      c(h);
    }
  }, f = (m) => {
    try {
      b(s.throw(m));
    } catch (h) {
      c(h);
    }
  }, b = (m) => m.done ? l(m.value) : Promise.resolve(m.value).then(u, f);
  b((s = s.apply(e, t)).next());
});
import { y as Pn, z as $l, a as ve, S as ke, d as Pe, g as si, r as As, G as ri, b as ql, c as eo, n as to, o as io, l as _s, e as ni, f as st, F as $s, V as so, P as ro, h as no, q as lo, H as qs, M as oo, i as ao, s as co, L as uo, A as ho, B as po, C as mo, D as fo, p as bo, k as er, u as yo, E as Zo, x as go, I as tr, J as So, K as Xo, N as Ro, O as Go, Q as Vo, R as Wo, T as Io } from "./common-Bb1m6MTi.js";
import { L as wo, i as Ke } from "./buffer-DIFxvF2Q.js";
import { LDRecord as Co } from "./LDRecord.js";
const xo = {
  key: "_sid"
}, vo = "rrweb/sequential-id@1", Lo = (e) => {
  const t = xo;
  let s = 0;
  return {
    name: vo,
    eventProcessor(l) {
      return Object.assign(l, {
        [t.key]: ++s
      }), l;
    },
    options: t
  };
};
var ko = Object.defineProperty, Jo = (e, t, s) => t in e ? ko(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, L = (e, t, s) => Jo(e, typeof t != "symbol" ? t + "" : t, s), ir, Yo = Object.defineProperty, No = (e, t, s) => t in e ? Yo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, sr = (e, t, s) => No(e, typeof t != "symbol" ? t + "" : t, s), de = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(de || {});
const Xt = /* @__PURE__ */ new Map(), rr = /* @__PURE__ */ new WeakSet();
function nr(e) {
  return e !== null && typeof e == "object" && "complete" in e && "naturalWidth" in e && "naturalHeight" in e && "src" in e && "onload" in e;
}
function To(e) {
  if (rr.has(e))
    return;
  rr.add(e);
  const t = e.drawImage.bind(e);
  e.drawImage = function(s, ...l) {
    const c = Xt.get(e);
    c && (c.cancelled = !0);
    const u = () => {
      l.length === 2 && nr(s) && l.push(
        s.naturalWidth || s.width,
        s.naturalHeight || s.height
      ), t(s, ...l);
    };
    if (nr(s) && !s.complete) {
      const f = { cancelled: !1 };
      Xt.set(e, f);
      const b = () => {
        f.cancelled || (Xt.delete(e), u());
      }, m = () => {
        if (!f.cancelled) {
          Xt.delete(e);
          try {
            u();
          } catch (h) {
          }
        }
      };
      s.onload = b, s.onerror = m;
    } else
      u();
  };
}
const lr = {
  Node: [
    "childNodes",
    "parentNode",
    "parentElement",
    "textContent",
    "ownerDocument"
  ],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, or = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, Rt = {}, En = {}, Uo = () => !!globalThis.Zone;
function Gs(e) {
  if (Rt[e])
    return Rt[e];
  const t = globalThis[e], s = t.prototype, l = e in lr ? lr[e] : void 0, c = !!(l && // @ts-expect-error 2345
  l.every(
    (b) => {
      var m, h;
      return !!((h = (m = Object.getOwnPropertyDescriptor(s, b)) == null ? void 0 : m.get) != null && h.toString().includes("[native code]"));
    }
  )), u = e in or ? or[e] : void 0, f = !!(u && u.every(
    // @ts-expect-error 2345
    (b) => {
      var m;
      return typeof s[b] == "function" && ((m = s[b]) == null ? void 0 : m.toString().includes("[native code]"));
    }
  ));
  if (c && f && !Uo())
    return Rt[e] = t.prototype, t.prototype;
  try {
    const b = document.createElement("iframe");
    b.style.display = "none", document.body.appendChild(b);
    const m = b.contentWindow;
    if (!m) return t.prototype;
    const h = m[e].prototype;
    if (!h)
      return b.remove(), s;
    const d = navigator.userAgent;
    return d.includes("Safari") && !d.includes("Chrome") ? (b.classList.add("rr-block"), b.setAttribute("__rrwebUntaintedMutationObserver", ""), En[e] = () => b.remove()) : b.remove(), Rt[e] = h;
  } catch (b) {
    return s;
  }
}
const li = {};
function Ye(e, t, s) {
  var l;
  const c = `${e}.${String(s)}`;
  if (li[c])
    return li[c].call(
      t
    );
  const u = Gs(e), f = (l = Object.getOwnPropertyDescriptor(
    u,
    s
  )) == null ? void 0 : l.get;
  return f ? (li[c] = f, f.call(t)) : t[s];
}
const oi = {};
function Qn(e, t, s) {
  const l = `${e}.${String(s)}`;
  if (oi[l])
    return oi[l].bind(
      t
    );
  const u = Gs(e)[s];
  return typeof u != "function" ? t[s] : (oi[l] = u, u.bind(t));
}
function Ko(e) {
  return Ye("Node", e, "ownerDocument");
}
function Fo(e) {
  return Ye("Node", e, "childNodes");
}
function Mo(e) {
  return Ye("Node", e, "parentNode");
}
function zo(e) {
  return Ye("Node", e, "parentElement");
}
function Ho(e) {
  return Ye("Node", e, "textContent");
}
function Oo(e, t) {
  return Qn("Node", e, "contains")(t);
}
function Po(e) {
  return Qn("Node", e, "getRootNode")();
}
function Eo(e) {
  return !e || !("host" in e) ? null : Ye("ShadowRoot", e, "host");
}
function Qo(e) {
  return e.styleSheets;
}
function Bo(e) {
  return !e || !("shadowRoot" in e) ? null : Ye("Element", e, "shadowRoot");
}
function Do(e, t) {
  return Ye("Element", e, "querySelector")(t);
}
function jo(e, t) {
  return Ye("Element", e, "querySelectorAll")(t);
}
function Ao() {
  var e;
  return [
    Gs("MutationObserver").constructor,
    (e = En.MutationObserver) != null ? e : () => {
    }
  ];
}
let Bn = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (Bn = () => (/* @__PURE__ */ new Date()).getTime());
function _o(e, t, s) {
  try {
    if (!(t in e))
      return () => {
      };
    const l = e[t], c = s(l);
    return typeof c == "function" && (c.prototype = c.prototype || {}, Object.defineProperties(c, {
      __rrweb_original__: {
        enumerable: !1,
        value: l
      }
    })), e[t] = c, () => {
      e[t] = l;
    };
  } catch (l) {
    return () => {
    };
  }
}
const me = {
  ownerDocument: Ko,
  childNodes: Fo,
  parentNode: Mo,
  parentElement: zo,
  textContent: Ho,
  contains: Oo,
  getRootNode: Po,
  host: Eo,
  styleSheets: Qo,
  shadowRoot: Bo,
  querySelector: Do,
  querySelectorAll: jo,
  nowTimestamp: Bn,
  mutationObserverCtor: Ao,
  patch: _o,
  wrapCanvasContextDrawImage: To
};
function Dn(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function lt(e) {
  const t = (
    // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    e && "host" in e && "mode" in e && me.host(e) || null
  );
  return !!(t && "shadowRoot" in t && me.shadowRoot(t) === e);
}
function ot(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function $o(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), e;
}
function qo(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3) return t;
  const s = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? s.push("layer") : e.layerName && s.push(`layer(${e.layerName})`), e.supportsText && s.push(`supports(${e.supportsText})`), e.media.length && s.push(e.media.mediaText), s.join(" ") + ";";
}
function ms(e) {
  try {
    const t = e.rules || e.cssRules;
    if (!t)
      return null;
    let s = e.href;
    !s && e.ownerNode && (s = e.ownerNode.baseURI);
    const l = Array.from(
      t,
      (c) => jn(c, s)
    ).join("");
    return $o(l);
  } catch (t) {
    return null;
  }
}
function jn(e, t) {
  if (An(e)) {
    let s;
    try {
      s = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      ms(e.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      qo(e);
    } catch (l) {
      s = e.cssText;
    }
    return e.styleSheet.href ? Ut(s, e.styleSheet.href) : s;
  } else {
    let s = e.cssText;
    return ta(e) && e.selectorText.includes(":") && (s = ea(s)), t ? Ut(s, t) : s;
  }
}
function ea(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function An(e) {
  return "styleSheet" in e;
}
function ta(e) {
  return "selectorText" in e;
}
class _n {
  constructor() {
    sr(this, "idNodeMap", /* @__PURE__ */ new Map()), sr(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var s;
    if (!t) return -1;
    const l = (s = this.getMeta(t)) == null ? void 0 : s.id;
    return l != null ? l : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach(
      (l) => this.removeNodeFromMap(l)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const l = s.id;
    this.idNodeMap.set(l, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const l = this.getNode(t);
    if (l) {
      const c = this.nodeMetaMap.get(l);
      c && this.nodeMetaMap.set(s, c);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function ia() {
  return new _n();
}
function Nt({
  element: e,
  maskInputOptions: t,
  tagName: s,
  type: l,
  value: c,
  overwriteRecord: u,
  maskInputFn: f
}) {
  let b = c || "";
  return el({
    maskInputOptions: t,
    tagName: s,
    type: l,
    overwriteRecord: u
  }) && (f ? b = f(b, e) : b = "*".repeat(b.length)), b;
}
function Ee(e) {
  return e.toLowerCase();
}
const ar = "__rrweb_original__";
function sa(e) {
  const t = e.getContext("2d");
  if (!t) return !0;
  const s = 50;
  for (let l = 0; l < e.width; l += s)
    for (let c = 0; c < e.height; c += s) {
      const u = t.getImageData, f = ar in u ? u[ar] : u;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        f.call(
          t,
          l,
          c,
          Math.min(s, e.width - l),
          Math.min(s, e.height - c)
        ).data.buffer
      ).some((m) => m !== 0)) return !1;
    }
  return !0;
}
function Tt(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Ee(t)
  ) : null;
}
function $n(e, t) {
  var u;
  let s;
  try {
    s = new URL(e, window.location.href);
  } catch (f) {
    return null;
  }
  const l = /\.([0-9a-z]+)(?:$)/i, c = s.pathname.match(l);
  return (u = c == null ? void 0 : c[1]) != null ? u : null;
}
function ra(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
const na = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, la = /^(?:[a-z+]+:)?\/\//i, oa = /^www\..*/i, aa = /^(data:)([^,]*),(.*)/i;
function Ut(e, t) {
  return (e || "").replace(
    na,
    (s, l, c, u, f, b) => {
      const m = c || f || b, h = l || u || "";
      if (!m)
        return s;
      if (la.test(m) || oa.test(m))
        return `url(${h}${m}${h})`;
      if (aa.test(m))
        return `url(${h}${m}${h})`;
      if (m[0] === "/")
        return `url(${h}${ra(t) + m}${h})`;
      const d = m.split("#")[0], r = m.substring(d.length), n = t.split("#")[0].split("/"), i = d.split("/");
      n.pop();
      for (const o of i)
        o !== "." && (o === ".." ? n.pop() : n.push(o));
      return `url(${h}${n.join("/")}${r}${h})`;
    }
  );
}
function Gt(e, t = !1) {
  return t ? e.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "") : e.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function ca(e, t, s = !1) {
  const l = Array.from(t.childNodes), c = [];
  let u = 0;
  if (l.length > 1 && e && typeof e == "string") {
    let f = Gt(e, s);
    const b = f.length / e.length;
    for (let m = 1; m < l.length; m++)
      if (l[m].textContent && typeof l[m].textContent == "string") {
        const h = Gt(
          l[m].textContent,
          s
        ), d = 100;
        let r = 3;
        for (; r < h.length && // keep consuming css identifiers (to get a decent chunk more quickly)
        (h[r].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
        h.indexOf(h.substring(0, r), 1) !== -1); r++)
          ;
        for (; r < h.length; r++) {
          let n = h.substring(0, r), i = f.split(n), o = -1;
          if (i.length === 2)
            o = i[0].length;
          else if (i.length > 2 && i[0] === "" && l[m - 1].textContent !== "")
            o = f.indexOf(n, 1);
          else if (i.length === 1) {
            if (n = n.substring(
              0,
              n.length - 1
            ), i = f.split(n), i.length <= 1)
              return c.push(e), c;
            r = d + 1;
          } else r === h.length - 1 && (o = f.indexOf(n));
          if (i.length >= 2 && r > d) {
            const a = l[m - 1].textContent;
            if (a && typeof a == "string") {
              const p = Gt(a).length;
              o = f.indexOf(n, p);
            }
            o === -1 && (o = i[0].length);
          }
          if (o !== -1) {
            let a = Math.floor(o / b);
            for (; a > 0 && a < e.length; ) {
              if (u += 1, u > 50 * l.length)
                return c.push(e), c;
              const p = Gt(
                e.substring(0, a),
                s
              );
              if (p.length === o) {
                c.push(e.substring(0, a)), e = e.substring(a), f = f.substring(o);
                break;
              } else p.length < o ? a += Math.max(
                1,
                Math.floor((o - p.length) / b)
              ) : a -= Math.max(
                1,
                Math.floor((p.length - o) * b)
              );
            }
            break;
          }
        }
      }
  }
  return c.push(e), c;
}
function ua(e, t) {
  return ca(e, t).join("/* rr_split */");
}
function Vs(e) {
  return e = e.replace(/[^ -~]+/g, ""), e = (e == null ? void 0 : e.split(" ").map((t) => t ? Math.random().toString(20).substring(2, t.length + 2) : "").join(" ")) || "", e;
}
function fs(e) {
  return e === "img" || e === "video" || e === "audio" || e === "source";
}
const da = new RegExp(
  /[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*/
), ha = new RegExp(/[0-9]{9,16}/), pa = new RegExp(/[0-9]{3}-?[0-9]{2}-?[0-9]{4}/), ma = new RegExp(
  /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/
), fa = new RegExp(/[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}/), ba = new RegExp(
  /[0-9]{1,5}.?[0-9]{0,3}\s[a-zA-Z]{2,30}\s[a-zA-Z]{2,15}/
), ya = new RegExp(/(?:[0-9]{1,3}.){3}[0-9]{1,3}/), Za = [
  da,
  ha,
  pa,
  ma,
  fa,
  ba,
  ya
];
function qn(e) {
  return e ? Za.some((t) => t.test(e)) : !1;
}
const el = ({
  maskInputOptions: e,
  tagName: t,
  type: s,
  overwriteRecord: l
}) => {
  const c = s && s.toLowerCase();
  return l !== "true" && (!!e[t.toLowerCase()] || !!(c && e[c]));
};
let ga = 1;
const Sa = new RegExp("[^a-z0-9-_:]"), dt = -2;
function tl() {
  return ga++;
}
function Xa(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = Ee(e.tagName);
  return Sa.test(t) ? "div" : t;
}
let je, cr;
const Ra = /^[^ \t\n\r\u000c]+/, Ga = /^[, \t\n\r\u000c]+/;
function Va(e, t) {
  if (t.trim() === "")
    return t;
  let s = 0;
  function l(u) {
    let f;
    const b = u.exec(t.substring(s));
    return b ? (f = b[0], s += f.length, f) : "";
  }
  const c = [];
  for (; l(Ga), !(s >= t.length); ) {
    let u = l(Ra);
    if (u.slice(-1) === ",")
      u = $e(e, u.substring(0, u.length - 1)), c.push(u);
    else {
      let f = "";
      u = $e(e, u);
      let b = !1;
      for (; ; ) {
        const m = t.charAt(s);
        if (m === "") {
          c.push((u + f).trim());
          break;
        } else if (b)
          m === ")" && (b = !1);
        else if (m === ",") {
          s += 1, c.push((u + f).trim());
          break;
        } else m === "(" && (b = !0);
        f += m, s += 1;
      }
    }
  }
  return c.join(", ");
}
const ur = /* @__PURE__ */ new WeakMap();
function $e(e, t) {
  return !t || t.trim() === "" ? t : Ws(e, t);
}
function Wa(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function Ws(e, t) {
  let s = ur.get(e);
  if (s || (s = e.createElement("a"), ur.set(e, s)), !t)
    t = "";
  else if (t.startsWith("blob:") || t.startsWith("data:"))
    return t;
  return s.setAttribute("href", t), s.href;
}
function il(e, t, s, l) {
  return l && (s === "src" || s === "href" && !(t === "use" && l[0] === "#") || s === "xlink:href" && l[0] !== "#" || s === "background" && ["table", "td", "th"].includes(t) ? $e(e, l) : s === "srcset" ? Va(e, l) : s === "style" ? Ut(l, Ws(e)) : t === "object" && s === "data" ? $e(e, l) : l);
}
function sl(e, t, s) {
  return ["video", "audio"].includes(e) && t === "autoplay";
}
function dr(e, t, s) {
  try {
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let l = e.classList.length; l--; ) {
        const c = e.classList[l];
        if (t.test(c))
          return !0;
      }
    if (s)
      return e.matches(s);
  } catch (l) {
  }
  return !1;
}
function Kt(e, t, s) {
  if (!e) return !1;
  if (e.nodeType !== e.ELEMENT_NODE)
    return s ? Kt(me.parentNode(e), t, s) : !1;
  for (let l = e.classList.length; l--; ) {
    const c = e.classList[l];
    if (t.test(c))
      return !0;
  }
  return s ? Kt(me.parentNode(e), t, s) : !1;
}
function rl(e, t, s, l) {
  let c;
  if (Dn(e)) {
    if (c = e, !me.childNodes(c).length)
      return !1;
  } else {
    if (me.parentElement(e) === null)
      return !1;
    c = me.parentElement(e);
  }
  try {
    if (typeof t == "string") {
      if (l) {
        if (c.closest(`.${t}`)) return !0;
      } else if (c.classList.contains(t)) return !0;
    } else if (Kt(c, t, l)) return !0;
    if (s) {
      if (l) {
        if (c.closest(s)) return !0;
      } else if (c.matches(s)) return !0;
    }
  } catch (u) {
  }
  return !1;
}
function Ia(e, t, s) {
  const l = e.contentWindow;
  if (!l)
    return;
  let c = !1, u;
  try {
    u = l.document.readyState;
  } catch (b) {
    return;
  }
  if (u !== "complete") {
    const b = setTimeout(() => {
      c || (t(), c = !0);
    }, s);
    e.addEventListener("load", () => {
      clearTimeout(b), c = !0, t();
    });
    return;
  }
  const f = "about:blank";
  if (l.location.href !== f || e.src === f || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function wa(e, t, s) {
  let l = !1, c;
  try {
    c = e.sheet;
  } catch (f) {
    return;
  }
  if (c) return;
  const u = setTimeout(() => {
    l || (t(), l = !0);
  }, s);
  e.addEventListener("load", () => {
    clearTimeout(u), l = !0, t();
  });
}
function Ca(e, t) {
  const {
    doc: s,
    mirror: l,
    blockClass: c,
    blockSelector: u,
    needsMask: f,
    inlineStylesheet: b,
    maskInputOptions: m = {},
    maskTextClass: h,
    maskTextFn: d,
    maskInputFn: r,
    dataURLOptions: n = {},
    inlineImages: i,
    inlineVideos: o,
    recordCanvas: a,
    keepIframeSrcFn: p,
    newlyAddedElement: X = !1,
    cssCaptured: Z = !1,
    privacySetting: S
  } = t, G = xa(s, l);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: de.Document,
        childNodes: [],
        compatMode: e.compatMode
        // probably "BackCompat"
      } : {
        type: de.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: de.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: G
      };
    case e.ELEMENT_NODE:
      return La(e, {
        doc: s,
        blockClass: c,
        blockSelector: u,
        inlineStylesheet: b,
        maskInputOptions: m,
        maskInputFn: r,
        maskTextClass: h,
        dataURLOptions: n,
        inlineImages: i,
        inlineVideos: o,
        recordCanvas: a,
        keepIframeSrcFn: p,
        newlyAddedElement: X,
        privacySetting: S,
        rootId: G
      });
    case e.TEXT_NODE:
      return va(e, {
        doc: s,
        needsMask: f,
        maskTextFn: d,
        privacySetting: S,
        rootId: G,
        cssCaptured: Z
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: de.CDATA,
        textContent: "",
        rootId: G
      };
    case e.COMMENT_NODE:
      return {
        type: de.Comment,
        textContent: me.textContent(e) || "",
        rootId: G
      };
    default:
      return !1;
  }
}
function xa(e, t) {
  if (!t.hasNode(e)) return;
  const s = t.getId(e);
  return s === 1 ? void 0 : s;
}
function va(e, t) {
  var s;
  const { needsMask: l, maskTextFn: c, privacySetting: u, rootId: f, cssCaptured: b } = t, m = me.parentNode(e), h = m && m.tagName;
  let d = "";
  const r = h === "STYLE" ? !0 : void 0, n = h === "SCRIPT" ? !0 : void 0;
  n ? d = "SCRIPT_PLACEHOLDER" : b || (d = me.textContent(e), r && d && (d = Ut(d, Ws(t.doc)))), !r && !n && d && l && (d = c ? c(d, me.parentElement(e)) : d.replace(/[\S]/g, "*"));
  const i = u === "strict", o = (s = e.parentElement) == null ? void 0 : s.getAttribute("data-hl-record"), a = u === "default" && qn(d);
  return (i || a) && !o && h && !(/* @__PURE__ */ new Set([
    "HEAD",
    "TITLE",
    "STYLE",
    "SCRIPT",
    "HTML",
    "BODY",
    "NOSCRIPT"
  ])).has(h) && d && (d = Vs(d)), {
    type: de.Text,
    textContent: d || "",
    rootId: f
  };
}
function La(e, t) {
  const {
    doc: s,
    blockClass: l,
    blockSelector: c,
    inlineStylesheet: u,
    maskInputOptions: f = {},
    maskInputFn: b,
    maskTextClass: m,
    dataURLOptions: h = {},
    inlineImages: d,
    inlineVideos: r,
    recordCanvas: n,
    keepIframeSrcFn: i,
    newlyAddedElement: o = !1,
    privacySetting: a,
    rootId: p
  } = t;
  let X = dr(e, l, c);
  const Z = dr(e, m, null), S = a === "strict";
  let G = Xa(e), g = {};
  const y = e.attributes.length;
  for (let V = 0; V < y; V++) {
    const I = e.attributes[V];
    sl(G, I.name) || (g[I.name] = il(
      s,
      G,
      Ee(I.name),
      I.value
    ));
  }
  if (G === "link" && u) {
    const V = Array.from(s.styleSheets).find((v) => v.href === e.href);
    let I = null;
    V && (I = ms(V)), I && (delete g.rel, delete g.href, g._cssText = I);
  }
  if (G === "style" && e.sheet) {
    let V = ms(
      e.sheet
    );
    V && (e.childNodes.length > 1 && (V = ua(V, e)), g._cssText = V);
  }
  if (["input", "textarea", "select"].includes(G)) {
    const V = e.value, I = e.checked;
    g.type !== "radio" && g.type !== "checkbox" && g.type !== "submit" && g.type !== "button" && V ? g.value = Nt({
      element: e,
      type: Tt(e),
      tagName: G,
      value: V,
      overwriteRecord: e.getAttribute("data-hl-record"),
      maskInputOptions: f,
      maskInputFn: b
    }) : I && (g.checked = I);
  }
  if (G === "option" && (e.selected && !f.select ? g.selected = !0 : delete g.selected), G === "dialog" && e.open && (g.rr_open_mode = e.matches("dialog:modal") ? "modal" : "non-modal"), G === "canvas" && n) {
    if (e.__context === "2d")
      sa(e);
    else if (!("__context" in e)) {
      const V = e.toDataURL(
        h.type,
        h.quality
      ), I = s.createElement("canvas");
      I.width = e.width, I.height = e.height;
      const v = I.toDataURL(
        h.type,
        h.quality
      );
      V !== v && (g.rr_dataURL = V);
    }
  }
  if (G === "img" && d && !X && !Z && !S) {
    je || (je = s.createElement("canvas"), cr = je.getContext("2d"));
    const V = e, I = V.currentSrc || V.getAttribute("src") || "<unknown-src>", v = V.crossOrigin, x = () => {
      V.removeEventListener("load", x);
      try {
        je.width = V.naturalWidth, je.height = V.naturalHeight, cr.drawImage(V, 0, 0), g.rr_dataURL = je.toDataURL(
          h.type,
          h.quality
        );
      } catch (P) {
        if (V.crossOrigin !== "anonymous") {
          V.crossOrigin = "anonymous", V.complete && V.naturalWidth !== 0 ? x() : V.addEventListener("load", x);
          return;
        } else
          console.warn(
            `Cannot inline img src=${I}! Error: ${P}`
          );
      }
      V.crossOrigin === "anonymous" && (v ? g.crossOrigin = v : V.removeAttribute("crossorigin"));
    };
    V.complete && V.naturalWidth !== 0 ? x() : V.addEventListener("load", x);
  }
  if (["audio", "video"].includes(G)) {
    const V = g;
    V.rr_mediaState = e.paused ? "paused" : "played", V.rr_mediaCurrentTime = e.currentTime, V.rr_mediaPlaybackRate = e.playbackRate, V.rr_mediaMuted = e.muted, V.rr_mediaLoop = e.loop, V.rr_mediaVolume = e.volume;
  }
  if (o || (e.scrollLeft && (g.rr_scrollLeft = e.scrollLeft), e.scrollTop && (g.rr_scrollTop = e.scrollTop)), X || Z || S && fs(G)) {
    const { width: V, height: I } = e.getBoundingClientRect();
    g = {
      class: g.class,
      rr_width: `${V}px`,
      rr_height: `${I}px`
    };
  }
  S && fs(G) && (X = !0), G === "iframe" && !i(g.src) && (e.contentDocument || (g.rr_src = g.src), delete g.src);
  let R;
  try {
    customElements.get(G) && (R = !0);
  } catch (V) {
  }
  const W = (V) => {
    const { width: I, height: v } = V.getBoundingClientRect();
    g = {
      width: I,
      height: v,
      rr_width: `${I}px`,
      rr_height: `${v}px`,
      rr_inlined_video: !0,
      class: g.class,
      style: g.style
    }, G = "canvas";
    const x = s.createElement("canvas");
    x.width = e.width, x.height = e.height, g.rr_dataURL = x.toDataURL(
      h.type,
      h.quality
    );
  };
  if (G === "video") {
    const V = e;
    d && (V.src === "" || V.src.indexOf("blob:") !== -1) && W(V), r && V.src !== "" && V.src.indexOf("blob:") === -1 && W(V);
  }
  return {
    type: de.Element,
    tagName: G,
    attributes: g,
    childNodes: [],
    isSVG: Wa(e) || void 0,
    needBlock: X,
    needMask: Z,
    rootId: p,
    isCustom: R
  };
}
function re(e) {
  return e == null ? "" : e.toLowerCase();
}
function nl(e) {
  return e === !0 || e === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: e === "all",
    headMetaDescKeywords: e === "all",
    headTitleMutations: e === "all"
  } : e || {};
}
function ka(e, t) {
  if (t.comment && e.type === de.Comment)
    return !0;
  if (e.type === de.Element) {
    if (t.script && // script tag
    (e.tagName === "script" || // (module)preload link
    e.tagName === "link" && (e.attributes.rel === "preload" && e.attributes.as === "script" || e.attributes.rel === "modulepreload") || // prefetch link
    e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && $n(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (re(e.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || re(e.attributes.name) === "application-name" || re(e.attributes.rel) === "icon" || re(e.attributes.rel) === "apple-touch-icon" || re(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && re(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (re(e.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      re(e.attributes.name).match(/^(og|twitter):/) || re(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (re(e.attributes.name) === "robots" || re(e.attributes.name) === "googlebot" || re(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (re(e.attributes.name) === "author" || re(e.attributes.name) === "generator" || re(e.attributes.name) === "framework" || re(e.attributes.name) === "publisher" || re(e.attributes.name) === "progid" || re(e.attributes.property).match(/^article:/) || re(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (re(e.attributes.name) === "google-site-verification" || re(e.attributes.name) === "yandex-verification" || re(e.attributes.name) === "csrf-token" || re(e.attributes.name) === "p:domain_verify" || re(e.attributes.name) === "verify-v1" || re(e.attributes.name) === "verification" || re(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function qe(e, t) {
  const {
    doc: s,
    mirror: l,
    blockClass: c,
    blockSelector: u,
    maskTextClass: f,
    maskTextSelector: b,
    skipChild: m = !1,
    inlineStylesheet: h = !0,
    maskInputOptions: d = {},
    maskTextFn: r,
    maskInputFn: n,
    slimDOMOptions: i,
    dataURLOptions: o = {},
    inlineImages: a = !1,
    inlineVideos: p = !1,
    recordCanvas: X = !1,
    onSerialize: Z,
    onIframeLoad: S,
    iframeLoadTimeout: G = 5e3,
    onStylesheetLoad: g,
    stylesheetLoadTimeout: y = 5e3,
    keepIframeSrcFn: R = () => !1,
    newlyAddedElement: W = !1,
    cssCaptured: V = !1,
    privacySetting: I
  } = t;
  let { needsMask: v } = t, { preserveWhiteSpace: x = !0 } = t;
  v || (v = rl(
    e,
    f,
    b,
    v === void 0
  ));
  const P = Ca(e, {
    doc: s,
    mirror: l,
    blockClass: c,
    blockSelector: u,
    needsMask: v,
    inlineStylesheet: h,
    maskInputOptions: d,
    maskTextClass: f,
    maskTextFn: r,
    maskInputFn: n,
    dataURLOptions: o,
    inlineImages: a,
    inlineVideos: p,
    recordCanvas: X,
    keepIframeSrcFn: R,
    newlyAddedElement: W,
    cssCaptured: V,
    privacySetting: I
  });
  if (!P)
    return console.warn(e, "not serialized"), null;
  let O;
  l.hasNode(e) ? O = l.getId(e) : ka(P, i) || !x && P.type === de.Text && !P.textContent.replace(/^\s+|\s+$/gm, "").length ? O = dt : O = tl();
  const w = Object.assign(P, { id: O });
  if (l.add(e, w), O === dt)
    return null;
  Z && Z(e);
  let q = !m, J = I, F = I === "strict";
  if (w.type === de.Element) {
    if (q = q && !w.needBlock, F || (F = !!w.needBlock || !!w.needMask), J = F ? "strict" : J, F && fs(w.tagName)) {
      const Q = e.cloneNode();
      Q.src = "", l.add(Q, w);
    }
    delete w.needBlock, delete w.needMask;
    const M = me.shadowRoot(e);
    M && ot(M) && (w.isShadowHost = !0);
  }
  if ((w.type === de.Document || w.type === de.Element) && q) {
    i.headWhitespace && w.type === de.Element && w.tagName === "head" && (x = !1);
    const M = {
      doc: s,
      mirror: l,
      blockClass: c,
      blockSelector: u,
      needsMask: v,
      maskTextClass: f,
      maskTextSelector: b,
      skipChild: m,
      inlineStylesheet: h,
      maskInputOptions: d,
      maskTextFn: r,
      maskInputFn: n,
      slimDOMOptions: i,
      dataURLOptions: o,
      inlineImages: a,
      inlineVideos: p,
      recordCanvas: X,
      preserveWhiteSpace: x,
      onSerialize: Z,
      onIframeLoad: S,
      iframeLoadTimeout: G,
      onStylesheetLoad: g,
      stylesheetLoadTimeout: y,
      keepIframeSrcFn: R,
      cssCaptured: !1,
      privacySetting: J
    };
    if (!(w.type === de.Element && w.tagName === "textarea" && w.attributes.value !== void 0)) {
      w.type === de.Element && w.attributes._cssText !== void 0 && typeof w.attributes._cssText == "string" && (M.cssCaptured = !0);
      for (const ne of Array.from(me.childNodes(e))) {
        const C = qe(ne, M);
        C && w.childNodes.push(C);
      }
    }
    let Q = null;
    if (Dn(e) && (Q = me.shadowRoot(e)))
      for (const ne of Array.from(me.childNodes(Q))) {
        const C = qe(ne, M);
        C && (ot(Q) && (C.isShadow = !0), w.childNodes.push(C));
      }
  }
  const _ = me.parentNode(e);
  return _ && lt(_) && ot(_) && (w.isShadow = !0), w.type === de.Element && w.tagName === "iframe" && Ia(
    e,
    () => {
      const M = e.contentDocument;
      if (M && S) {
        const Q = qe(M, {
          doc: M,
          mirror: l,
          blockClass: c,
          blockSelector: u,
          needsMask: v,
          maskTextClass: f,
          maskTextSelector: b,
          skipChild: !1,
          inlineStylesheet: h,
          maskInputOptions: d,
          maskTextFn: r,
          maskInputFn: n,
          slimDOMOptions: i,
          dataURLOptions: o,
          inlineImages: a,
          inlineVideos: p,
          recordCanvas: X,
          preserveWhiteSpace: x,
          onSerialize: Z,
          onIframeLoad: S,
          iframeLoadTimeout: G,
          onStylesheetLoad: g,
          stylesheetLoadTimeout: y,
          keepIframeSrcFn: R,
          privacySetting: I
        });
        Q && S(
          e,
          Q
        );
      }
    },
    G
  ), w.type === de.Element && w.tagName === "link" && typeof w.attributes.rel == "string" && (w.attributes.rel === "stylesheet" || w.attributes.rel === "preload" && typeof w.attributes.href == "string" && $n(w.attributes.href) === "css") && wa(
    e,
    () => {
      if (g) {
        const M = qe(e, {
          doc: s,
          mirror: l,
          blockClass: c,
          blockSelector: u,
          needsMask: v,
          maskTextClass: f,
          maskTextSelector: b,
          skipChild: !1,
          inlineStylesheet: h,
          maskInputOptions: d,
          maskTextFn: r,
          maskInputFn: n,
          slimDOMOptions: i,
          dataURLOptions: o,
          inlineImages: a,
          inlineVideos: p,
          recordCanvas: X,
          preserveWhiteSpace: x,
          onSerialize: Z,
          onIframeLoad: S,
          iframeLoadTimeout: G,
          onStylesheetLoad: g,
          stylesheetLoadTimeout: y,
          keepIframeSrcFn: R,
          privacySetting: I
        });
        M && g(
          e,
          M
        );
      }
    },
    y
  ), w;
}
function Ja(e, t) {
  const {
    mirror: s = new _n(),
    blockClass: l = "highlight-block",
    blockSelector: c = null,
    maskTextClass: u = "highlight-mask",
    maskTextSelector: f = null,
    inlineStylesheet: b = !0,
    inlineImages: m = !1,
    inlineVideos: h = !1,
    recordCanvas: d = !1,
    maskAllInputs: r = !1,
    maskTextFn: n,
    maskInputFn: i,
    slimDOM: o = !1,
    dataURLOptions: a,
    preserveWhiteSpace: p,
    onSerialize: X,
    onIframeLoad: Z,
    iframeLoadTimeout: S,
    onStylesheetLoad: G,
    stylesheetLoadTimeout: g,
    keepIframeSrcFn: y = () => !1,
    privacySetting: R = "default"
  } = t || {}, W = r === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : r === !1 ? {
    password: !0
  } : r, V = nl(o);
  return qe(e, {
    doc: e,
    mirror: s,
    blockClass: l,
    blockSelector: c,
    maskTextClass: u,
    maskTextSelector: f,
    skipChild: !1,
    inlineStylesheet: b,
    maskInputOptions: W,
    maskTextFn: n,
    maskInputFn: i,
    slimDOMOptions: V,
    dataURLOptions: a,
    inlineImages: m,
    inlineVideos: h,
    recordCanvas: d,
    preserveWhiteSpace: p,
    onSerialize: X,
    onIframeLoad: Z,
    iframeLoadTimeout: S,
    onStylesheetLoad: G,
    stylesheetLoadTimeout: g,
    keepIframeSrcFn: y,
    newlyAddedElement: !1,
    privacySetting: R
  });
}
function Ya(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var s = function l() {
      return this instanceof l ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    s.prototype = t.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(l) {
    var c = Object.getOwnPropertyDescriptor(e, l);
    Object.defineProperty(s, l, c.get ? c : {
      enumerable: !0,
      get: function() {
        return e[l];
      }
    });
  }), s;
}
var Vt = { exports: {} }, hr;
function Na() {
  if (hr) return Vt.exports;
  hr = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return Vt.exports = t(), Vt.exports.createColors = t, Vt.exports;
}
const Ta = {}, Ua = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ta
}, Symbol.toStringTag, { value: "Module" })), Ie = /* @__PURE__ */ Ya(Ua);
var ai, pr;
function Is() {
  if (pr) return ai;
  pr = 1;
  let e = /* @__PURE__ */ Na(), t = Ie;
  class s extends Error {
    constructor(c, u, f, b, m, h) {
      super(c), this.name = "CssSyntaxError", this.reason = c, m && (this.file = m), b && (this.source = b), h && (this.plugin = h), typeof u != "undefined" && typeof f != "undefined" && (typeof u == "number" ? (this.line = u, this.column = f) : (this.line = u.line, this.column = u.column, this.endLine = f.line, this.endColumn = f.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, s);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(c) {
      if (!this.source) return "";
      let u = this.source;
      c == null && (c = e.isColorSupported);
      let f = (i) => i, b = (i) => i, m = (i) => i;
      if (c) {
        let { bold: i, gray: o, red: a } = e.createColors(!0);
        b = (p) => i(a(p)), f = (p) => o(p), t && (m = (p) => t(p));
      }
      let h = u.split(/\r?\n/), d = Math.max(this.line - 3, 0), r = Math.min(this.line + 2, h.length), n = String(r).length;
      return h.slice(d, r).map((i, o) => {
        let a = d + 1 + o, p = " " + (" " + a).slice(-n) + " | ";
        if (a === this.line) {
          if (i.length > 160) {
            let Z = 20, S = Math.max(0, this.column - Z), G = Math.max(
              this.column + Z,
              this.endColumn + Z
            ), g = i.slice(S, G), y = f(p.replace(/\d/g, " ")) + i.slice(0, Math.min(this.column - 1, Z - 1)).replace(/[^\t]/g, " ");
            return b(">") + f(p) + m(g) + `
 ` + y + b("^");
          }
          let X = f(p.replace(/\d/g, " ")) + i.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return b(">") + f(p) + m(i) + `
 ` + X + b("^");
        }
        return " " + f(p) + m(i);
      }).join(`
`);
    }
    toString() {
      let c = this.showSourceCode();
      return c && (c = `

` + c + `
`), this.name + ": " + this.message + c;
    }
  }
  return ai = s, s.default = s, ai;
}
var ci, mr;
function ll() {
  if (mr) return ci;
  mr = 1;
  const e = /(<)(\/?style\b)/gi, t = /(<)(!--)/g, s = /[\t\n\f\r "#'()/;[\\\]{}]/;
  function l(d) {
    return typeof d != "string" || !d.includes("<") ? d : d.replace(e, "\\3c $2").replace(t, "\\3c $2");
  }
  const c = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function u(d) {
    return d[0].toUpperCase() + d.slice(1);
  }
  function f(d, r) {
    let n = "@" + r.name, i = r.params ? d.rawValue(r, "params") : "", o = r.raws.afterName;
    return typeof o == "undefined" ? o = i ? " " : "" : o === "" && i && !s.test(i[0]) && (o = " "), n + o + i;
  }
  function b(d, r, n) {
    let i = n.nodes, o = i.length - 1;
    for (; o > 0 && i[o].type === "comment"; )
      o -= 1;
    let a = d.raw(n, "semicolon"), p = n.type === "document";
    for (let X = i.length - 1; X >= 0; X--) {
      let Z = i[X], S = o !== X || a;
      !S && X < i.length - 1 && (Z.type === "atrule" && !Z.nodes || Z.type === "decl" && Z.prop.startsWith("--")) && (S = !0), r.push({
        document: p,
        node: Z,
        semicolon: S
      });
    }
  }
  function m(d, r, n, i) {
    let o = d.raw(n, "between", "beforeOpen");
    d.builder(l(i + o) + "{", n, "start");
    let a = n.nodes && n.nodes.length, p = () => {
      let X = a ? d.raw(n, "after") : d.raw(n, "after", "emptyBody");
      X && d.builder(l(X)), d.builder("}", n, "end"), n.type === "rule" && n.raws.ownSemicolon && d.builder(l(n.raws.ownSemicolon), n, "end");
    };
    a ? (r.push(p), b(d, r, n)) : p();
  }
  class h {
    constructor(r) {
      this.builder = r;
    }
    atrule(r, n) {
      let i = f(this, r);
      if (r.nodes)
        this.block(r, i);
      else {
        let o = (r.raws.between || "") + (n ? ";" : "");
        this.builder(l(i + o), r);
      }
    }
    beforeAfter(r, n) {
      let i;
      r.type === "decl" ? i = this.raw(r, null, "beforeDecl") : r.type === "comment" ? i = this.raw(r, null, "beforeComment") : n === "before" ? i = this.raw(r, null, "beforeRule") : i = this.raw(r, null, "beforeClose");
      let o = r.parent, a = 0;
      for (; o && o.type !== "root"; )
        a += 1, o = o.parent;
      if (i.includes(`
`)) {
        let p = this.raw(r, null, "indent");
        if (p.length)
          for (let X = 0; X < a; X++) i += p;
      }
      return i;
    }
    block(r, n) {
      let i = this.raw(r, "between", "beforeOpen");
      this.builder(l(n + i) + "{", r, "start");
      let o;
      r.nodes && r.nodes.length ? (this.body(r), o = this.raw(r, "after")) : o = this.raw(r, "after", "emptyBody"), o && this.builder(l(o)), this.builder("}", r, "end");
    }
    body(r) {
      let n = h.prototype, i = ["atrule", "block", "body", "rule", "stringify"].every(
        (a) => this[a] === n[a]
      ), o = [];
      for (b(this, o, r); o.length > 0; ) {
        let a = o.pop();
        if (typeof a == "function") {
          a();
          continue;
        }
        let p = a.node, X = this.raw(p, "before");
        X && this.builder(a.document ? X : l(X)), i && p.type === "rule" ? m(this, o, p, this.rawValue(p, "selector")) : i && p.type === "atrule" && p.nodes ? m(this, o, p, f(this, p)) : this.stringify(p, a.semicolon);
      }
    }
    comment(r) {
      let n = this.raw(r, "left", "commentLeft"), i = this.raw(r, "right", "commentRight");
      this.builder(l("/*" + n + r.text + i + "*/"), r);
    }
    decl(r, n) {
      let i = r.raws, o = this.raw(r, "between", "colon"), a = r.prop + o + this.rawValue(r, "value");
      r.important && (a += i.important || " !important"), n && (a += ";"), this.builder(l(a), r);
    }
    document(r) {
      this.body(r);
    }
    raw(r, n, i) {
      let o;
      if (i || (i = n), n && (o = r.raws[n], typeof o != "undefined"))
        return o;
      let a = r.parent;
      if (i === "before" && (!a || a.type === "root" && a.first === r || a && a.type === "document"))
        return "";
      if (!a) return c[i];
      let p = r.root(), X = p.rawCache || (p.rawCache = {});
      if (typeof X[i] != "undefined")
        return X[i];
      if (i === "before" || i === "after")
        return this.beforeAfter(r, i);
      {
        let Z = "raw" + u(i);
        this[Z] ? o = this[Z](p, r) : p.walk((S) => {
          if (o = S.raws[n], typeof o != "undefined") return !1;
        });
      }
      return typeof o == "undefined" && (o = c[i]), X[i] = o, o;
    }
    rawBeforeClose(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && i.nodes.length > 0 && typeof i.raws.after != "undefined")
          return n = i.raws.after, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
      }), n && (n = n.replace(/\S/g, "")), n;
    }
    rawBeforeComment(r, n) {
      let i;
      return r.walkComments((o) => {
        if (typeof o.raws.before != "undefined")
          return i = o.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
      }), typeof i == "undefined" ? i = this.raw(n, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
    }
    rawBeforeDecl(r, n) {
      let i;
      return r.walkDecls((o) => {
        if (typeof o.raws.before != "undefined")
          return i = o.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
      }), typeof i == "undefined" ? i = this.raw(n, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
    }
    rawBeforeOpen(r) {
      let n;
      return r.walk((i) => {
        if (i.type !== "decl" && (n = i.raws.between, typeof n != "undefined"))
          return !1;
      }), n;
    }
    rawBeforeRule(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && (i.parent !== r || r.first !== i) && typeof i.raws.before != "undefined")
          return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
      }), n && (n = n.replace(/\S/g, "")), n;
    }
    rawColon(r) {
      let n;
      return r.walkDecls((i) => {
        if (typeof i.raws.between != "undefined")
          return n = i.raws.between.replace(/[^\s:]/g, ""), !1;
      }), n;
    }
    rawEmptyBody(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && i.nodes.length === 0 && (n = i.raws.after, typeof n != "undefined"))
          return !1;
      }), n;
    }
    rawIndent(r) {
      if (r.raws.indent) return r.raws.indent;
      let n;
      return r.walk((i) => {
        let o = i.parent;
        if (o && o !== r && o.parent && o.parent === r && typeof i.raws.before != "undefined") {
          let a = i.raws.before.split(`
`);
          return n = a[a.length - 1], n = n.replace(/\S/g, ""), !1;
        }
      }), n;
    }
    rawSemicolon(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && i.nodes.length && i.last.type === "decl" && (n = i.raws.semicolon, typeof n != "undefined"))
          return !1;
      }), n;
    }
    rawValue(r, n) {
      let i = r[n], o = r.raws[n];
      return o && o.value === i ? o.raw : i;
    }
    root(r) {
      if (r.source && r.source.input.hasBOM && this.builder("\uFEFF", r, "start"), this.body(r), r.raws.after) {
        let n = r.raws.after, i = r.parent && r.parent.type === "document";
        this.builder(i ? n : l(n));
      }
    }
    rule(r) {
      this.block(r, this.rawValue(r, "selector")), r.raws.ownSemicolon && this.builder(l(r.raws.ownSemicolon), r, "end");
    }
    stringify(r, n) {
      if (!this[r.type])
        throw new Error(
          "Unknown AST node type " + r.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[r.type](r, n);
    }
  }
  return ci = h, h.default = h, ci;
}
var ui, fr;
function Ht() {
  if (fr) return ui;
  fr = 1;
  let e = ll();
  function t(s, l) {
    new e(l).stringify(s);
  }
  return ui = t, t.default = t, ui;
}
var Wt = {}, br;
function Ot() {
  return br || (br = 1, Wt.isClean = Symbol("isClean"), Wt.my = Symbol("my")), Wt;
}
var di, yr;
function Pt() {
  if (yr) return di;
  yr = 1;
  let e = Is(), t = ll(), s = Ht(), { isClean: l, my: c } = Ot();
  function u(m, h) {
    let d = new m.constructor(), r = [[m, d, h]];
    for (; r.length > 0; ) {
      let [n, i, o] = r.pop();
      for (let a in n) {
        if (!Object.prototype.hasOwnProperty.call(n, a) || a === "proxyCache") continue;
        let p = n[a], X = typeof p;
        if (a === "parent" && X === "object")
          o && (i[a] = o);
        else if (a === "source")
          i[a] = p;
        else if (Array.isArray(p)) {
          let Z = [];
          i[a] = Z;
          for (let S of p) {
            let G = new S.constructor();
            Z.push(G), r.push([S, G, i]);
          }
        } else {
          if (X === "object" && p !== null) {
            let Z = new p.constructor();
            r.push([p, Z, void 0]), p = Z;
          }
          i[a] = p;
        }
      }
    }
    return d;
  }
  function f(m, h) {
    if (h && typeof h.offset != "undefined")
      return h.offset;
    let d = 1, r = 1, n = 0;
    for (let i = 0; i < m.length; i++) {
      if (r === h.line && d === h.column) {
        n = i;
        break;
      }
      m[i] === `
` ? (d = 1, r += 1) : d += 1;
    }
    return n;
  }
  class b {
    get proxyOf() {
      return this;
    }
    constructor(h = {}) {
      this.raws = {}, this[l] = !1, this[c] = !0;
      for (let d of Object.keys(h))
        if (d !== "__proto__")
          if (d === "nodes") {
            this.nodes = [];
            for (let r of h[d])
              typeof r.clone == "function" && r.parent ? this.append(r.clone()) : this.append(r);
          } else
            this[d] = h[d];
    }
    addToError(h) {
      if (h.postcssNode = this, h.stack && this.source && /\n\s{4}at /.test(h.stack)) {
        let d = this.source;
        h.stack = h.stack.replace(
          /\n\s{4}at /,
          `$&${d.input.from}:${d.start.line}:${d.start.column}$&`
        );
      }
      return h;
    }
    after(h) {
      return this.parent.insertAfter(this, h), this;
    }
    assign(h = {}) {
      for (let d in h)
        this[d] = h[d];
      return this;
    }
    before(h) {
      return this.parent.insertBefore(this, h), this;
    }
    cleanRaws(h) {
      delete this.raws.before, delete this.raws.after, h || delete this.raws.between;
    }
    clone(h = {}) {
      let d = u(this);
      for (let r in h)
        d[r] = h[r];
      return d;
    }
    cloneAfter(h = {}) {
      let d = this.clone(h);
      return this.parent.insertAfter(this, d), d;
    }
    cloneBefore(h = {}) {
      let d = this.clone(h);
      return this.parent.insertBefore(this, d), d;
    }
    error(h, d = {}) {
      if (this.source) {
        let { end: r, start: n } = this.rangeBy(d);
        return this.source.input.error(
          h,
          { column: n.column, line: n.line },
          { column: r.column, line: r.line },
          d
        );
      }
      return new e(h);
    }
    getProxyProcessor() {
      return {
        get(h, d) {
          return d === "proxyOf" ? h : d === "root" ? () => h.root().toProxy() : h[d];
        },
        set(h, d, r) {
          return h[d] === r || (h[d] = r, (d === "prop" || d === "value" || d === "name" || d === "params" || d === "important" || /* c8 ignore next */
          d === "text") && h.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[l] = !0;
    }
    markDirty() {
      if (this[l]) {
        this[l] = !1;
        let h = this;
        for (; h = h.parent; )
          h[l] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let h = this.parent.index(this);
      return this.parent.nodes[h + 1];
    }
    positionBy(h = {}) {
      let d = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: f(d, this.source.start)
      };
      if (h.index)
        r = this.positionInside(h.index);
      else if (h.word) {
        let i = d.slice(
          f(d, this.source.start),
          f(d, this.source.end)
        ).indexOf(h.word);
        i !== -1 && (r = this.positionInside(i));
      }
      return r;
    }
    positionInside(h) {
      let d = this.source.start.column, r = this.source.start.line, n = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = f(n, this.source.start), o = i + h;
      for (let a = i; a < o; a++)
        n[a] === `
` ? (d = 1, r += 1) : d += 1;
      return { column: d, line: r, offset: o };
    }
    prev() {
      if (!this.parent) return;
      let h = this.parent.index(this);
      return this.parent.nodes[h - 1];
    }
    rangeBy(h = {}) {
      let d = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: f(d, this.source.start)
      }, n = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          f(d, this.source.end) + 1
        )
      } : {
        column: r.column + 1,
        line: r.line,
        offset: r.offset + 1
      };
      if (h.word) {
        let o = d.slice(
          f(d, this.source.start),
          f(d, this.source.end)
        ).indexOf(h.word);
        o !== -1 && (r = this.positionInside(o), n = this.positionInside(o + h.word.length));
      } else
        h.start ? r = {
          column: h.start.column,
          line: h.start.line,
          offset: f(d, h.start)
        } : typeof h.index == "number" && (r = this.positionInside(h.index)), h.end ? n = {
          column: h.end.column,
          line: h.end.line,
          offset: f(d, h.end)
        } : typeof h.endIndex == "number" ? n = this.positionInside(h.endIndex) : typeof h.index == "number" && (n = this.positionInside(h.index + 1));
      return (n.line < r.line || n.line === r.line && n.column <= r.column) && (n = {
        column: r.column + 1,
        line: r.line,
        offset: r.offset + 1
      }), { end: n, start: r };
    }
    raw(h, d) {
      return new t().raw(this, h, d);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...h) {
      if (this.parent) {
        let d = this, r = !1;
        for (let n of h)
          n === this ? r = !0 : r ? (this.parent.insertAfter(d, n), d = n) : this.parent.insertBefore(d, n);
        r || this.remove();
      }
      return this;
    }
    root() {
      let h = this;
      for (; h.parent && h.parent.type !== "document"; )
        h = h.parent;
      return h;
    }
    toJSON(h, d) {
      let r = d == null;
      d = d || /* @__PURE__ */ new Map();
      let n = [], i = [[this, n, 0]];
      for (let a = 0; a < i.length; a++) {
        let [p, X, Z] = i[a], S = {};
        X[Z] = S;
        for (let G in p) {
          if (!Object.prototype.hasOwnProperty.call(p, G) || G === "parent" || G === "proxyCache") continue;
          let g = p[G];
          if (Array.isArray(g)) {
            let y = [];
            S[G] = y;
            for (let R = 0; R < g.length; R++) {
              let W = g[R];
              typeof W == "object" && W.toJSON ? W.toJSON === b.prototype.toJSON ? i.push([W, y, R]) : y[R] = W.toJSON(null, d) : y[R] = W;
            }
          } else if (typeof g == "object" && g.toJSON)
            g.toJSON === b.prototype.toJSON ? i.push([g, S, G]) : S[G] = g.toJSON(null, d);
          else if (G === "source") {
            if (g == null) continue;
            let y = d.get(g.input);
            y == null && (y = d.size, d.set(g.input, y)), S[G] = {
              end: g.end,
              inputId: y,
              start: g.start
            };
          } else
            S[G] = g;
        }
      }
      let o = n[0];
      return r && (o.inputs = [...d.keys()].map((a) => a.toJSON())), o;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(h = s) {
      h.stringify && (h = h.stringify);
      let d = "";
      return h(this, (r) => {
        d += r;
      }), d;
    }
    warn(h, d, r = {}) {
      let n = { node: this };
      for (let i in r) n[i] = r[i];
      return h.warn(d, n);
    }
  }
  return di = b, b.default = b, di;
}
var hi, Zr;
function Et() {
  if (Zr) return hi;
  Zr = 1;
  let e = Pt();
  class t extends e {
    constructor(l) {
      super(l), this.type = "comment";
    }
  }
  return hi = t, t.default = t, hi;
}
var pi, gr;
function Qt() {
  if (gr) return pi;
  gr = 1;
  let e = Pt();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(l) {
      l && typeof l.value != "undefined" && typeof l.value != "string" && (l = he(K({}, l), { value: String(l.value) })), super(l), this.type = "decl";
    }
  }
  return pi = t, t.default = t, pi;
}
var mi, Sr;
function ze() {
  if (Sr) return mi;
  Sr = 1;
  let e = Et(), t = Qt(), s = Pt(), { isClean: l, my: c } = Ot(), u, f, b, m;
  function h(n) {
    let i = n.slice();
    for (; i.length > 0; ) {
      let o = i.pop();
      if (delete o.source, o.nodes) {
        o.nodes = o.nodes.slice();
        for (let a of o.nodes) i.push(a);
      }
    }
    return n.slice();
  }
  function d(n) {
    let i = [n];
    for (; i.length > 0; ) {
      let o = i.pop();
      if (o[l] = !1, o.proxyOf.nodes)
        for (let a of o.proxyOf.nodes) i.push(a);
    }
  }
  class r extends s {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...i) {
      for (let o of i) {
        let a = this.normalize(o, this.last);
        for (let p of a) this.proxyOf.nodes.push(p);
      }
      return this.markDirty(), this;
    }
    cleanRaws(i) {
      let o = [this];
      for (; o.length > 0; ) {
        let a = o.pop();
        if (a !== this && a.cleanRaws !== r.prototype.cleanRaws) {
          a.cleanRaws(i);
          continue;
        }
        if (s.prototype.cleanRaws.call(a, i), a.nodes)
          for (let p of a.nodes) o.push(p);
      }
    }
    each(i) {
      if (!this.proxyOf.nodes) return;
      let o = this.getIterator(), a, p;
      for (; this.indexes[o] < this.proxyOf.nodes.length && (a = this.indexes[o], p = i(this.proxyOf.nodes[a], a), p !== !1); )
        this.indexes[o] += 1;
      return delete this.indexes[o], p;
    }
    every(i) {
      return this.nodes.every(i);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let i = this.lastEach;
      return this.indexes[i] = 0, i;
    }
    getProxyProcessor() {
      return {
        get(i, o) {
          return o === "proxyOf" ? i : i[o] ? o === "each" || typeof o == "string" && o.startsWith("walk") ? (...a) => i[o](
            ...a.map((p) => typeof p == "function" ? (X, Z) => p(X.toProxy(), Z) : p)
          ) : o === "every" || o === "some" ? (a) => i[o](
            (p, ...X) => a(p.toProxy(), ...X)
          ) : o === "root" ? () => i.root().toProxy() : o === "nodes" ? i.nodes.map((a) => a.toProxy()) : o === "first" || o === "last" ? i[o].toProxy() : i[o] : i[o];
        },
        set(i, o, a) {
          return i[o] === a || (i[o] = a, (o === "name" || o === "params" || o === "selector") && i.markDirty()), !0;
        }
      };
    }
    index(i) {
      return typeof i == "number" ? i : (i.proxyOf && (i = i.proxyOf), this.proxyOf.nodes.indexOf(i));
    }
    insertAfter(i, o) {
      let a = this.index(i), p = this.normalize(o, this.proxyOf.nodes[a]).reverse();
      a = this.index(i);
      for (let Z of p) this.proxyOf.nodes.splice(a + 1, 0, Z);
      let X;
      for (let Z in this.indexes)
        X = this.indexes[Z], a < X && (this.indexes[Z] = X + p.length);
      return this.markDirty(), this;
    }
    insertBefore(i, o) {
      let a = this.index(i), p = a === 0 ? "prepend" : !1, X = this.normalize(
        o,
        this.proxyOf.nodes[a],
        p
      ).reverse();
      a = this.index(i);
      for (let S of X) this.proxyOf.nodes.splice(a, 0, S);
      let Z;
      for (let S in this.indexes)
        Z = this.indexes[S], a <= Z && (this.indexes[S] = Z + X.length);
      return this.markDirty(), this;
    }
    normalize(i, o) {
      if (typeof i == "string")
        i = h(f(i).nodes);
      else if (typeof i == "undefined")
        i = [];
      else if (Array.isArray(i)) {
        i = i.slice(0);
        for (let p of i)
          p.parent && p.parent.removeChild(p, "ignore");
      } else if (i.type === "root" && this.type !== "document") {
        i = i.nodes.slice(0);
        for (let p of i)
          p.parent && p.parent.removeChild(p, "ignore");
      } else if (i.type)
        i = [i];
      else if (i.prop) {
        if (typeof i.value == "undefined")
          throw new Error("Value field is missed in node creation");
        typeof i.value != "string" && (i.value = String(i.value)), i = [new t(i)];
      } else if (i.selector || i.selectors)
        i = [new m(i)];
      else if (i.name)
        i = [new u(i)];
      else if (i.text)
        i = [new e(i)];
      else
        throw new Error("Unknown node type in node creation");
      return i.map((p) => (p[c] || r.rebuild(p), p = p.proxyOf, p.parent && p.parent.removeChild(p), p[l] && d(p), p.raws || (p.raws = {}), typeof p.raws.before == "undefined" && o && typeof o.raws.before != "undefined" && (p.raws.before = o.raws.before.replace(/\S/g, "")), p.parent = this.proxyOf, p));
    }
    prepend(...i) {
      i = i.reverse();
      for (let o of i) {
        let a = this.normalize(o, this.first, "prepend").reverse();
        for (let p of a) this.proxyOf.nodes.unshift(p);
        for (let p in this.indexes)
          this.indexes[p] = this.indexes[p] + a.length;
      }
      return this.markDirty(), this;
    }
    push(i) {
      return i.parent = this, this.proxyOf.nodes.push(i), this;
    }
    removeAll() {
      for (let i of this.proxyOf.nodes) i.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(i) {
      i = this.index(i), this.proxyOf.nodes[i].parent = void 0, this.proxyOf.nodes.splice(i, 1);
      let o;
      for (let a in this.indexes)
        o = this.indexes[a], o >= i && (this.indexes[a] = o - 1);
      return this.markDirty(), this;
    }
    replaceValues(i, o, a) {
      return a || (a = o, o = {}), this.walkDecls((p) => {
        o.props && !o.props.includes(p.prop) || o.fast && !p.value.includes(o.fast) || (p.value = p.value.replace(i, a));
      }), this.markDirty(), this;
    }
    some(i) {
      return this.nodes.some(i);
    }
    walk(i) {
      if (!this.proxyOf.nodes) return;
      let o = [{ iterator: this.getIterator(), node: this.proxyOf }];
      for (; o.length > 0; ) {
        let { iterator: a, node: p } = o[o.length - 1], X = p.indexes[a];
        if (X >= p.proxyOf.nodes.length) {
          delete p.indexes[a], o.pop();
          let G = o[o.length - 1];
          G && (G.node.indexes[G.iterator] += 1);
          continue;
        }
        let Z = p.proxyOf.nodes[X], S;
        try {
          S = i(Z, X);
        } catch (G) {
          throw Z.addToError(G);
        }
        if (S === !1) {
          for (let G of o)
            delete G.node.indexes[G.iterator];
          return !1;
        }
        Z.walk && Z.proxyOf.nodes ? o.push({ iterator: Z.getIterator(), node: Z }) : p.indexes[a] += 1;
      }
    }
    walkAtRules(i, o) {
      return o ? i instanceof RegExp ? this.walk((a, p) => {
        if (a.type === "atrule" && i.test(a.name))
          return o(a, p);
      }) : this.walk((a, p) => {
        if (a.type === "atrule" && a.name === i)
          return o(a, p);
      }) : (o = i, this.walk((a, p) => {
        if (a.type === "atrule")
          return o(a, p);
      }));
    }
    walkComments(i) {
      return this.walk((o, a) => {
        if (o.type === "comment")
          return i(o, a);
      });
    }
    walkDecls(i, o) {
      return o ? i instanceof RegExp ? this.walk((a, p) => {
        if (a.type === "decl" && i.test(a.prop))
          return o(a, p);
      }) : this.walk((a, p) => {
        if (a.type === "decl" && a.prop === i)
          return o(a, p);
      }) : (o = i, this.walk((a, p) => {
        if (a.type === "decl")
          return o(a, p);
      }));
    }
    walkRules(i, o) {
      return o ? i instanceof RegExp ? this.walk((a, p) => {
        if (a.type === "rule" && i.test(a.selector))
          return o(a, p);
      }) : this.walk((a, p) => {
        if (a.type === "rule" && a.selector === i)
          return o(a, p);
      }) : (o = i, this.walk((a, p) => {
        if (a.type === "rule")
          return o(a, p);
      }));
    }
  }
  return r.registerParse = (n) => {
    f = n;
  }, r.registerRule = (n) => {
    m = n;
  }, r.registerAtRule = (n) => {
    u = n;
  }, r.registerRoot = (n) => {
    b = n;
  }, mi = r, r.default = r, r.rebuild = (n) => {
    let i = [n];
    for (; i.length > 0; ) {
      let o = i.pop();
      if (o.type === "atrule" ? Object.setPrototypeOf(o, u.prototype) : o.type === "rule" ? Object.setPrototypeOf(o, m.prototype) : o.type === "decl" ? Object.setPrototypeOf(o, t.prototype) : o.type === "comment" ? Object.setPrototypeOf(o, e.prototype) : o.type === "root" && Object.setPrototypeOf(o, b.prototype), o[c] = !0, o.nodes)
        for (let a of o.nodes) i.push(a);
    }
  }, mi;
}
var fi, Xr;
function ws() {
  if (Xr) return fi;
  Xr = 1;
  let e = ze();
  class t extends e {
    constructor(l) {
      super(l), this.type = "atrule";
    }
    append(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...l);
    }
    prepend(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...l);
    }
  }
  return fi = t, t.default = t, e.registerAtRule(t), fi;
}
var bi, Rr;
function Cs() {
  if (Rr) return bi;
  Rr = 1;
  let e = ze(), t, s;
  class l extends e {
    constructor(u) {
      super(K({ type: "document" }, u)), this.nodes || (this.nodes = []);
    }
    toResult(u = {}) {
      return new t(new s(), this, u).stringify();
    }
  }
  return l.registerLazyResult = (c) => {
    t = c;
  }, l.registerProcessor = (c) => {
    s = c;
  }, bi = l, l.default = l, bi;
}
var yi, Gr;
function Ka() {
  if (Gr) return yi;
  Gr = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return yi = { nanoid: (l = 21) => {
    let c = "", u = l | 0;
    for (; u-- > 0; )
      c += e[Math.random() * 64 | 0];
    return c;
  }, customAlphabet: (l, c = 21) => (u = c) => {
    let f = "", b = u | 0;
    for (; b-- > 0; )
      f += l[Math.random() * l.length | 0];
    return f;
  } }, yi;
}
var Zi, Vr;
function ol() {
  if (Vr) return Zi;
  Vr = 1;
  let { existsSync: e, readFileSync: t, realpathSync: s } = Ie, { dirname: l, isAbsolute: c, join: u, relative: f, sep: b } = Ie, { SourceMapConsumer: m, SourceMapGenerator: h } = Ie;
  function d(i) {
    try {
      return s(i);
    } catch (o) {
      return i;
    }
  }
  function r(i) {
    return Buffer ? Buffer.from(i, "base64").toString() : window.atob(i);
  }
  class n {
    constructor(o, a) {
      if (a.map === !1) return;
      a.unsafeMap && (this.unsafeMap = !0), this.loadAnnotation(o), this.inline = this.startWith(this.annotation, "data:");
      let p = a.map ? a.map.prev : void 0, X = this.loadMap(a.from, p);
      !this.mapFile && a.from && (this.mapFile = a.from), this.mapFile && (this.root = l(this.mapFile)), X && (this.text = X);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new m(this.json || this.text)), this.consumerCache;
    }
    decodeInline(o) {
      let a = /^data:application\/json;charset=utf-?8;base64,/, p = /^data:application\/json;base64,/, X = /^data:application\/json;charset=utf-?8,/, Z = /^data:application\/json,/, S = o.match(X) || o.match(Z);
      if (S)
        return decodeURIComponent(o.substr(S[0].length));
      let G = o.match(a) || o.match(p);
      if (G)
        return r(o.substr(G[0].length));
      let g = o.slice(22);
      throw g = g.slice(0, g.indexOf(",")), new Error("Unsupported source map encoding " + g);
    }
    getAnnotationURL(o) {
      return o.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(o) {
      return typeof o != "object" ? !1 : typeof o.mappings == "string" || typeof o._mappings == "string" || Array.isArray(o.sections);
    }
    loadAnnotation(o) {
      let a = o.match(/\/\*\s*# sourceMappingURL=/g);
      if (!a) return;
      let p = o.lastIndexOf(a.pop()), X = o.indexOf("*/", p);
      p > -1 && X > -1 && (this.annotation = this.getAnnotationURL(o.substring(p, X)));
    }
    loadFile(o, a, p) {
      if (!p && !this.unsafeMap) {
        if (!/\.map$/i.test(o) || !a) return;
        let X = f(d(l(a)), d(o));
        if (X === ".." || X.startsWith(".." + b) || c(X))
          return;
      }
      if (this.root = l(o), e(o))
        return this.mapFile = o, t(o, "utf-8").toString().trim();
    }
    loadMap(o, a) {
      if (a === !1) return !1;
      if (a) {
        if (typeof a == "string")
          return a;
        if (typeof a == "function") {
          let p = a(o);
          if (p) {
            let X = this.loadFile(p, o, !0);
            if (!X)
              throw new Error(
                "Unable to load previous source map: " + p.toString()
              );
            return X;
          }
        } else {
          if (a instanceof m)
            return h.fromSourceMap(a).toString();
          if (a instanceof h)
            return a.toString();
          if (this.isMap(a))
            return JSON.stringify(a);
          throw new Error(
            "Unsupported previous source map format: " + a.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let p = this.annotation;
          o && (p = u(l(o), p));
          let X = this.loadFile(p, o, !1);
          if (X)
            try {
              this.json = JSON.parse(X.replace(/^\)]}'[^\n]*\n/, ""));
            } catch (Z) {
              return;
            }
          return X;
        }
      }
    }
    startWith(o, a) {
      return o ? o.substr(0, a.length) === a : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Zi = n, n.default = n, Zi;
}
var gi, Wr;
function Bt() {
  if (Wr) return gi;
  Wr = 1;
  let { nanoid: e } = /* @__PURE__ */ Ka(), { isAbsolute: t, resolve: s } = Ie, { SourceMapConsumer: l, SourceMapGenerator: c } = Ie, { fileURLToPath: u, pathToFileURL: f } = Ie, b = Is(), m = ol(), h = Ie, d = Symbol("lineToIndexCache"), r = !!(l && c), n = !!(s && t);
  function i(a) {
    if (a[d]) return a[d];
    let p = a.css.split(`
`), X = new Array(p.length), Z = 0;
    for (let S = 0, G = p.length; S < G; S++)
      X[S] = Z, Z += p[S].length + 1;
    return a[d] = X, X;
  }
  class o {
    get from() {
      return this.file || this.id;
    }
    constructor(p, X = {}) {
      if (p === null || typeof p == "undefined" || typeof p == "object" && !p.toString)
        throw new Error(`PostCSS received ${p} instead of CSS string`);
      if (this.css = p.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, X.document && (this.document = X.document.toString()), X.from && (!n || /^\w+:\/\//.test(X.from) || t(X.from) ? this.file = X.from : this.file = s(X.from)), n && r) {
        let Z = new m(this.css, X);
        if (Z.text) {
          this.map = Z;
          let S = Z.consumer().file;
          !this.file && S && (this.file = this.mapResolve(S));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(p, X, Z, S = {}) {
      let G, g, y, R, W;
      if (X && typeof X == "object") {
        let I = X, v = Z;
        if (typeof I.offset == "number") {
          R = I.offset;
          let x = this.fromOffset(R);
          X = x.line, Z = x.col;
        } else
          X = I.line, Z = I.column, R = this.fromLineAndColumn(X, Z);
        if (typeof v.offset == "number") {
          y = v.offset;
          let x = this.fromOffset(y);
          g = x.line, G = x.col;
        } else
          g = v.line, G = v.column, y = this.fromLineAndColumn(v.line, v.column);
      } else if (Z)
        R = this.fromLineAndColumn(X, Z);
      else {
        R = X;
        let I = this.fromOffset(R);
        X = I.line, Z = I.col;
      }
      let V = this.origin(X, Z, g, G);
      return V ? W = new b(
        p,
        V.endLine === void 0 ? V.line : { column: V.column, line: V.line },
        V.endLine === void 0 ? V.column : { column: V.endColumn, line: V.endLine },
        V.source,
        V.file,
        S.plugin
      ) : W = new b(
        p,
        g === void 0 ? X : { column: Z, line: X },
        g === void 0 ? Z : { column: G, line: g },
        this.css,
        this.file,
        S.plugin
      ), W.input = {
        column: Z,
        endColumn: G,
        endLine: g,
        endOffset: y,
        line: X,
        offset: R,
        source: this.css
      }, this.file && (f && (W.input.url = f(this.file).toString()), W.input.file = this.file), W;
    }
    fromLineAndColumn(p, X) {
      return i(this)[p - 1] + X - 1;
    }
    fromOffset(p) {
      let X = i(this), Z = X[X.length - 1], S = 0;
      if (p >= Z)
        S = X.length - 1;
      else {
        let G = X.length - 2, g;
        for (; S < G; )
          if (g = S + (G - S >> 1), p < X[g])
            G = g - 1;
          else if (p >= X[g + 1])
            S = g + 1;
          else {
            S = g;
            break;
          }
      }
      return {
        col: p - X[S] + 1,
        line: S + 1
      };
    }
    mapResolve(p) {
      return /^\w+:\/\//.test(p) ? p : s(this.map.consumer().sourceRoot || this.map.root || ".", p);
    }
    origin(p, X, Z, S) {
      if (!this.map) return !1;
      let G = this.map.consumer(), g = G.originalPositionFor({ column: X - 1, line: p });
      if (!g.source) return !1;
      let y;
      if (typeof Z == "number") {
        let I = G.originalPositionFor({
          column: S - 1,
          line: Z
        });
        I.source && (y = I);
      }
      let R;
      t(g.source) ? R = f(g.source) : R = new URL(
        g.source,
        this.map.consumer().sourceRoot || f(this.map.mapFile)
      );
      let W = {
        column: g.column + 1,
        endColumn: y && y.column + 1,
        endLine: y && y.line,
        line: g.line,
        url: R.toString()
      };
      if (R.protocol === "file:")
        if (u)
          W.file = u(R);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let V = G.sourceContentFor(g.source);
      return V && (W.source = V), W;
    }
    toJSON() {
      let p = {};
      for (let X of ["hasBOM", "css", "file", "id"])
        this[X] != null && (p[X] = this[X]);
      return this.map && (p.map = K({}, this.map), p.map.consumerCache && (p.map.consumerCache = void 0)), p;
    }
  }
  return gi = o, o.default = o, h && h.registerInput && h.registerInput(o), gi;
}
var Si, Ir;
function bt() {
  if (Ir) return Si;
  Ir = 1;
  let e = ze(), t, s;
  class l extends e {
    constructor(u) {
      super(u), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(u, f, b) {
      let m = /* @__PURE__ */ new Set();
      for (let d of Array.isArray(u) ? u : [u])
        d && typeof d == "object" && !d.parent && d.raws && typeof d.raws.before != "undefined" && m.add(d.raws);
      let h = super.normalize(u);
      if (f) {
        if (b === "prepend")
          this.nodes.length > 1 ? f.raws.before = this.nodes[1].raws.before : delete f.raws.before;
        else if (this.first !== f)
          for (let d of h)
            m.has(d.raws) || (d.raws.before = f.raws.before);
      }
      return h;
    }
    removeChild(u, f) {
      let b = this.index(u);
      return !f && b === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[b].raws.before), super.removeChild(u);
    }
    toResult(u = {}) {
      return new t(new s(), this, u).stringify();
    }
  }
  return l.registerLazyResult = (c) => {
    t = c;
  }, l.registerProcessor = (c) => {
    s = c;
  }, Si = l, l.default = l, e.registerRoot(l), Si;
}
var Xi, wr;
function al() {
  if (wr) return Xi;
  wr = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let s = [" ", `
`, "	"];
      return e.split(t, s);
    },
    split(t, s, l) {
      if (typeof t != "string") return [];
      let c = [], u = "", f = !1, b = 0, m = !1, h = "", d = !1;
      for (let r of t)
        d ? d = !1 : r === "\\" ? d = !0 : m ? r === h && (m = !1) : r === '"' || r === "'" ? (m = !0, h = r) : r === "(" ? b += 1 : r === ")" ? b > 0 && (b -= 1) : b === 0 && s.includes(r) && (f = !0), f ? (u !== "" && c.push(u.trim()), u = "", f = !1) : u += r;
      return (l || u !== "") && c.push(u.trim()), c;
    }
  };
  return Xi = e, e.default = e, Xi;
}
var Ri, Cr;
function xs() {
  if (Cr) return Ri;
  Cr = 1;
  let e = ze(), t = al();
  class s extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(c) {
      let u = this.selector ? this.selector.match(/,\s*/) : null, f = u ? u[0] : "," + this.raw("between", "beforeOpen");
      this.selector = c.join(f);
    }
    constructor(c) {
      super(c), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return Ri = s, s.default = s, e.registerRule(s), Ri;
}
var Gi, xr;
function Fa() {
  if (xr) return Gi;
  xr = 1;
  let e = ws(), t = Et(), s = Qt(), l = Bt(), c = ol(), u = bt(), f = xs();
  function b(d, r) {
    return d.inputs ? d.inputs.map((n) => {
      let i = he(K({}, n), { __proto__: l.prototype });
      return i.map && (i.map = he(K({}, i.map), {
        __proto__: c.prototype
      })), i;
    }) : r;
  }
  function m(d, r, n) {
    let i = K({}, d);
    if (delete i.inputs, delete i.nodes, i.source) {
      let a = i.source, { inputId: p } = a, X = it(a, ["inputId"]);
      i.source = X, p != null && (i.source.input = r[p]);
    }
    let o;
    if (i.type === "root")
      o = new u(i);
    else if (i.type === "decl")
      o = new s(i);
    else if (i.type === "rule")
      o = new f(i);
    else if (i.type === "comment")
      o = new t(i);
    else if (i.type === "atrule")
      o = new e(i);
    else
      throw new Error("Unknown node type: " + d.type);
    if (n) {
      o.nodes = n;
      for (let p of n) p.parent = o;
    }
    return o;
  }
  function h(d, r) {
    if (Array.isArray(d)) return d.map((o) => h(o));
    let n, i = [
      { childIndex: 0, children: [], inputs: b(d, r), json: d }
    ];
    for (; i.length > 0; ) {
      let o = i[i.length - 1], a = o.json.nodes;
      if (a && o.childIndex < a.length) {
        let X = a[o.childIndex];
        o.childIndex += 1, i.push({
          childIndex: 0,
          children: [],
          inputs: b(X, o.inputs),
          json: X
        });
        continue;
      }
      i.pop();
      let p = m(
        o.json,
        o.inputs,
        a ? o.children : void 0
      );
      i.length > 0 ? i[i.length - 1].children.push(p) : n = p;
    }
    return n;
  }
  return Gi = h, h.default = h, Gi;
}
var Vi, vr;
function cl() {
  if (vr) return Vi;
  vr = 1;
  let { dirname: e, relative: t, resolve: s, sep: l } = Ie, { SourceMapConsumer: c, SourceMapGenerator: u } = Ie, { pathToFileURL: f } = Ie, b = Bt(), m = !!(c && u), h = !!(e && s && t && l);
  class d {
    constructor(n, i, o, a) {
      this.stringify = n, this.mapOpts = o.map || {}, this.root = i, this.opts = o, this.css = a, this.originalCSS = a, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let n;
      this.isInline() ? n = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? n = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? n = this.mapOpts.annotation(this.opts.to, this.root) : n = this.outputFile() + ".map";
      let i = `
`;
      this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + n + " */";
    }
    applyPrevMaps() {
      for (let n of this.previous()) {
        let i = this.toUrl(this.path(n.file)), o = n.root || e(n.file), a;
        this.mapOpts.sourcesContent === !1 ? (a = new c(n.text), a.sourcesContent && (a.sourcesContent = null)) : a = n.consumer(), this.map.applySourceMap(a, i, this.toUrl(this.path(o)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1) {
        if (this.root) {
          let n;
          for (let i = this.root.nodes.length - 1; i >= 0; i--)
            n = this.root.nodes[i], n.type === "comment" && n.text.startsWith("# sourceMappingURL=") && this.root.removeChild(i);
        } else if (this.css) {
          let n;
          for (; (n = this.css.lastIndexOf("/*#")) !== -1; ) {
            let i = this.css.indexOf("*/", n + 3);
            if (i === -1) break;
            for (; n > 0 && this.css[n - 1] === `
`; )
              n--;
            this.css = this.css.slice(0, n) + this.css.slice(i + 2);
          }
        }
      }
    }
    generate() {
      if (this.clearAnnotation(), h && m && this.isMap())
        return this.generateMap();
      {
        let n = "";
        return this.stringify(this.root, (i) => {
          n += i;
        }), [n];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let n = this.previous()[0].consumer();
        n.file = this.outputFile(), this.map = u.fromSourceMap(n, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new u({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new u({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let n = 1, i = 1, o = "<no source>", a = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, p, X;
      this.stringify(this.root, (Z, S, G) => {
        if (this.css += Z, S && G !== "end" && (a.generated.line = n, a.generated.column = i - 1, S.source && S.source.start ? (a.source = this.sourcePath(S), a.original.line = S.source.start.line, a.original.column = S.source.start.column - 1, this.map.addMapping(a)) : (a.source = o, a.original.line = 1, a.original.column = 0, this.map.addMapping(a))), X = Z.match(/\n/g), X ? (n += X.length, p = Z.lastIndexOf(`
`), i = Z.length - p) : i += Z.length, S && G !== "start") {
          let g = S.parent || { raws: {} };
          (!(S.type === "decl" || S.type === "atrule" && !S.nodes) || S !== g.last || g.raws.semicolon) && (S.source && S.source.end ? (a.source = this.sourcePath(S), a.original.line = S.source.end.line, a.original.column = S.source.end.column - 1, a.generated.line = n, a.generated.column = i - 2, this.map.addMapping(a)) : (a.source = o, a.original.line = 1, a.original.column = 0, a.generated.line = n, a.generated.column = i - 1, this.map.addMapping(a)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((n) => n.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline != "undefined")
        return this.mapOpts.inline;
      let n = this.mapOpts.annotation;
      return typeof n != "undefined" && n !== !0 ? !1 : this.previous().length ? this.previous().some((i) => i.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((n) => n.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(n) {
      if (this.mapOpts.absolute || n.charCodeAt(0) === 60 || /^\w+:\/\//.test(n)) return n;
      let i = this.memoizedPaths.get(n);
      if (i) return i;
      let o = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (o = e(s(o, this.mapOpts.annotation)));
      let a = t(o, n);
      return this.memoizedPaths.set(n, a), a;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((n) => {
            if (n.source && n.source.input.map) {
              let i = n.source.input.map;
              this.previousMaps.includes(i) || this.previousMaps.push(i);
            }
          });
        else {
          let n = new b(this.originalCSS, this.opts);
          n.map && this.previousMaps.push(n.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let n = {};
      if (this.root)
        this.root.walk((i) => {
          if (i.source) {
            let o = i.source.input.from;
            if (o && !n[o]) {
              n[o] = !0;
              let a = this.usesFileUrls ? this.toFileUrl(o) : this.toUrl(this.path(o));
              this.map.setSourceContent(a, i.source.input.css);
            }
          }
        });
      else if (this.css) {
        let i = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(i, this.css);
      }
    }
    sourcePath(n) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(n.source.input.from) : this.toUrl(this.path(n.source.input.from));
    }
    toBase64(n) {
      return Buffer ? Buffer.from(n).toString("base64") : window.btoa(unescape(encodeURIComponent(n)));
    }
    toFileUrl(n) {
      let i = this.memoizedFileURLs.get(n);
      if (i) return i;
      if (f) {
        let o = f(n).toString();
        return this.memoizedFileURLs.set(n, o), o;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(n) {
      let i = this.memoizedURLs.get(n);
      if (i) return i;
      l === "\\" && (n = n.replace(/\\/g, "/"));
      let o = encodeURI(n).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(n, o), o;
    }
  }
  return Vi = d, Vi;
}
var Wi, Lr;
function Ma() {
  if (Lr) return Wi;
  Lr = 1;
  const e = 39, t = 34, s = 92, l = 47, c = 10, u = 32, f = 12, b = 9, m = 13, h = 91, d = 93, r = 40, n = 41, i = 123, o = 125, a = 59, p = 42, X = 58, Z = 64, S = /[\t\n\f\r "#'()/;[\\\]{}]/g, G = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, g = /.[\r\n"'(/\\]/, y = /[\da-f]/i;
  return Wi = function(W, V = {}) {
    let I = W.css.valueOf(), v = V.ignoreErrors, x, P, O, w, q, J, F, _, M, Q, ne = I.length, C = 0, se = [], k = [], N = -1;
    function Y() {
      return C;
    }
    function T(U) {
      throw W.error("Unclosed " + U, C);
    }
    function H() {
      return k.length === 0 && C >= ne;
    }
    function B(U) {
      if (k.length) return k.pop();
      if (C >= ne) return;
      let D = U ? U.ignoreUnclosed : !1;
      switch (x = I.charCodeAt(C), x) {
        case c:
        case u:
        case b:
        case m:
        case f: {
          w = C;
          do
            w += 1, x = I.charCodeAt(w);
          while (x === u || x === c || x === b || x === m || x === f);
          J = ["space", I.slice(C, w)], C = w - 1;
          break;
        }
        case h:
        case d:
        case i:
        case o:
        case X:
        case a:
        case n: {
          let ue = String.fromCharCode(x);
          J = [ue, ue, C];
          break;
        }
        case r: {
          if (Q = se.length ? se.pop()[1] : "", M = I.charCodeAt(C + 1), Q === "url" && M !== e && M !== t && M !== u && M !== c && M !== b && M !== f && M !== m) {
            w = C;
            do {
              if (F = !1, w = I.indexOf(")", w + 1), w === -1)
                if (v || D) {
                  w = C;
                  break;
                } else
                  T("bracket");
              for (_ = w; I.charCodeAt(_ - 1) === s; )
                _ -= 1, F = !F;
            } while (F);
            J = ["brackets", I.slice(C, w + 1), C, w], C = w;
          } else C <= N ? J = ["(", "(", C] : (w = I.indexOf(")", C + 1), P = I.slice(C, w + 1), w === -1 || g.test(P) ? (N = w === -1 ? ne : w, J = ["(", "(", C]) : (J = ["brackets", P, C, w], C = w));
          break;
        }
        case e:
        case t: {
          q = x === e ? "'" : '"', w = C;
          do {
            if (F = !1, w = I.indexOf(q, w + 1), w === -1)
              if (v || D) {
                w = C + 1;
                break;
              } else
                T("string");
            for (_ = w; I.charCodeAt(_ - 1) === s; )
              _ -= 1, F = !F;
          } while (F);
          J = ["string", I.slice(C, w + 1), C, w], C = w;
          break;
        }
        case Z: {
          S.lastIndex = C + 1, S.test(I), S.lastIndex === 0 ? w = I.length - 1 : w = S.lastIndex - 2, J = ["at-word", I.slice(C, w + 1), C, w], C = w;
          break;
        }
        case s: {
          for (w = C, O = !0; I.charCodeAt(w + 1) === s; )
            w += 1, O = !O;
          if (x = I.charCodeAt(w + 1), O && x !== l && x !== u && x !== c && x !== b && x !== m && x !== f && (w += 1, y.test(I.charAt(w)))) {
            for (; y.test(I.charAt(w + 1)); )
              w += 1;
            I.charCodeAt(w + 1) === u && (w += 1);
          }
          J = ["word", I.slice(C, w + 1), C, w], C = w;
          break;
        }
        default: {
          x === l && I.charCodeAt(C + 1) === p ? (w = I.indexOf("*/", C + 2) + 1, w === 0 && (v || D ? w = I.length : T("comment")), J = ["comment", I.slice(C, w + 1), C, w], C = w) : (G.lastIndex = C + 1, G.test(I), G.lastIndex === 0 ? w = I.length - 1 : w = G.lastIndex - 2, J = ["word", I.slice(C, w + 1), C, w], se.push(J), C = w);
          break;
        }
      }
      return C++, J;
    }
    function ee(U) {
      k.push(U);
    }
    return {
      back: ee,
      endOfFile: H,
      nextToken: B,
      position: Y
    };
  }, Wi;
}
var Ii, kr;
function za() {
  if (kr) return Ii;
  kr = 1;
  let e = ws(), t = Et(), s = Qt(), l = bt(), c = xs(), u = Ma();
  const f = {
    empty: !0,
    space: !0
  };
  function b(d) {
    for (let r = d.length - 1; r >= 0; r--) {
      let n = d[r], i = n[3] || n[2];
      if (i) return i;
    }
  }
  function m(d, r, n) {
    let i = "";
    for (let o = r; o < n; o++) i += d[o][1];
    return i;
  }
  class h {
    constructor(r) {
      this.input = r, this.root = new l(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: r, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(r) {
      let n = new e();
      n.name = r[1].slice(1), n.name === "" && this.unnamedAtrule(n, r), this.init(n, r[2]);
      let i, o, a, p = !1, X = !1, Z = [], S = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (r = this.tokenizer.nextToken(), i = r[0], i === "(" || i === "[" ? S.push(i === "(" ? ")" : "]") : i === "{" && S.length > 0 ? S.push("}") : i === S[S.length - 1] && S.pop(), S.length === 0)
          if (i === ";") {
            n.source.end = this.getPosition(r[2]), n.source.end.offset++, this.semicolon = !0;
            break;
          } else if (i === "{") {
            X = !0;
            break;
          } else if (i === "}") {
            if (Z.length > 0) {
              for (a = Z.length - 1, o = Z[a]; o && o[0] === "space"; )
                o = Z[--a];
              o && (n.source.end = this.getPosition(o[3] || o[2]), n.source.end.offset++);
            }
            this.end(r);
            break;
          } else
            Z.push(r);
        else
          Z.push(r);
        if (this.tokenizer.endOfFile()) {
          p = !0;
          break;
        }
      }
      n.raws.between = this.spacesAndCommentsFromEnd(Z), Z.length ? (n.raws.afterName = this.spacesAndCommentsFromStart(Z), this.raw(n, "params", Z), p && (r = Z[Z.length - 1], n.source.end = this.getPosition(r[3] || r[2]), n.source.end.offset++, this.spaces = n.raws.between, n.raws.between = "")) : (n.raws.afterName = "", n.params = ""), X && (n.nodes = [], this.current = n);
    }
    checkMissedSemicolon(r) {
      let n = this.colon(r);
      if (n === !1) return;
      let i = 0, o;
      for (let a = n - 1; a >= 0 && (o = r[a], !(o[0] !== "space" && (i += 1, i === 2))); a--)
        ;
      throw this.input.error(
        "Missed semicolon",
        o[0] === "word" ? o[3] + 1 : o[2]
      );
    }
    colon(r) {
      let n = 0, i, o, a;
      for (let [p, X] of r.entries()) {
        if (o = X, a = o[0], a === "(" && (n += 1), a === ")" && (n -= 1), n === 0 && a === ":")
          if (!i)
            this.doubleColon(o);
          else {
            if (i[0] === "word" && i[1] === "progid")
              continue;
            return p;
          }
        i = o;
      }
      return !1;
    }
    comment(r) {
      let n = new t();
      this.init(n, r[2]), n.source.end = this.getPosition(r[3] || r[2]), n.source.end.offset++;
      let i = r[1].slice(2, -2);
      if (!i.trim())
        n.text = "", n.raws.left = i, n.raws.right = "";
      else {
        let o = i.match(/^(\s*)([^]*\S)(\s*)$/);
        n.text = o[2], n.raws.left = o[1], n.raws.right = o[3];
      }
    }
    createTokenizer() {
      this.tokenizer = u(this.input);
    }
    decl(r, n) {
      let i = new s();
      this.init(i, r[0][2]);
      let o = r[r.length - 1];
      o[0] === ";" && (this.semicolon = !0, r.pop()), i.source.end = this.getPosition(
        o[3] || o[2] || b(r)
      ), i.source.end.offset++;
      let a = 0;
      for (; r[a][0] !== "word"; )
        a === r.length - 1 && this.unknownWord([r[a]]), a++;
      i.raws.before += m(r, 0, a), i.source.start = this.getPosition(r[a][2]);
      let p = a;
      for (; a < r.length; ) {
        let y = r[a][0];
        if (y === ":" || y === "space" || y === "comment")
          break;
        a++;
      }
      i.prop = m(r, p, a);
      let X = a, Z;
      for (; a < r.length && (Z = r[a], a++, Z[0] !== ":"); )
        Z[0] === "word" && /\w/.test(Z[1]) && this.unknownWord([Z]);
      i.raws.between = m(r, X, a), (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
      let S = a;
      for (; a < r.length; ) {
        let y = r[a][0];
        if (y !== "space" && y !== "comment") break;
        a++;
      }
      let G = r.slice(S, a);
      r = r.slice(a), this.precheckMissedSemicolon(r);
      for (let y = r.length - 1; y >= 0; y--) {
        if (Z = r[y], Z[1].toLowerCase() === "!important") {
          i.important = !0;
          let R = this.stringFrom(r, y);
          R = this.spacesFromEnd(r) + R, R !== " !important" && (i.raws.important = R);
          break;
        } else if (Z[1].toLowerCase() === "important") {
          let R = r.slice(0), W = "";
          for (let V = y; V > 0; V--) {
            let I = R[V][0];
            if (W.trim().startsWith("!") && I !== "space")
              break;
            W = R.pop()[1] + W;
          }
          W.trim().startsWith("!") && (i.important = !0, i.raws.important = W, r = R);
        }
        if (Z[0] !== "space" && Z[0] !== "comment")
          break;
      }
      r.some((y) => y[0] !== "space" && y[0] !== "comment") && (i.raws.between += G.map((y) => y[1]).join(""), G = []), this.raw(i, "value", G.concat(r), n), i.value.includes(":") && !n && this.checkMissedSemicolon(r);
    }
    doubleColon(r) {
      throw this.input.error(
        "Double colon",
        { offset: r[2] },
        { offset: r[2] + r[1].length }
      );
    }
    emptyRule(r) {
      let n = new c();
      this.init(n, r[2]), n.selector = "", n.raws.between = "", this.current = n;
    }
    end(r) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(r[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(r);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(r) {
      if (this.spaces += r[1], this.current.nodes) {
        let n = this.current.nodes[this.current.nodes.length - 1];
        n && n.type === "rule" && !n.raws.ownSemicolon && (n.raws.ownSemicolon = this.spaces, this.spaces = "", n.source.end = this.getPosition(r[2]), n.source.end.offset += n.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(r) {
      let n = this.input.fromOffset(r);
      return {
        column: n.col,
        line: n.line,
        offset: r
      };
    }
    init(r, n) {
      this.current.push(r), r.source = {
        input: this.input,
        start: this.getPosition(n)
      }, r.raws.before = this.spaces, this.spaces = "", r.type !== "comment" && (this.semicolon = !1);
    }
    other(r) {
      let n = !1, i = null, o = !1, a = null, p = [], X = r[1].startsWith("--"), Z = [], S = r;
      for (; S; ) {
        if (i = S[0], Z.push(S), i === "(" || i === "[")
          a || (a = S), p.push(i === "(" ? ")" : "]");
        else if (X && o && i === "{")
          a || (a = S), p.push("}");
        else if (p.length === 0)
          if (i === ";")
            if (o) {
              this.decl(Z, X);
              return;
            } else
              break;
          else if (i === "{") {
            this.rule(Z);
            return;
          } else if (i === "}") {
            this.tokenizer.back(Z.pop()), n = !0;
            break;
          } else i === ":" && (o = !0);
        else i === p[p.length - 1] && (p.pop(), p.length === 0 && (a = null));
        S = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (n = !0), p.length > 0 && this.unclosedBracket(a), n && o) {
        if (!X)
          for (; Z.length && (S = Z[Z.length - 1][0], !(S !== "space" && S !== "comment")); )
            this.tokenizer.back(Z.pop());
        this.decl(Z, X);
      } else
        this.unknownWord(Z);
    }
    parse() {
      let r;
      for (; !this.tokenizer.endOfFile(); )
        switch (r = this.tokenizer.nextToken(), r[0]) {
          case "space":
            this.spaces += r[1];
            break;
          case ";":
            this.freeSemicolon(r);
            break;
          case "}":
            this.end(r);
            break;
          case "comment":
            this.comment(r);
            break;
          case "at-word":
            this.atrule(r);
            break;
          case "{":
            this.emptyRule(r);
            break;
          default:
            this.other(r);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(r, n, i, o) {
      let a, p, X = i.length, Z = "", S = !0, G, g;
      for (let y = 0; y < X; y += 1)
        a = i[y], p = a[0], p === "space" && y === X - 1 && !o ? S = !1 : p === "comment" ? (g = i[y - 1] ? i[y - 1][0] : "empty", G = i[y + 1] ? i[y + 1][0] : "empty", !f[g] && !f[G] ? Z.slice(-1) === "," ? S = !1 : Z += a[1] : S = !1) : Z += a[1];
      if (!S) {
        let y = i.reduce((R, W) => R + W[1], "");
        r.raws[n] = { raw: y, value: Z };
      }
      r[n] = Z;
    }
    rule(r) {
      r.pop();
      let n = new c();
      this.init(n, r[0][2]), n.raws.between = this.spacesAndCommentsFromEnd(r), this.raw(n, "selector", r), this.current = n;
    }
    spacesAndCommentsFromEnd(r) {
      let n, i = "";
      for (; r.length && (n = r[r.length - 1][0], !(n !== "space" && n !== "comment")); )
        i = r.pop()[1] + i;
      return i;
    }
    // Errors
    spacesAndCommentsFromStart(r) {
      let n, i = "";
      for (; r.length && (n = r[0][0], !(n !== "space" && n !== "comment")); )
        i += r.shift()[1];
      return i;
    }
    spacesFromEnd(r) {
      let n, i = "";
      for (; r.length && (n = r[r.length - 1][0], n === "space"); )
        i = r.pop()[1] + i;
      return i;
    }
    stringFrom(r, n) {
      let i = "";
      for (let o = n; o < r.length; o++)
        i += r[o][1];
      return r.splice(n, r.length - n), i;
    }
    unclosedBlock() {
      let r = this.current.source.start;
      throw this.input.error("Unclosed block", r.line, r.column);
    }
    unclosedBracket(r) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unexpectedClose(r) {
      throw this.input.error(
        "Unexpected }",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unknownWord(r) {
      throw this.input.error(
        "Unknown word " + r[0][1],
        { offset: r[0][2] },
        { offset: r[0][2] + r[0][1].length }
      );
    }
    unnamedAtrule(r, n) {
      throw this.input.error(
        "At-rule without name",
        { offset: n[2] },
        { offset: n[2] + n[1].length }
      );
    }
  }
  return Ii = h, Ii;
}
var wi, Jr;
function vs() {
  if (Jr) return wi;
  Jr = 1;
  let e = ze(), t = Bt(), s = za();
  function l(c, u) {
    let f = new t(c, u), b = new s(f);
    try {
      b.parse();
    } catch (m) {
      throw process.env.NODE_ENV !== "production" && m.name === "CssSyntaxError" && u && u.from && (/\.scss$/i.test(u.from) ? m.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(u.from) ? m.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(u.from) && (m.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), m;
    }
    return b.root;
  }
  return wi = l, l.default = l, e.registerParse(l), wi;
}
var Ci, Yr;
function ul() {
  if (Yr) return Ci;
  Yr = 1;
  let e = ze(), { my: t } = Ot();
  class s {
    constructor(c, u = {}) {
      if (this.type = "warning", this.text = c, u.node && u.node.source) {
        u.node[t] || e.rebuild(u.node);
        let f = u.node.rangeBy(u);
        this.line = f.start.line, this.column = f.start.column, this.endLine = f.end.line, this.endColumn = f.end.column;
      }
      for (let f in u) this[f] = u[f];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Ci = s, s.default = s, Ci;
}
var xi, Nr;
function Ls() {
  if (Nr) return xi;
  Nr = 1;
  let e = ul();
  class t {
    get content() {
      return this.css;
    }
    constructor(l, c, u) {
      this.processor = l, this.messages = [], this.root = c, this.opts = u, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(l, c = {}) {
      c.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (c.plugin = this.lastPlugin.postcssPlugin);
      let u = new e(l, c);
      return this.messages.push(u), u;
    }
    warnings() {
      return this.messages.filter((l) => l.type === "warning");
    }
  }
  return xi = t, t.default = t, xi;
}
var vi, Tr;
function dl() {
  if (Tr) return vi;
  Tr = 1;
  let e = {};
  return vi = function(s) {
    e[s] || (e[s] = !0, typeof console != "undefined" && console.warn && console.warn(s));
  }, vi;
}
var Li, Ur;
function hl() {
  if (Ur) return Li;
  Ur = 1;
  let e = ze(), t = Cs(), s = cl(), l = vs(), c = Ls(), u = bt(), f = Ht(), { isClean: b, my: m } = Ot(), h = dl();
  const d = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, r = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, n = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, i = 0;
  function o(G) {
    return typeof G == "object" && typeof G.then == "function";
  }
  function a(G) {
    let g = !1, y = d[G.type];
    return G.type === "decl" ? g = G.prop.toLowerCase() : G.type === "atrule" && (g = G.name.toLowerCase()), g && G.append ? [
      y,
      y + "-" + g,
      i,
      y + "Exit",
      y + "Exit-" + g
    ] : g ? [y, y + "-" + g, y + "Exit", y + "Exit-" + g] : G.append ? [y, i, y + "Exit"] : [y, y + "Exit"];
  }
  function p(G) {
    let g;
    return G.type === "document" ? g = ["Document", i, "DocumentExit"] : G.type === "root" ? g = ["Root", i, "RootExit"] : g = a(G), {
      eventIndex: 0,
      events: g,
      iterator: 0,
      node: G,
      visitorIndex: 0,
      visitors: []
    };
  }
  function X(G) {
    let g = [G];
    for (; g.length > 0; ) {
      let y = g.pop();
      if (y[b] = !1, y.nodes)
        for (let R of y.nodes) g.push(R);
    }
    return G;
  }
  let Z = {};
  class S {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(g, y, R) {
      this.stringified = !1, this.processed = !1;
      let W;
      if (typeof y == "object" && y !== null && (y.type === "root" || y.type === "document"))
        W = X(y);
      else if (y instanceof S || y instanceof c)
        W = X(y.root), y.map && (typeof R.map == "undefined" && (R.map = {}), R.map.inline || (R.map.inline = !1), R.map.prev = y.map);
      else {
        let V = l;
        R.syntax && (V = R.syntax.parse), R.parser && (V = R.parser), V.parse && (V = V.parse);
        try {
          W = V(y, R);
        } catch (I) {
          this.processed = !0, this.error = I;
        }
        W && !W[m] && e.rebuild(W);
      }
      this.result = new c(g, W, R), this.helpers = he(K({}, Z), { postcss: Z, result: this.result }), this.plugins = this.processor.plugins.map((V) => typeof V == "object" && V.prepare ? K(K({}, V), V.prepare(this.result)) : V);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(g) {
      return this.async().catch(g);
    }
    finally(g) {
      return this.async().then(g, g);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(g, y) {
      let R = this.result.lastPlugin;
      try {
        if (y && y.addToError(g), this.error = g, g.name === "CssSyntaxError" && !g.plugin)
          g.plugin = R.postcssPlugin, g.setMessage();
        else if (R.postcssVersion && process.env.NODE_ENV !== "production") {
          let W = R.postcssPlugin, V = R.postcssVersion, I = this.result.processor.version, v = V.split("."), x = I.split(".");
          (v[0] !== x[0] || parseInt(v[1]) > parseInt(x[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + I + ", but " + W + " uses " + V + ". Perhaps this is the source of the error below."
          );
        }
      } catch (W) {
        console && console.error && console.error(W);
      }
      return g;
    }
    prepareVisitors() {
      this.listeners = {};
      let g = (y, R, W) => {
        this.listeners[R] || (this.listeners[R] = []), this.listeners[R].push([y, W]);
      };
      for (let y of this.plugins)
        if (typeof y == "object")
          for (let R in y) {
            if (!r[R] && /^[A-Z]/.test(R))
              throw new Error(
                `Unknown event ${R} in ${y.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!n[R])
              if (typeof y[R] == "object")
                for (let W in y[R])
                  W === "*" ? g(y, R, y[R][W]) : g(
                    y,
                    R + "-" + W.toLowerCase(),
                    y[R][W]
                  );
              else typeof y[R] == "function" && g(y, R, y[R]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    runAsync() {
      return pe(this, null, function* () {
        this.plugin = 0;
        for (let g = 0; g < this.plugins.length; g++) {
          let y = this.plugins[g], R = this.runOnRoot(y);
          if (o(R))
            try {
              yield R;
            } catch (W) {
              throw this.handleError(W);
            }
        }
        if (this.prepareVisitors(), this.hasListener) {
          let g = this.result.root;
          for (; !g[b]; ) {
            g[b] = !0;
            let y = [p(g)];
            for (; y.length > 0; ) {
              let R = this.visitTick(y);
              if (o(R))
                try {
                  yield R;
                } catch (W) {
                  let V = y[y.length - 1].node;
                  throw this.handleError(W, V);
                }
            }
          }
          if (this.listeners.OnceExit)
            for (let [y, R] of this.listeners.OnceExit) {
              this.result.lastPlugin = y;
              try {
                if (g.type === "document") {
                  let W = g.nodes.map(
                    (V) => R(V, this.helpers)
                  );
                  yield Promise.all(W);
                } else
                  yield R(g, this.helpers);
              } catch (W) {
                throw this.handleError(W);
              }
            }
        }
        return this.processed = !0, this.stringify();
      });
    }
    runOnRoot(g) {
      this.result.lastPlugin = g;
      try {
        if (typeof g == "object" && g.Once) {
          if (this.result.root.type === "document") {
            let y = this.result.root.nodes.map(
              (R) => g.Once(R, this.helpers)
            );
            return o(y[0]) ? Promise.all(y) : y;
          }
          return g.Once(this.result.root, this.helpers);
        } else if (typeof g == "function")
          return g(this.result.root, this.result);
      } catch (y) {
        throw this.handleError(y);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let g = this.result.opts, y = f;
      g.syntax && (y = g.syntax.stringify), g.stringifier && (y = g.stringifier), y.stringify && (y = y.stringify);
      let R = this.result.root.source;
      if (g.map === void 0 && !(R && R.input && R.input.map)) {
        let I = "";
        return y(this.result.root, (v) => {
          I += v;
        }), this.result.css = I, this.result;
      }
      let V = new s(y, this.result.root, this.result.opts).generate();
      return this.result.css = V[0], this.result.map = V[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let g of this.plugins) {
        let y = this.runOnRoot(g);
        if (o(y))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let g = this.result.root;
        for (; !g[b]; )
          g[b] = !0, this.walkSync(g);
        if (this.listeners.OnceExit)
          if (g.type === "document")
            for (let y of g.nodes)
              this.visitSync(this.listeners.OnceExit, y);
          else
            this.visitSync(this.listeners.OnceExit, g);
      }
      return this.result;
    }
    then(g, y) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || h(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(g, y);
    }
    toString() {
      return this.css;
    }
    visitSync(g, y) {
      for (let [R, W] of g) {
        this.result.lastPlugin = R;
        let V;
        try {
          V = W(y, this.helpers);
        } catch (I) {
          throw this.handleError(I, y.proxyOf);
        }
        if (y.type !== "root" && y.type !== "document" && !y.parent)
          return !0;
        if (o(V))
          throw this.getAsyncError();
      }
    }
    visitTick(g) {
      let y = g[g.length - 1], { node: R, visitors: W } = y;
      if (R.type !== "root" && R.type !== "document" && !R.parent) {
        g.pop();
        return;
      }
      if (W.length > 0 && y.visitorIndex < W.length) {
        let [I, v] = W[y.visitorIndex];
        y.visitorIndex += 1, y.visitorIndex === W.length && (y.visitors = [], y.visitorIndex = 0), this.result.lastPlugin = I;
        try {
          return v(R.toProxy(), this.helpers);
        } catch (x) {
          throw this.handleError(x, R);
        }
      }
      if (y.iterator !== 0) {
        let I = y.iterator;
        y.descending && (y.descending = !1, R.indexes[I] += 1);
        let v;
        for (; v = R.nodes[R.indexes[I]]; ) {
          if (!v[b]) {
            v[b] = !0, y.descending = !0, g.push(p(v));
            return;
          }
          R.indexes[I] += 1;
        }
        y.iterator = 0, delete R.indexes[I];
      }
      let V = y.events;
      for (; y.eventIndex < V.length; ) {
        let I = V[y.eventIndex];
        if (y.eventIndex += 1, I === i) {
          R.nodes && R.nodes.length && (R[b] = !0, y.iterator = R.getIterator());
          return;
        } else if (this.listeners[I]) {
          y.visitors = this.listeners[I];
          return;
        }
      }
      g.pop();
    }
    walkSync(g) {
      g[b] = !0;
      let y = [{ eventIndex: 0, events: a(g), iterator: 0, node: g }];
      for (; y.length > 0; ) {
        let R = y[y.length - 1], W = R.node;
        if (R.iterator !== 0) {
          let V = R.iterator;
          R.descending && (R.descending = !1, W.indexes[V] += 1);
          let I, v = !1;
          for (; I = W.nodes[W.indexes[V]]; ) {
            if (!I[b]) {
              I[b] = !0, R.descending = !0, y.push({
                eventIndex: 0,
                events: a(I),
                iterator: 0,
                node: I
              }), v = !0;
              break;
            }
            W.indexes[V] += 1;
          }
          if (v) continue;
          R.iterator = 0, delete W.indexes[V];
        }
        if (R.eventIndex < R.events.length) {
          let V = R.events[R.eventIndex];
          if (R.eventIndex += 1, V === i)
            W.nodes && W.nodes.length && (R.iterator = W.getIterator());
          else {
            let I = this.listeners[V];
            I && this.visitSync(I, W.toProxy()) && y.pop();
          }
          continue;
        }
        y.pop();
      }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return S.registerPostcss = (G) => {
    Z = G;
  }, Li = S, S.default = S, u.registerLazyResult(S), t.registerLazyResult(S), Li;
}
var ki, Kr;
function Ha() {
  if (Kr) return ki;
  Kr = 1;
  let e = cl(), t = vs(), s = Ls(), l = Ht(), c = dl();
  class u {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let b, m = t;
      try {
        b = m(this._css, this._opts);
      } catch (h) {
        this.error = h;
      }
      if (this.error)
        throw this.error;
      return this._root = b, b;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(b, m, h) {
      m = m.toString(), this.stringified = !1, this._processor = b, this._css = m, this._opts = h, this._map = void 0;
      let d = l;
      this.result = new s(this._processor, void 0, this._opts), this.result.css = m;
      let r = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return r.root;
        }
      });
      let n = new e(d, void 0, this._opts, m);
      if (n.isMap()) {
        let [i, o] = n.generate();
        i && (this.result.css = i), o && (this.result.map = o);
      } else
        n.clearAnnotation(), this.result.css = n.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(b) {
      return this.async().catch(b);
    }
    finally(b) {
      return this.async().then(b, b);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(b, m) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || c(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(b, m);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return ki = u, u.default = u, ki;
}
var Ji, Fr;
function Oa() {
  if (Fr) return Ji;
  Fr = 1;
  let e = Cs(), t = hl(), s = Ha(), l = bt();
  class c {
    constructor(f = []) {
      this.version = "8.5.26", this.plugins = this.normalize(f);
    }
    normalize(f) {
      let b = [];
      for (let m of f)
        if (m.postcss === !0 ? m = m() : m.postcss && (m = m.postcss), typeof m == "object" && Array.isArray(m.plugins))
          b = b.concat(m.plugins);
        else if (typeof m == "object" && m.postcssPlugin)
          b.push(m);
        else if (typeof m == "function")
          b.push(m);
        else if (typeof m == "object" && (m.parse || m.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(m + " is not a PostCSS plugin");
      return b;
    }
    process(f, b = {}) {
      return !this.plugins.length && !b.parser && !b.stringifier && !b.syntax ? new s(this, f, b) : new t(this, f, b);
    }
    use(f) {
      return this.plugins = this.plugins.concat(this.normalize([f])), this;
    }
  }
  return Ji = c, c.default = c, l.registerProcessor(c), e.registerProcessor(c), Ji;
}
var Yi, Mr;
function Pa() {
  if (Mr) return Yi;
  Mr = 1;
  let e = ws(), t = Et(), s = ze(), l = Is(), c = Qt(), u = Cs(), f = Fa(), b = Bt(), m = hl(), h = al(), d = Pt(), r = vs(), n = Oa(), i = Ls(), o = bt(), a = xs(), p = Ht(), X = ul();
  function Z(...S) {
    return S.length === 1 && Array.isArray(S[0]) && (S = S[0]), new n(S);
  }
  return Z.plugin = function(G, g) {
    let y = !1;
    function R(...V) {
      console && console.warn && !y && (y = !0, console.warn(
        G + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        G + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let I = g(...V);
      return I.postcssPlugin = G, I.postcssVersion = new n().version, I;
    }
    let W;
    return Object.defineProperty(R, "postcss", {
      get() {
        return W || (W = R()), W;
      }
    }), R.process = function(V, I, v) {
      return Z([R(v)]).process(V, I);
    }, R;
  }, Z.stringify = p, Z.parse = r, Z.fromJSON = f, Z.list = h, Z.comment = (S) => new t(S), Z.atRule = (S) => new e(S), Z.decl = (S) => new c(S), Z.rule = (S) => new a(S), Z.root = (S) => new o(S), Z.document = (S) => new u(S), Z.CssSyntaxError = l, Z.Declaration = c, Z.Container = s, Z.Processor = n, Z.Document = u, Z.Comment = t, Z.Warning = X, Z.AtRule = e, Z.Result = i, Z.Input = b, Z.Rule = a, Z.Root = o, Z.Node = d, m.registerPostcss(Z), Yi = Z, Z.default = Z, Yi;
}
Pa();
var Ea = Object.defineProperty, Qa = (e, t, s) => t in e ? Ea(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, Ge = (e, t, s) => Qa(e, typeof t != "symbol" ? t + "" : t, s);
Date.now().toString();
function Ba(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var s = function l() {
      return this instanceof l ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    s.prototype = t.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(l) {
    var c = Object.getOwnPropertyDescriptor(e, l);
    Object.defineProperty(s, l, c.get ? c : {
      enumerable: !0,
      get: function() {
        return e[l];
      }
    });
  }), s;
}
var It = { exports: {} }, zr;
function Da() {
  if (zr) return It.exports;
  zr = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return It.exports = t(), It.exports.createColors = t, It.exports;
}
const ja = {}, Aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ja
}, Symbol.toStringTag, { value: "Module" })), we = /* @__PURE__ */ Ba(Aa);
var Ni, Hr;
function ks() {
  if (Hr) return Ni;
  Hr = 1;
  let e = /* @__PURE__ */ Da(), t = we;
  class s extends Error {
    constructor(c, u, f, b, m, h) {
      super(c), this.name = "CssSyntaxError", this.reason = c, m && (this.file = m), b && (this.source = b), h && (this.plugin = h), typeof u != "undefined" && typeof f != "undefined" && (typeof u == "number" ? (this.line = u, this.column = f) : (this.line = u.line, this.column = u.column, this.endLine = f.line, this.endColumn = f.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, s);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(c) {
      if (!this.source) return "";
      let u = this.source;
      c == null && (c = e.isColorSupported);
      let f = (i) => i, b = (i) => i, m = (i) => i;
      if (c) {
        let { bold: i, gray: o, red: a } = e.createColors(!0);
        b = (p) => i(a(p)), f = (p) => o(p), t && (m = (p) => t(p));
      }
      let h = u.split(/\r?\n/), d = Math.max(this.line - 3, 0), r = Math.min(this.line + 2, h.length), n = String(r).length;
      return h.slice(d, r).map((i, o) => {
        let a = d + 1 + o, p = " " + (" " + a).slice(-n) + " | ";
        if (a === this.line) {
          if (i.length > 160) {
            let Z = 20, S = Math.max(0, this.column - Z), G = Math.max(
              this.column + Z,
              this.endColumn + Z
            ), g = i.slice(S, G), y = f(p.replace(/\d/g, " ")) + i.slice(0, Math.min(this.column - 1, Z - 1)).replace(/[^\t]/g, " ");
            return b(">") + f(p) + m(g) + `
 ` + y + b("^");
          }
          let X = f(p.replace(/\d/g, " ")) + i.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return b(">") + f(p) + m(i) + `
 ` + X + b("^");
        }
        return " " + f(p) + m(i);
      }).join(`
`);
    }
    toString() {
      let c = this.showSourceCode();
      return c && (c = `

` + c + `
`), this.name + ": " + this.message + c;
    }
  }
  return Ni = s, s.default = s, Ni;
}
var Ti, Or;
function pl() {
  if (Or) return Ti;
  Or = 1;
  const e = /(<)(\/?style\b)/gi, t = /(<)(!--)/g, s = /[\t\n\f\r "#'()/;[\\\]{}]/;
  function l(d) {
    return typeof d != "string" || !d.includes("<") ? d : d.replace(e, "\\3c $2").replace(t, "\\3c $2");
  }
  const c = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function u(d) {
    return d[0].toUpperCase() + d.slice(1);
  }
  function f(d, r) {
    let n = "@" + r.name, i = r.params ? d.rawValue(r, "params") : "", o = r.raws.afterName;
    return typeof o == "undefined" ? o = i ? " " : "" : o === "" && i && !s.test(i[0]) && (o = " "), n + o + i;
  }
  function b(d, r, n) {
    let i = n.nodes, o = i.length - 1;
    for (; o > 0 && i[o].type === "comment"; )
      o -= 1;
    let a = d.raw(n, "semicolon"), p = n.type === "document";
    for (let X = i.length - 1; X >= 0; X--) {
      let Z = i[X], S = o !== X || a;
      !S && X < i.length - 1 && (Z.type === "atrule" && !Z.nodes || Z.type === "decl" && Z.prop.startsWith("--")) && (S = !0), r.push({
        document: p,
        node: Z,
        semicolon: S
      });
    }
  }
  function m(d, r, n, i) {
    let o = d.raw(n, "between", "beforeOpen");
    d.builder(l(i + o) + "{", n, "start");
    let a = n.nodes && n.nodes.length, p = () => {
      let X = a ? d.raw(n, "after") : d.raw(n, "after", "emptyBody");
      X && d.builder(l(X)), d.builder("}", n, "end"), n.type === "rule" && n.raws.ownSemicolon && d.builder(l(n.raws.ownSemicolon), n, "end");
    };
    a ? (r.push(p), b(d, r, n)) : p();
  }
  class h {
    constructor(r) {
      this.builder = r;
    }
    atrule(r, n) {
      let i = f(this, r);
      if (r.nodes)
        this.block(r, i);
      else {
        let o = (r.raws.between || "") + (n ? ";" : "");
        this.builder(l(i + o), r);
      }
    }
    beforeAfter(r, n) {
      let i;
      r.type === "decl" ? i = this.raw(r, null, "beforeDecl") : r.type === "comment" ? i = this.raw(r, null, "beforeComment") : n === "before" ? i = this.raw(r, null, "beforeRule") : i = this.raw(r, null, "beforeClose");
      let o = r.parent, a = 0;
      for (; o && o.type !== "root"; )
        a += 1, o = o.parent;
      if (i.includes(`
`)) {
        let p = this.raw(r, null, "indent");
        if (p.length)
          for (let X = 0; X < a; X++) i += p;
      }
      return i;
    }
    block(r, n) {
      let i = this.raw(r, "between", "beforeOpen");
      this.builder(l(n + i) + "{", r, "start");
      let o;
      r.nodes && r.nodes.length ? (this.body(r), o = this.raw(r, "after")) : o = this.raw(r, "after", "emptyBody"), o && this.builder(l(o)), this.builder("}", r, "end");
    }
    body(r) {
      let n = h.prototype, i = ["atrule", "block", "body", "rule", "stringify"].every(
        (a) => this[a] === n[a]
      ), o = [];
      for (b(this, o, r); o.length > 0; ) {
        let a = o.pop();
        if (typeof a == "function") {
          a();
          continue;
        }
        let p = a.node, X = this.raw(p, "before");
        X && this.builder(a.document ? X : l(X)), i && p.type === "rule" ? m(this, o, p, this.rawValue(p, "selector")) : i && p.type === "atrule" && p.nodes ? m(this, o, p, f(this, p)) : this.stringify(p, a.semicolon);
      }
    }
    comment(r) {
      let n = this.raw(r, "left", "commentLeft"), i = this.raw(r, "right", "commentRight");
      this.builder(l("/*" + n + r.text + i + "*/"), r);
    }
    decl(r, n) {
      let i = r.raws, o = this.raw(r, "between", "colon"), a = r.prop + o + this.rawValue(r, "value");
      r.important && (a += i.important || " !important"), n && (a += ";"), this.builder(l(a), r);
    }
    document(r) {
      this.body(r);
    }
    raw(r, n, i) {
      let o;
      if (i || (i = n), n && (o = r.raws[n], typeof o != "undefined"))
        return o;
      let a = r.parent;
      if (i === "before" && (!a || a.type === "root" && a.first === r || a && a.type === "document"))
        return "";
      if (!a) return c[i];
      let p = r.root(), X = p.rawCache || (p.rawCache = {});
      if (typeof X[i] != "undefined")
        return X[i];
      if (i === "before" || i === "after")
        return this.beforeAfter(r, i);
      {
        let Z = "raw" + u(i);
        this[Z] ? o = this[Z](p, r) : p.walk((S) => {
          if (o = S.raws[n], typeof o != "undefined") return !1;
        });
      }
      return typeof o == "undefined" && (o = c[i]), X[i] = o, o;
    }
    rawBeforeClose(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && i.nodes.length > 0 && typeof i.raws.after != "undefined")
          return n = i.raws.after, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
      }), n && (n = n.replace(/\S/g, "")), n;
    }
    rawBeforeComment(r, n) {
      let i;
      return r.walkComments((o) => {
        if (typeof o.raws.before != "undefined")
          return i = o.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
      }), typeof i == "undefined" ? i = this.raw(n, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
    }
    rawBeforeDecl(r, n) {
      let i;
      return r.walkDecls((o) => {
        if (typeof o.raws.before != "undefined")
          return i = o.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
      }), typeof i == "undefined" ? i = this.raw(n, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
    }
    rawBeforeOpen(r) {
      let n;
      return r.walk((i) => {
        if (i.type !== "decl" && (n = i.raws.between, typeof n != "undefined"))
          return !1;
      }), n;
    }
    rawBeforeRule(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && (i.parent !== r || r.first !== i) && typeof i.raws.before != "undefined")
          return n = i.raws.before, n.includes(`
`) && (n = n.replace(/[^\n]+$/, "")), !1;
      }), n && (n = n.replace(/\S/g, "")), n;
    }
    rawColon(r) {
      let n;
      return r.walkDecls((i) => {
        if (typeof i.raws.between != "undefined")
          return n = i.raws.between.replace(/[^\s:]/g, ""), !1;
      }), n;
    }
    rawEmptyBody(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && i.nodes.length === 0 && (n = i.raws.after, typeof n != "undefined"))
          return !1;
      }), n;
    }
    rawIndent(r) {
      if (r.raws.indent) return r.raws.indent;
      let n;
      return r.walk((i) => {
        let o = i.parent;
        if (o && o !== r && o.parent && o.parent === r && typeof i.raws.before != "undefined") {
          let a = i.raws.before.split(`
`);
          return n = a[a.length - 1], n = n.replace(/\S/g, ""), !1;
        }
      }), n;
    }
    rawSemicolon(r) {
      let n;
      return r.walk((i) => {
        if (i.nodes && i.nodes.length && i.last.type === "decl" && (n = i.raws.semicolon, typeof n != "undefined"))
          return !1;
      }), n;
    }
    rawValue(r, n) {
      let i = r[n], o = r.raws[n];
      return o && o.value === i ? o.raw : i;
    }
    root(r) {
      if (r.source && r.source.input.hasBOM && this.builder("\uFEFF", r, "start"), this.body(r), r.raws.after) {
        let n = r.raws.after, i = r.parent && r.parent.type === "document";
        this.builder(i ? n : l(n));
      }
    }
    rule(r) {
      this.block(r, this.rawValue(r, "selector")), r.raws.ownSemicolon && this.builder(l(r.raws.ownSemicolon), r, "end");
    }
    stringify(r, n) {
      if (!this[r.type])
        throw new Error(
          "Unknown AST node type " + r.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[r.type](r, n);
    }
  }
  return Ti = h, h.default = h, Ti;
}
var Ui, Pr;
function Dt() {
  if (Pr) return Ui;
  Pr = 1;
  let e = pl();
  function t(s, l) {
    new e(l).stringify(s);
  }
  return Ui = t, t.default = t, Ui;
}
var wt = {}, Er;
function jt() {
  return Er || (Er = 1, wt.isClean = Symbol("isClean"), wt.my = Symbol("my")), wt;
}
var Ki, Qr;
function At() {
  if (Qr) return Ki;
  Qr = 1;
  let e = ks(), t = pl(), s = Dt(), { isClean: l, my: c } = jt();
  function u(m, h) {
    let d = new m.constructor(), r = [[m, d, h]];
    for (; r.length > 0; ) {
      let [n, i, o] = r.pop();
      for (let a in n) {
        if (!Object.prototype.hasOwnProperty.call(n, a) || a === "proxyCache") continue;
        let p = n[a], X = typeof p;
        if (a === "parent" && X === "object")
          o && (i[a] = o);
        else if (a === "source")
          i[a] = p;
        else if (Array.isArray(p)) {
          let Z = [];
          i[a] = Z;
          for (let S of p) {
            let G = new S.constructor();
            Z.push(G), r.push([S, G, i]);
          }
        } else {
          if (X === "object" && p !== null) {
            let Z = new p.constructor();
            r.push([p, Z, void 0]), p = Z;
          }
          i[a] = p;
        }
      }
    }
    return d;
  }
  function f(m, h) {
    if (h && typeof h.offset != "undefined")
      return h.offset;
    let d = 1, r = 1, n = 0;
    for (let i = 0; i < m.length; i++) {
      if (r === h.line && d === h.column) {
        n = i;
        break;
      }
      m[i] === `
` ? (d = 1, r += 1) : d += 1;
    }
    return n;
  }
  class b {
    get proxyOf() {
      return this;
    }
    constructor(h = {}) {
      this.raws = {}, this[l] = !1, this[c] = !0;
      for (let d of Object.keys(h))
        if (d !== "__proto__")
          if (d === "nodes") {
            this.nodes = [];
            for (let r of h[d])
              typeof r.clone == "function" && r.parent ? this.append(r.clone()) : this.append(r);
          } else
            this[d] = h[d];
    }
    addToError(h) {
      if (h.postcssNode = this, h.stack && this.source && /\n\s{4}at /.test(h.stack)) {
        let d = this.source;
        h.stack = h.stack.replace(
          /\n\s{4}at /,
          `$&${d.input.from}:${d.start.line}:${d.start.column}$&`
        );
      }
      return h;
    }
    after(h) {
      return this.parent.insertAfter(this, h), this;
    }
    assign(h = {}) {
      for (let d in h)
        this[d] = h[d];
      return this;
    }
    before(h) {
      return this.parent.insertBefore(this, h), this;
    }
    cleanRaws(h) {
      delete this.raws.before, delete this.raws.after, h || delete this.raws.between;
    }
    clone(h = {}) {
      let d = u(this);
      for (let r in h)
        d[r] = h[r];
      return d;
    }
    cloneAfter(h = {}) {
      let d = this.clone(h);
      return this.parent.insertAfter(this, d), d;
    }
    cloneBefore(h = {}) {
      let d = this.clone(h);
      return this.parent.insertBefore(this, d), d;
    }
    error(h, d = {}) {
      if (this.source) {
        let { end: r, start: n } = this.rangeBy(d);
        return this.source.input.error(
          h,
          { column: n.column, line: n.line },
          { column: r.column, line: r.line },
          d
        );
      }
      return new e(h);
    }
    getProxyProcessor() {
      return {
        get(h, d) {
          return d === "proxyOf" ? h : d === "root" ? () => h.root().toProxy() : h[d];
        },
        set(h, d, r) {
          return h[d] === r || (h[d] = r, (d === "prop" || d === "value" || d === "name" || d === "params" || d === "important" || /* c8 ignore next */
          d === "text") && h.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[l] = !0;
    }
    markDirty() {
      if (this[l]) {
        this[l] = !1;
        let h = this;
        for (; h = h.parent; )
          h[l] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let h = this.parent.index(this);
      return this.parent.nodes[h + 1];
    }
    positionBy(h = {}) {
      let d = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: f(d, this.source.start)
      };
      if (h.index)
        r = this.positionInside(h.index);
      else if (h.word) {
        let i = d.slice(
          f(d, this.source.start),
          f(d, this.source.end)
        ).indexOf(h.word);
        i !== -1 && (r = this.positionInside(i));
      }
      return r;
    }
    positionInside(h) {
      let d = this.source.start.column, r = this.source.start.line, n = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = f(n, this.source.start), o = i + h;
      for (let a = i; a < o; a++)
        n[a] === `
` ? (d = 1, r += 1) : d += 1;
      return { column: d, line: r, offset: o };
    }
    prev() {
      if (!this.parent) return;
      let h = this.parent.index(this);
      return this.parent.nodes[h - 1];
    }
    rangeBy(h = {}) {
      let d = "document" in this.source.input ? this.source.input.document : this.source.input.css, r = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: f(d, this.source.start)
      }, n = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset == "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          f(d, this.source.end) + 1
        )
      } : {
        column: r.column + 1,
        line: r.line,
        offset: r.offset + 1
      };
      if (h.word) {
        let o = d.slice(
          f(d, this.source.start),
          f(d, this.source.end)
        ).indexOf(h.word);
        o !== -1 && (r = this.positionInside(o), n = this.positionInside(o + h.word.length));
      } else
        h.start ? r = {
          column: h.start.column,
          line: h.start.line,
          offset: f(d, h.start)
        } : typeof h.index == "number" && (r = this.positionInside(h.index)), h.end ? n = {
          column: h.end.column,
          line: h.end.line,
          offset: f(d, h.end)
        } : typeof h.endIndex == "number" ? n = this.positionInside(h.endIndex) : typeof h.index == "number" && (n = this.positionInside(h.index + 1));
      return (n.line < r.line || n.line === r.line && n.column <= r.column) && (n = {
        column: r.column + 1,
        line: r.line,
        offset: r.offset + 1
      }), { end: n, start: r };
    }
    raw(h, d) {
      return new t().raw(this, h, d);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...h) {
      if (this.parent) {
        let d = this, r = !1;
        for (let n of h)
          n === this ? r = !0 : r ? (this.parent.insertAfter(d, n), d = n) : this.parent.insertBefore(d, n);
        r || this.remove();
      }
      return this;
    }
    root() {
      let h = this;
      for (; h.parent && h.parent.type !== "document"; )
        h = h.parent;
      return h;
    }
    toJSON(h, d) {
      let r = d == null;
      d = d || /* @__PURE__ */ new Map();
      let n = [], i = [[this, n, 0]];
      for (let a = 0; a < i.length; a++) {
        let [p, X, Z] = i[a], S = {};
        X[Z] = S;
        for (let G in p) {
          if (!Object.prototype.hasOwnProperty.call(p, G) || G === "parent" || G === "proxyCache") continue;
          let g = p[G];
          if (Array.isArray(g)) {
            let y = [];
            S[G] = y;
            for (let R = 0; R < g.length; R++) {
              let W = g[R];
              typeof W == "object" && W.toJSON ? W.toJSON === b.prototype.toJSON ? i.push([W, y, R]) : y[R] = W.toJSON(null, d) : y[R] = W;
            }
          } else if (typeof g == "object" && g.toJSON)
            g.toJSON === b.prototype.toJSON ? i.push([g, S, G]) : S[G] = g.toJSON(null, d);
          else if (G === "source") {
            if (g == null) continue;
            let y = d.get(g.input);
            y == null && (y = d.size, d.set(g.input, y)), S[G] = {
              end: g.end,
              inputId: y,
              start: g.start
            };
          } else
            S[G] = g;
        }
      }
      let o = n[0];
      return r && (o.inputs = [...d.keys()].map((a) => a.toJSON())), o;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(h = s) {
      h.stringify && (h = h.stringify);
      let d = "";
      return h(this, (r) => {
        d += r;
      }), d;
    }
    warn(h, d, r = {}) {
      let n = { node: this };
      for (let i in r) n[i] = r[i];
      return h.warn(d, n);
    }
  }
  return Ki = b, b.default = b, Ki;
}
var Fi, Br;
function _t() {
  if (Br) return Fi;
  Br = 1;
  let e = At();
  class t extends e {
    constructor(l) {
      super(l), this.type = "comment";
    }
  }
  return Fi = t, t.default = t, Fi;
}
var Mi, Dr;
function $t() {
  if (Dr) return Mi;
  Dr = 1;
  let e = At();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(l) {
      l && typeof l.value != "undefined" && typeof l.value != "string" && (l = he(K({}, l), { value: String(l.value) })), super(l), this.type = "decl";
    }
  }
  return Mi = t, t.default = t, Mi;
}
var zi, jr;
function He() {
  if (jr) return zi;
  jr = 1;
  let e = _t(), t = $t(), s = At(), { isClean: l, my: c } = jt(), u, f, b, m;
  function h(n) {
    let i = n.slice();
    for (; i.length > 0; ) {
      let o = i.pop();
      if (delete o.source, o.nodes) {
        o.nodes = o.nodes.slice();
        for (let a of o.nodes) i.push(a);
      }
    }
    return n.slice();
  }
  function d(n) {
    let i = [n];
    for (; i.length > 0; ) {
      let o = i.pop();
      if (o[l] = !1, o.proxyOf.nodes)
        for (let a of o.proxyOf.nodes) i.push(a);
    }
  }
  class r extends s {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...i) {
      for (let o of i) {
        let a = this.normalize(o, this.last);
        for (let p of a) this.proxyOf.nodes.push(p);
      }
      return this.markDirty(), this;
    }
    cleanRaws(i) {
      let o = [this];
      for (; o.length > 0; ) {
        let a = o.pop();
        if (a !== this && a.cleanRaws !== r.prototype.cleanRaws) {
          a.cleanRaws(i);
          continue;
        }
        if (s.prototype.cleanRaws.call(a, i), a.nodes)
          for (let p of a.nodes) o.push(p);
      }
    }
    each(i) {
      if (!this.proxyOf.nodes) return;
      let o = this.getIterator(), a, p;
      for (; this.indexes[o] < this.proxyOf.nodes.length && (a = this.indexes[o], p = i(this.proxyOf.nodes[a], a), p !== !1); )
        this.indexes[o] += 1;
      return delete this.indexes[o], p;
    }
    every(i) {
      return this.nodes.every(i);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let i = this.lastEach;
      return this.indexes[i] = 0, i;
    }
    getProxyProcessor() {
      return {
        get(i, o) {
          return o === "proxyOf" ? i : i[o] ? o === "each" || typeof o == "string" && o.startsWith("walk") ? (...a) => i[o](
            ...a.map((p) => typeof p == "function" ? (X, Z) => p(X.toProxy(), Z) : p)
          ) : o === "every" || o === "some" ? (a) => i[o](
            (p, ...X) => a(p.toProxy(), ...X)
          ) : o === "root" ? () => i.root().toProxy() : o === "nodes" ? i.nodes.map((a) => a.toProxy()) : o === "first" || o === "last" ? i[o].toProxy() : i[o] : i[o];
        },
        set(i, o, a) {
          return i[o] === a || (i[o] = a, (o === "name" || o === "params" || o === "selector") && i.markDirty()), !0;
        }
      };
    }
    index(i) {
      return typeof i == "number" ? i : (i.proxyOf && (i = i.proxyOf), this.proxyOf.nodes.indexOf(i));
    }
    insertAfter(i, o) {
      let a = this.index(i), p = this.normalize(o, this.proxyOf.nodes[a]).reverse();
      a = this.index(i);
      for (let Z of p) this.proxyOf.nodes.splice(a + 1, 0, Z);
      let X;
      for (let Z in this.indexes)
        X = this.indexes[Z], a < X && (this.indexes[Z] = X + p.length);
      return this.markDirty(), this;
    }
    insertBefore(i, o) {
      let a = this.index(i), p = a === 0 ? "prepend" : !1, X = this.normalize(
        o,
        this.proxyOf.nodes[a],
        p
      ).reverse();
      a = this.index(i);
      for (let S of X) this.proxyOf.nodes.splice(a, 0, S);
      let Z;
      for (let S in this.indexes)
        Z = this.indexes[S], a <= Z && (this.indexes[S] = Z + X.length);
      return this.markDirty(), this;
    }
    normalize(i, o) {
      if (typeof i == "string")
        i = h(f(i).nodes);
      else if (typeof i == "undefined")
        i = [];
      else if (Array.isArray(i)) {
        i = i.slice(0);
        for (let p of i)
          p.parent && p.parent.removeChild(p, "ignore");
      } else if (i.type === "root" && this.type !== "document") {
        i = i.nodes.slice(0);
        for (let p of i)
          p.parent && p.parent.removeChild(p, "ignore");
      } else if (i.type)
        i = [i];
      else if (i.prop) {
        if (typeof i.value == "undefined")
          throw new Error("Value field is missed in node creation");
        typeof i.value != "string" && (i.value = String(i.value)), i = [new t(i)];
      } else if (i.selector || i.selectors)
        i = [new m(i)];
      else if (i.name)
        i = [new u(i)];
      else if (i.text)
        i = [new e(i)];
      else
        throw new Error("Unknown node type in node creation");
      return i.map((p) => (p[c] || r.rebuild(p), p = p.proxyOf, p.parent && p.parent.removeChild(p), p[l] && d(p), p.raws || (p.raws = {}), typeof p.raws.before == "undefined" && o && typeof o.raws.before != "undefined" && (p.raws.before = o.raws.before.replace(/\S/g, "")), p.parent = this.proxyOf, p));
    }
    prepend(...i) {
      i = i.reverse();
      for (let o of i) {
        let a = this.normalize(o, this.first, "prepend").reverse();
        for (let p of a) this.proxyOf.nodes.unshift(p);
        for (let p in this.indexes)
          this.indexes[p] = this.indexes[p] + a.length;
      }
      return this.markDirty(), this;
    }
    push(i) {
      return i.parent = this, this.proxyOf.nodes.push(i), this;
    }
    removeAll() {
      for (let i of this.proxyOf.nodes) i.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(i) {
      i = this.index(i), this.proxyOf.nodes[i].parent = void 0, this.proxyOf.nodes.splice(i, 1);
      let o;
      for (let a in this.indexes)
        o = this.indexes[a], o >= i && (this.indexes[a] = o - 1);
      return this.markDirty(), this;
    }
    replaceValues(i, o, a) {
      return a || (a = o, o = {}), this.walkDecls((p) => {
        o.props && !o.props.includes(p.prop) || o.fast && !p.value.includes(o.fast) || (p.value = p.value.replace(i, a));
      }), this.markDirty(), this;
    }
    some(i) {
      return this.nodes.some(i);
    }
    walk(i) {
      if (!this.proxyOf.nodes) return;
      let o = [{ iterator: this.getIterator(), node: this.proxyOf }];
      for (; o.length > 0; ) {
        let { iterator: a, node: p } = o[o.length - 1], X = p.indexes[a];
        if (X >= p.proxyOf.nodes.length) {
          delete p.indexes[a], o.pop();
          let G = o[o.length - 1];
          G && (G.node.indexes[G.iterator] += 1);
          continue;
        }
        let Z = p.proxyOf.nodes[X], S;
        try {
          S = i(Z, X);
        } catch (G) {
          throw Z.addToError(G);
        }
        if (S === !1) {
          for (let G of o)
            delete G.node.indexes[G.iterator];
          return !1;
        }
        Z.walk && Z.proxyOf.nodes ? o.push({ iterator: Z.getIterator(), node: Z }) : p.indexes[a] += 1;
      }
    }
    walkAtRules(i, o) {
      return o ? i instanceof RegExp ? this.walk((a, p) => {
        if (a.type === "atrule" && i.test(a.name))
          return o(a, p);
      }) : this.walk((a, p) => {
        if (a.type === "atrule" && a.name === i)
          return o(a, p);
      }) : (o = i, this.walk((a, p) => {
        if (a.type === "atrule")
          return o(a, p);
      }));
    }
    walkComments(i) {
      return this.walk((o, a) => {
        if (o.type === "comment")
          return i(o, a);
      });
    }
    walkDecls(i, o) {
      return o ? i instanceof RegExp ? this.walk((a, p) => {
        if (a.type === "decl" && i.test(a.prop))
          return o(a, p);
      }) : this.walk((a, p) => {
        if (a.type === "decl" && a.prop === i)
          return o(a, p);
      }) : (o = i, this.walk((a, p) => {
        if (a.type === "decl")
          return o(a, p);
      }));
    }
    walkRules(i, o) {
      return o ? i instanceof RegExp ? this.walk((a, p) => {
        if (a.type === "rule" && i.test(a.selector))
          return o(a, p);
      }) : this.walk((a, p) => {
        if (a.type === "rule" && a.selector === i)
          return o(a, p);
      }) : (o = i, this.walk((a, p) => {
        if (a.type === "rule")
          return o(a, p);
      }));
    }
  }
  return r.registerParse = (n) => {
    f = n;
  }, r.registerRule = (n) => {
    m = n;
  }, r.registerAtRule = (n) => {
    u = n;
  }, r.registerRoot = (n) => {
    b = n;
  }, zi = r, r.default = r, r.rebuild = (n) => {
    let i = [n];
    for (; i.length > 0; ) {
      let o = i.pop();
      if (o.type === "atrule" ? Object.setPrototypeOf(o, u.prototype) : o.type === "rule" ? Object.setPrototypeOf(o, m.prototype) : o.type === "decl" ? Object.setPrototypeOf(o, t.prototype) : o.type === "comment" ? Object.setPrototypeOf(o, e.prototype) : o.type === "root" && Object.setPrototypeOf(o, b.prototype), o[c] = !0, o.nodes)
        for (let a of o.nodes) i.push(a);
    }
  }, zi;
}
var Hi, Ar;
function Js() {
  if (Ar) return Hi;
  Ar = 1;
  let e = He();
  class t extends e {
    constructor(l) {
      super(l), this.type = "atrule";
    }
    append(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...l);
    }
    prepend(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...l);
    }
  }
  return Hi = t, t.default = t, e.registerAtRule(t), Hi;
}
var Oi, _r;
function Ys() {
  if (_r) return Oi;
  _r = 1;
  let e = He(), t, s;
  class l extends e {
    constructor(u) {
      super(K({ type: "document" }, u)), this.nodes || (this.nodes = []);
    }
    toResult(u = {}) {
      return new t(new s(), this, u).stringify();
    }
  }
  return l.registerLazyResult = (c) => {
    t = c;
  }, l.registerProcessor = (c) => {
    s = c;
  }, Oi = l, l.default = l, Oi;
}
var Pi, $r;
function _a() {
  if ($r) return Pi;
  $r = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return Pi = { nanoid: (l = 21) => {
    let c = "", u = l | 0;
    for (; u-- > 0; )
      c += e[Math.random() * 64 | 0];
    return c;
  }, customAlphabet: (l, c = 21) => (u = c) => {
    let f = "", b = u | 0;
    for (; b-- > 0; )
      f += l[Math.random() * l.length | 0];
    return f;
  } }, Pi;
}
var Ei, qr;
function ml() {
  if (qr) return Ei;
  qr = 1;
  let { existsSync: e, readFileSync: t, realpathSync: s } = we, { dirname: l, isAbsolute: c, join: u, relative: f, sep: b } = we, { SourceMapConsumer: m, SourceMapGenerator: h } = we;
  function d(i) {
    try {
      return s(i);
    } catch (o) {
      return i;
    }
  }
  function r(i) {
    return Buffer ? Buffer.from(i, "base64").toString() : window.atob(i);
  }
  class n {
    constructor(o, a) {
      if (a.map === !1) return;
      a.unsafeMap && (this.unsafeMap = !0), this.loadAnnotation(o), this.inline = this.startWith(this.annotation, "data:");
      let p = a.map ? a.map.prev : void 0, X = this.loadMap(a.from, p);
      !this.mapFile && a.from && (this.mapFile = a.from), this.mapFile && (this.root = l(this.mapFile)), X && (this.text = X);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new m(this.json || this.text)), this.consumerCache;
    }
    decodeInline(o) {
      let a = /^data:application\/json;charset=utf-?8;base64,/, p = /^data:application\/json;base64,/, X = /^data:application\/json;charset=utf-?8,/, Z = /^data:application\/json,/, S = o.match(X) || o.match(Z);
      if (S)
        return decodeURIComponent(o.substr(S[0].length));
      let G = o.match(a) || o.match(p);
      if (G)
        return r(o.substr(G[0].length));
      let g = o.slice(22);
      throw g = g.slice(0, g.indexOf(",")), new Error("Unsupported source map encoding " + g);
    }
    getAnnotationURL(o) {
      return o.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(o) {
      return typeof o != "object" ? !1 : typeof o.mappings == "string" || typeof o._mappings == "string" || Array.isArray(o.sections);
    }
    loadAnnotation(o) {
      let a = o.match(/\/\*\s*# sourceMappingURL=/g);
      if (!a) return;
      let p = o.lastIndexOf(a.pop()), X = o.indexOf("*/", p);
      p > -1 && X > -1 && (this.annotation = this.getAnnotationURL(o.substring(p, X)));
    }
    loadFile(o, a, p) {
      if (!p && !this.unsafeMap) {
        if (!/\.map$/i.test(o) || !a) return;
        let X = f(d(l(a)), d(o));
        if (X === ".." || X.startsWith(".." + b) || c(X))
          return;
      }
      if (this.root = l(o), e(o))
        return this.mapFile = o, t(o, "utf-8").toString().trim();
    }
    loadMap(o, a) {
      if (a === !1) return !1;
      if (a) {
        if (typeof a == "string")
          return a;
        if (typeof a == "function") {
          let p = a(o);
          if (p) {
            let X = this.loadFile(p, o, !0);
            if (!X)
              throw new Error(
                "Unable to load previous source map: " + p.toString()
              );
            return X;
          }
        } else {
          if (a instanceof m)
            return h.fromSourceMap(a).toString();
          if (a instanceof h)
            return a.toString();
          if (this.isMap(a))
            return JSON.stringify(a);
          throw new Error(
            "Unsupported previous source map format: " + a.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let p = this.annotation;
          o && (p = u(l(o), p));
          let X = this.loadFile(p, o, !1);
          if (X)
            try {
              this.json = JSON.parse(X.replace(/^\)]}'[^\n]*\n/, ""));
            } catch (Z) {
              return;
            }
          return X;
        }
      }
    }
    startWith(o, a) {
      return o ? o.substr(0, a.length) === a : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Ei = n, n.default = n, Ei;
}
var Qi, en;
function qt() {
  if (en) return Qi;
  en = 1;
  let { nanoid: e } = /* @__PURE__ */ _a(), { isAbsolute: t, resolve: s } = we, { SourceMapConsumer: l, SourceMapGenerator: c } = we, { fileURLToPath: u, pathToFileURL: f } = we, b = ks(), m = ml(), h = we, d = Symbol("lineToIndexCache"), r = !!(l && c), n = !!(s && t);
  function i(a) {
    if (a[d]) return a[d];
    let p = a.css.split(`
`), X = new Array(p.length), Z = 0;
    for (let S = 0, G = p.length; S < G; S++)
      X[S] = Z, Z += p[S].length + 1;
    return a[d] = X, X;
  }
  class o {
    get from() {
      return this.file || this.id;
    }
    constructor(p, X = {}) {
      if (p === null || typeof p == "undefined" || typeof p == "object" && !p.toString)
        throw new Error(`PostCSS received ${p} instead of CSS string`);
      if (this.css = p.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, X.document && (this.document = X.document.toString()), X.from && (!n || /^\w+:\/\//.test(X.from) || t(X.from) ? this.file = X.from : this.file = s(X.from)), n && r) {
        let Z = new m(this.css, X);
        if (Z.text) {
          this.map = Z;
          let S = Z.consumer().file;
          !this.file && S && (this.file = this.mapResolve(S));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(p, X, Z, S = {}) {
      let G, g, y, R, W;
      if (X && typeof X == "object") {
        let I = X, v = Z;
        if (typeof I.offset == "number") {
          R = I.offset;
          let x = this.fromOffset(R);
          X = x.line, Z = x.col;
        } else
          X = I.line, Z = I.column, R = this.fromLineAndColumn(X, Z);
        if (typeof v.offset == "number") {
          y = v.offset;
          let x = this.fromOffset(y);
          g = x.line, G = x.col;
        } else
          g = v.line, G = v.column, y = this.fromLineAndColumn(v.line, v.column);
      } else if (Z)
        R = this.fromLineAndColumn(X, Z);
      else {
        R = X;
        let I = this.fromOffset(R);
        X = I.line, Z = I.col;
      }
      let V = this.origin(X, Z, g, G);
      return V ? W = new b(
        p,
        V.endLine === void 0 ? V.line : { column: V.column, line: V.line },
        V.endLine === void 0 ? V.column : { column: V.endColumn, line: V.endLine },
        V.source,
        V.file,
        S.plugin
      ) : W = new b(
        p,
        g === void 0 ? X : { column: Z, line: X },
        g === void 0 ? Z : { column: G, line: g },
        this.css,
        this.file,
        S.plugin
      ), W.input = {
        column: Z,
        endColumn: G,
        endLine: g,
        endOffset: y,
        line: X,
        offset: R,
        source: this.css
      }, this.file && (f && (W.input.url = f(this.file).toString()), W.input.file = this.file), W;
    }
    fromLineAndColumn(p, X) {
      return i(this)[p - 1] + X - 1;
    }
    fromOffset(p) {
      let X = i(this), Z = X[X.length - 1], S = 0;
      if (p >= Z)
        S = X.length - 1;
      else {
        let G = X.length - 2, g;
        for (; S < G; )
          if (g = S + (G - S >> 1), p < X[g])
            G = g - 1;
          else if (p >= X[g + 1])
            S = g + 1;
          else {
            S = g;
            break;
          }
      }
      return {
        col: p - X[S] + 1,
        line: S + 1
      };
    }
    mapResolve(p) {
      return /^\w+:\/\//.test(p) ? p : s(this.map.consumer().sourceRoot || this.map.root || ".", p);
    }
    origin(p, X, Z, S) {
      if (!this.map) return !1;
      let G = this.map.consumer(), g = G.originalPositionFor({ column: X - 1, line: p });
      if (!g.source) return !1;
      let y;
      if (typeof Z == "number") {
        let I = G.originalPositionFor({
          column: S - 1,
          line: Z
        });
        I.source && (y = I);
      }
      let R;
      t(g.source) ? R = f(g.source) : R = new URL(
        g.source,
        this.map.consumer().sourceRoot || f(this.map.mapFile)
      );
      let W = {
        column: g.column + 1,
        endColumn: y && y.column + 1,
        endLine: y && y.line,
        line: g.line,
        url: R.toString()
      };
      if (R.protocol === "file:")
        if (u)
          W.file = u(R);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let V = G.sourceContentFor(g.source);
      return V && (W.source = V), W;
    }
    toJSON() {
      let p = {};
      for (let X of ["hasBOM", "css", "file", "id"])
        this[X] != null && (p[X] = this[X]);
      return this.map && (p.map = K({}, this.map), p.map.consumerCache && (p.map.consumerCache = void 0)), p;
    }
  }
  return Qi = o, o.default = o, h && h.registerInput && h.registerInput(o), Qi;
}
var Bi, tn;
function yt() {
  if (tn) return Bi;
  tn = 1;
  let e = He(), t, s;
  class l extends e {
    constructor(u) {
      super(u), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(u, f, b) {
      let m = /* @__PURE__ */ new Set();
      for (let d of Array.isArray(u) ? u : [u])
        d && typeof d == "object" && !d.parent && d.raws && typeof d.raws.before != "undefined" && m.add(d.raws);
      let h = super.normalize(u);
      if (f) {
        if (b === "prepend")
          this.nodes.length > 1 ? f.raws.before = this.nodes[1].raws.before : delete f.raws.before;
        else if (this.first !== f)
          for (let d of h)
            m.has(d.raws) || (d.raws.before = f.raws.before);
      }
      return h;
    }
    removeChild(u, f) {
      let b = this.index(u);
      return !f && b === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[b].raws.before), super.removeChild(u);
    }
    toResult(u = {}) {
      return new t(new s(), this, u).stringify();
    }
  }
  return l.registerLazyResult = (c) => {
    t = c;
  }, l.registerProcessor = (c) => {
    s = c;
  }, Bi = l, l.default = l, e.registerRoot(l), Bi;
}
var Di, sn;
function fl() {
  if (sn) return Di;
  sn = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let s = [" ", `
`, "	"];
      return e.split(t, s);
    },
    split(t, s, l) {
      if (typeof t != "string") return [];
      let c = [], u = "", f = !1, b = 0, m = !1, h = "", d = !1;
      for (let r of t)
        d ? d = !1 : r === "\\" ? d = !0 : m ? r === h && (m = !1) : r === '"' || r === "'" ? (m = !0, h = r) : r === "(" ? b += 1 : r === ")" ? b > 0 && (b -= 1) : b === 0 && s.includes(r) && (f = !0), f ? (u !== "" && c.push(u.trim()), u = "", f = !1) : u += r;
      return (l || u !== "") && c.push(u.trim()), c;
    }
  };
  return Di = e, e.default = e, Di;
}
var ji, rn;
function Ns() {
  if (rn) return ji;
  rn = 1;
  let e = He(), t = fl();
  class s extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(c) {
      let u = this.selector ? this.selector.match(/,\s*/) : null, f = u ? u[0] : "," + this.raw("between", "beforeOpen");
      this.selector = c.join(f);
    }
    constructor(c) {
      super(c), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return ji = s, s.default = s, e.registerRule(s), ji;
}
var Ai, nn;
function $a() {
  if (nn) return Ai;
  nn = 1;
  let e = Js(), t = _t(), s = $t(), l = qt(), c = ml(), u = yt(), f = Ns();
  function b(d, r) {
    return d.inputs ? d.inputs.map((n) => {
      let i = he(K({}, n), { __proto__: l.prototype });
      return i.map && (i.map = he(K({}, i.map), {
        __proto__: c.prototype
      })), i;
    }) : r;
  }
  function m(d, r, n) {
    let i = K({}, d);
    if (delete i.inputs, delete i.nodes, i.source) {
      let a = i.source, { inputId: p } = a, X = it(a, ["inputId"]);
      i.source = X, p != null && (i.source.input = r[p]);
    }
    let o;
    if (i.type === "root")
      o = new u(i);
    else if (i.type === "decl")
      o = new s(i);
    else if (i.type === "rule")
      o = new f(i);
    else if (i.type === "comment")
      o = new t(i);
    else if (i.type === "atrule")
      o = new e(i);
    else
      throw new Error("Unknown node type: " + d.type);
    if (n) {
      o.nodes = n;
      for (let p of n) p.parent = o;
    }
    return o;
  }
  function h(d, r) {
    if (Array.isArray(d)) return d.map((o) => h(o));
    let n, i = [
      { childIndex: 0, children: [], inputs: b(d, r), json: d }
    ];
    for (; i.length > 0; ) {
      let o = i[i.length - 1], a = o.json.nodes;
      if (a && o.childIndex < a.length) {
        let X = a[o.childIndex];
        o.childIndex += 1, i.push({
          childIndex: 0,
          children: [],
          inputs: b(X, o.inputs),
          json: X
        });
        continue;
      }
      i.pop();
      let p = m(
        o.json,
        o.inputs,
        a ? o.children : void 0
      );
      i.length > 0 ? i[i.length - 1].children.push(p) : n = p;
    }
    return n;
  }
  return Ai = h, h.default = h, Ai;
}
var _i, ln;
function bl() {
  if (ln) return _i;
  ln = 1;
  let { dirname: e, relative: t, resolve: s, sep: l } = we, { SourceMapConsumer: c, SourceMapGenerator: u } = we, { pathToFileURL: f } = we, b = qt(), m = !!(c && u), h = !!(e && s && t && l);
  class d {
    constructor(n, i, o, a) {
      this.stringify = n, this.mapOpts = o.map || {}, this.root = i, this.opts = o, this.css = a, this.originalCSS = a, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let n;
      this.isInline() ? n = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? n = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? n = this.mapOpts.annotation(this.opts.to, this.root) : n = this.outputFile() + ".map";
      let i = `
`;
      this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + n + " */";
    }
    applyPrevMaps() {
      for (let n of this.previous()) {
        let i = this.toUrl(this.path(n.file)), o = n.root || e(n.file), a;
        this.mapOpts.sourcesContent === !1 ? (a = new c(n.text), a.sourcesContent && (a.sourcesContent = null)) : a = n.consumer(), this.map.applySourceMap(a, i, this.toUrl(this.path(o)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1) {
        if (this.root) {
          let n;
          for (let i = this.root.nodes.length - 1; i >= 0; i--)
            n = this.root.nodes[i], n.type === "comment" && n.text.startsWith("# sourceMappingURL=") && this.root.removeChild(i);
        } else if (this.css) {
          let n;
          for (; (n = this.css.lastIndexOf("/*#")) !== -1; ) {
            let i = this.css.indexOf("*/", n + 3);
            if (i === -1) break;
            for (; n > 0 && this.css[n - 1] === `
`; )
              n--;
            this.css = this.css.slice(0, n) + this.css.slice(i + 2);
          }
        }
      }
    }
    generate() {
      if (this.clearAnnotation(), h && m && this.isMap())
        return this.generateMap();
      {
        let n = "";
        return this.stringify(this.root, (i) => {
          n += i;
        }), [n];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let n = this.previous()[0].consumer();
        n.file = this.outputFile(), this.map = u.fromSourceMap(n, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new u({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new u({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let n = 1, i = 1, o = "<no source>", a = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, p, X;
      this.stringify(this.root, (Z, S, G) => {
        if (this.css += Z, S && G !== "end" && (a.generated.line = n, a.generated.column = i - 1, S.source && S.source.start ? (a.source = this.sourcePath(S), a.original.line = S.source.start.line, a.original.column = S.source.start.column - 1, this.map.addMapping(a)) : (a.source = o, a.original.line = 1, a.original.column = 0, this.map.addMapping(a))), X = Z.match(/\n/g), X ? (n += X.length, p = Z.lastIndexOf(`
`), i = Z.length - p) : i += Z.length, S && G !== "start") {
          let g = S.parent || { raws: {} };
          (!(S.type === "decl" || S.type === "atrule" && !S.nodes) || S !== g.last || g.raws.semicolon) && (S.source && S.source.end ? (a.source = this.sourcePath(S), a.original.line = S.source.end.line, a.original.column = S.source.end.column - 1, a.generated.line = n, a.generated.column = i - 2, this.map.addMapping(a)) : (a.source = o, a.original.line = 1, a.original.column = 0, a.generated.line = n, a.generated.column = i - 1, this.map.addMapping(a)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((n) => n.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline != "undefined")
        return this.mapOpts.inline;
      let n = this.mapOpts.annotation;
      return typeof n != "undefined" && n !== !0 ? !1 : this.previous().length ? this.previous().some((i) => i.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((n) => n.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(n) {
      if (this.mapOpts.absolute || n.charCodeAt(0) === 60 || /^\w+:\/\//.test(n)) return n;
      let i = this.memoizedPaths.get(n);
      if (i) return i;
      let o = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (o = e(s(o, this.mapOpts.annotation)));
      let a = t(o, n);
      return this.memoizedPaths.set(n, a), a;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((n) => {
            if (n.source && n.source.input.map) {
              let i = n.source.input.map;
              this.previousMaps.includes(i) || this.previousMaps.push(i);
            }
          });
        else {
          let n = new b(this.originalCSS, this.opts);
          n.map && this.previousMaps.push(n.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let n = {};
      if (this.root)
        this.root.walk((i) => {
          if (i.source) {
            let o = i.source.input.from;
            if (o && !n[o]) {
              n[o] = !0;
              let a = this.usesFileUrls ? this.toFileUrl(o) : this.toUrl(this.path(o));
              this.map.setSourceContent(a, i.source.input.css);
            }
          }
        });
      else if (this.css) {
        let i = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(i, this.css);
      }
    }
    sourcePath(n) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(n.source.input.from) : this.toUrl(this.path(n.source.input.from));
    }
    toBase64(n) {
      return Buffer ? Buffer.from(n).toString("base64") : window.btoa(unescape(encodeURIComponent(n)));
    }
    toFileUrl(n) {
      let i = this.memoizedFileURLs.get(n);
      if (i) return i;
      if (f) {
        let o = f(n).toString();
        return this.memoizedFileURLs.set(n, o), o;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(n) {
      let i = this.memoizedURLs.get(n);
      if (i) return i;
      l === "\\" && (n = n.replace(/\\/g, "/"));
      let o = encodeURI(n).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(n, o), o;
    }
  }
  return _i = d, _i;
}
var $i, on;
function qa() {
  if (on) return $i;
  on = 1;
  const e = 39, t = 34, s = 92, l = 47, c = 10, u = 32, f = 12, b = 9, m = 13, h = 91, d = 93, r = 40, n = 41, i = 123, o = 125, a = 59, p = 42, X = 58, Z = 64, S = /[\t\n\f\r "#'()/;[\\\]{}]/g, G = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, g = /.[\r\n"'(/\\]/, y = /[\da-f]/i;
  return $i = function(W, V = {}) {
    let I = W.css.valueOf(), v = V.ignoreErrors, x, P, O, w, q, J, F, _, M, Q, ne = I.length, C = 0, se = [], k = [], N = -1;
    function Y() {
      return C;
    }
    function T(U) {
      throw W.error("Unclosed " + U, C);
    }
    function H() {
      return k.length === 0 && C >= ne;
    }
    function B(U) {
      if (k.length) return k.pop();
      if (C >= ne) return;
      let D = U ? U.ignoreUnclosed : !1;
      switch (x = I.charCodeAt(C), x) {
        case c:
        case u:
        case b:
        case m:
        case f: {
          w = C;
          do
            w += 1, x = I.charCodeAt(w);
          while (x === u || x === c || x === b || x === m || x === f);
          J = ["space", I.slice(C, w)], C = w - 1;
          break;
        }
        case h:
        case d:
        case i:
        case o:
        case X:
        case a:
        case n: {
          let ue = String.fromCharCode(x);
          J = [ue, ue, C];
          break;
        }
        case r: {
          if (Q = se.length ? se.pop()[1] : "", M = I.charCodeAt(C + 1), Q === "url" && M !== e && M !== t && M !== u && M !== c && M !== b && M !== f && M !== m) {
            w = C;
            do {
              if (F = !1, w = I.indexOf(")", w + 1), w === -1)
                if (v || D) {
                  w = C;
                  break;
                } else
                  T("bracket");
              for (_ = w; I.charCodeAt(_ - 1) === s; )
                _ -= 1, F = !F;
            } while (F);
            J = ["brackets", I.slice(C, w + 1), C, w], C = w;
          } else C <= N ? J = ["(", "(", C] : (w = I.indexOf(")", C + 1), P = I.slice(C, w + 1), w === -1 || g.test(P) ? (N = w === -1 ? ne : w, J = ["(", "(", C]) : (J = ["brackets", P, C, w], C = w));
          break;
        }
        case e:
        case t: {
          q = x === e ? "'" : '"', w = C;
          do {
            if (F = !1, w = I.indexOf(q, w + 1), w === -1)
              if (v || D) {
                w = C + 1;
                break;
              } else
                T("string");
            for (_ = w; I.charCodeAt(_ - 1) === s; )
              _ -= 1, F = !F;
          } while (F);
          J = ["string", I.slice(C, w + 1), C, w], C = w;
          break;
        }
        case Z: {
          S.lastIndex = C + 1, S.test(I), S.lastIndex === 0 ? w = I.length - 1 : w = S.lastIndex - 2, J = ["at-word", I.slice(C, w + 1), C, w], C = w;
          break;
        }
        case s: {
          for (w = C, O = !0; I.charCodeAt(w + 1) === s; )
            w += 1, O = !O;
          if (x = I.charCodeAt(w + 1), O && x !== l && x !== u && x !== c && x !== b && x !== m && x !== f && (w += 1, y.test(I.charAt(w)))) {
            for (; y.test(I.charAt(w + 1)); )
              w += 1;
            I.charCodeAt(w + 1) === u && (w += 1);
          }
          J = ["word", I.slice(C, w + 1), C, w], C = w;
          break;
        }
        default: {
          x === l && I.charCodeAt(C + 1) === p ? (w = I.indexOf("*/", C + 2) + 1, w === 0 && (v || D ? w = I.length : T("comment")), J = ["comment", I.slice(C, w + 1), C, w], C = w) : (G.lastIndex = C + 1, G.test(I), G.lastIndex === 0 ? w = I.length - 1 : w = G.lastIndex - 2, J = ["word", I.slice(C, w + 1), C, w], se.push(J), C = w);
          break;
        }
      }
      return C++, J;
    }
    function ee(U) {
      k.push(U);
    }
    return {
      back: ee,
      endOfFile: H,
      nextToken: B,
      position: Y
    };
  }, $i;
}
var qi, an;
function ec() {
  if (an) return qi;
  an = 1;
  let e = Js(), t = _t(), s = $t(), l = yt(), c = Ns(), u = qa();
  const f = {
    empty: !0,
    space: !0
  };
  function b(d) {
    for (let r = d.length - 1; r >= 0; r--) {
      let n = d[r], i = n[3] || n[2];
      if (i) return i;
    }
  }
  function m(d, r, n) {
    let i = "";
    for (let o = r; o < n; o++) i += d[o][1];
    return i;
  }
  class h {
    constructor(r) {
      this.input = r, this.root = new l(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: r, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(r) {
      let n = new e();
      n.name = r[1].slice(1), n.name === "" && this.unnamedAtrule(n, r), this.init(n, r[2]);
      let i, o, a, p = !1, X = !1, Z = [], S = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (r = this.tokenizer.nextToken(), i = r[0], i === "(" || i === "[" ? S.push(i === "(" ? ")" : "]") : i === "{" && S.length > 0 ? S.push("}") : i === S[S.length - 1] && S.pop(), S.length === 0)
          if (i === ";") {
            n.source.end = this.getPosition(r[2]), n.source.end.offset++, this.semicolon = !0;
            break;
          } else if (i === "{") {
            X = !0;
            break;
          } else if (i === "}") {
            if (Z.length > 0) {
              for (a = Z.length - 1, o = Z[a]; o && o[0] === "space"; )
                o = Z[--a];
              o && (n.source.end = this.getPosition(o[3] || o[2]), n.source.end.offset++);
            }
            this.end(r);
            break;
          } else
            Z.push(r);
        else
          Z.push(r);
        if (this.tokenizer.endOfFile()) {
          p = !0;
          break;
        }
      }
      n.raws.between = this.spacesAndCommentsFromEnd(Z), Z.length ? (n.raws.afterName = this.spacesAndCommentsFromStart(Z), this.raw(n, "params", Z), p && (r = Z[Z.length - 1], n.source.end = this.getPosition(r[3] || r[2]), n.source.end.offset++, this.spaces = n.raws.between, n.raws.between = "")) : (n.raws.afterName = "", n.params = ""), X && (n.nodes = [], this.current = n);
    }
    checkMissedSemicolon(r) {
      let n = this.colon(r);
      if (n === !1) return;
      let i = 0, o;
      for (let a = n - 1; a >= 0 && (o = r[a], !(o[0] !== "space" && (i += 1, i === 2))); a--)
        ;
      throw this.input.error(
        "Missed semicolon",
        o[0] === "word" ? o[3] + 1 : o[2]
      );
    }
    colon(r) {
      let n = 0, i, o, a;
      for (let [p, X] of r.entries()) {
        if (o = X, a = o[0], a === "(" && (n += 1), a === ")" && (n -= 1), n === 0 && a === ":")
          if (!i)
            this.doubleColon(o);
          else {
            if (i[0] === "word" && i[1] === "progid")
              continue;
            return p;
          }
        i = o;
      }
      return !1;
    }
    comment(r) {
      let n = new t();
      this.init(n, r[2]), n.source.end = this.getPosition(r[3] || r[2]), n.source.end.offset++;
      let i = r[1].slice(2, -2);
      if (!i.trim())
        n.text = "", n.raws.left = i, n.raws.right = "";
      else {
        let o = i.match(/^(\s*)([^]*\S)(\s*)$/);
        n.text = o[2], n.raws.left = o[1], n.raws.right = o[3];
      }
    }
    createTokenizer() {
      this.tokenizer = u(this.input);
    }
    decl(r, n) {
      let i = new s();
      this.init(i, r[0][2]);
      let o = r[r.length - 1];
      o[0] === ";" && (this.semicolon = !0, r.pop()), i.source.end = this.getPosition(
        o[3] || o[2] || b(r)
      ), i.source.end.offset++;
      let a = 0;
      for (; r[a][0] !== "word"; )
        a === r.length - 1 && this.unknownWord([r[a]]), a++;
      i.raws.before += m(r, 0, a), i.source.start = this.getPosition(r[a][2]);
      let p = a;
      for (; a < r.length; ) {
        let y = r[a][0];
        if (y === ":" || y === "space" || y === "comment")
          break;
        a++;
      }
      i.prop = m(r, p, a);
      let X = a, Z;
      for (; a < r.length && (Z = r[a], a++, Z[0] !== ":"); )
        Z[0] === "word" && /\w/.test(Z[1]) && this.unknownWord([Z]);
      i.raws.between = m(r, X, a), (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
      let S = a;
      for (; a < r.length; ) {
        let y = r[a][0];
        if (y !== "space" && y !== "comment") break;
        a++;
      }
      let G = r.slice(S, a);
      r = r.slice(a), this.precheckMissedSemicolon(r);
      for (let y = r.length - 1; y >= 0; y--) {
        if (Z = r[y], Z[1].toLowerCase() === "!important") {
          i.important = !0;
          let R = this.stringFrom(r, y);
          R = this.spacesFromEnd(r) + R, R !== " !important" && (i.raws.important = R);
          break;
        } else if (Z[1].toLowerCase() === "important") {
          let R = r.slice(0), W = "";
          for (let V = y; V > 0; V--) {
            let I = R[V][0];
            if (W.trim().startsWith("!") && I !== "space")
              break;
            W = R.pop()[1] + W;
          }
          W.trim().startsWith("!") && (i.important = !0, i.raws.important = W, r = R);
        }
        if (Z[0] !== "space" && Z[0] !== "comment")
          break;
      }
      r.some((y) => y[0] !== "space" && y[0] !== "comment") && (i.raws.between += G.map((y) => y[1]).join(""), G = []), this.raw(i, "value", G.concat(r), n), i.value.includes(":") && !n && this.checkMissedSemicolon(r);
    }
    doubleColon(r) {
      throw this.input.error(
        "Double colon",
        { offset: r[2] },
        { offset: r[2] + r[1].length }
      );
    }
    emptyRule(r) {
      let n = new c();
      this.init(n, r[2]), n.selector = "", n.raws.between = "", this.current = n;
    }
    end(r) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(r[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(r);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(r) {
      if (this.spaces += r[1], this.current.nodes) {
        let n = this.current.nodes[this.current.nodes.length - 1];
        n && n.type === "rule" && !n.raws.ownSemicolon && (n.raws.ownSemicolon = this.spaces, this.spaces = "", n.source.end = this.getPosition(r[2]), n.source.end.offset += n.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(r) {
      let n = this.input.fromOffset(r);
      return {
        column: n.col,
        line: n.line,
        offset: r
      };
    }
    init(r, n) {
      this.current.push(r), r.source = {
        input: this.input,
        start: this.getPosition(n)
      }, r.raws.before = this.spaces, this.spaces = "", r.type !== "comment" && (this.semicolon = !1);
    }
    other(r) {
      let n = !1, i = null, o = !1, a = null, p = [], X = r[1].startsWith("--"), Z = [], S = r;
      for (; S; ) {
        if (i = S[0], Z.push(S), i === "(" || i === "[")
          a || (a = S), p.push(i === "(" ? ")" : "]");
        else if (X && o && i === "{")
          a || (a = S), p.push("}");
        else if (p.length === 0)
          if (i === ";")
            if (o) {
              this.decl(Z, X);
              return;
            } else
              break;
          else if (i === "{") {
            this.rule(Z);
            return;
          } else if (i === "}") {
            this.tokenizer.back(Z.pop()), n = !0;
            break;
          } else i === ":" && (o = !0);
        else i === p[p.length - 1] && (p.pop(), p.length === 0 && (a = null));
        S = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (n = !0), p.length > 0 && this.unclosedBracket(a), n && o) {
        if (!X)
          for (; Z.length && (S = Z[Z.length - 1][0], !(S !== "space" && S !== "comment")); )
            this.tokenizer.back(Z.pop());
        this.decl(Z, X);
      } else
        this.unknownWord(Z);
    }
    parse() {
      let r;
      for (; !this.tokenizer.endOfFile(); )
        switch (r = this.tokenizer.nextToken(), r[0]) {
          case "space":
            this.spaces += r[1];
            break;
          case ";":
            this.freeSemicolon(r);
            break;
          case "}":
            this.end(r);
            break;
          case "comment":
            this.comment(r);
            break;
          case "at-word":
            this.atrule(r);
            break;
          case "{":
            this.emptyRule(r);
            break;
          default:
            this.other(r);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(r, n, i, o) {
      let a, p, X = i.length, Z = "", S = !0, G, g;
      for (let y = 0; y < X; y += 1)
        a = i[y], p = a[0], p === "space" && y === X - 1 && !o ? S = !1 : p === "comment" ? (g = i[y - 1] ? i[y - 1][0] : "empty", G = i[y + 1] ? i[y + 1][0] : "empty", !f[g] && !f[G] ? Z.slice(-1) === "," ? S = !1 : Z += a[1] : S = !1) : Z += a[1];
      if (!S) {
        let y = i.reduce((R, W) => R + W[1], "");
        r.raws[n] = { raw: y, value: Z };
      }
      r[n] = Z;
    }
    rule(r) {
      r.pop();
      let n = new c();
      this.init(n, r[0][2]), n.raws.between = this.spacesAndCommentsFromEnd(r), this.raw(n, "selector", r), this.current = n;
    }
    spacesAndCommentsFromEnd(r) {
      let n, i = "";
      for (; r.length && (n = r[r.length - 1][0], !(n !== "space" && n !== "comment")); )
        i = r.pop()[1] + i;
      return i;
    }
    // Errors
    spacesAndCommentsFromStart(r) {
      let n, i = "";
      for (; r.length && (n = r[0][0], !(n !== "space" && n !== "comment")); )
        i += r.shift()[1];
      return i;
    }
    spacesFromEnd(r) {
      let n, i = "";
      for (; r.length && (n = r[r.length - 1][0], n === "space"); )
        i = r.pop()[1] + i;
      return i;
    }
    stringFrom(r, n) {
      let i = "";
      for (let o = n; o < r.length; o++)
        i += r[o][1];
      return r.splice(n, r.length - n), i;
    }
    unclosedBlock() {
      let r = this.current.source.start;
      throw this.input.error("Unclosed block", r.line, r.column);
    }
    unclosedBracket(r) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unexpectedClose(r) {
      throw this.input.error(
        "Unexpected }",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unknownWord(r) {
      throw this.input.error(
        "Unknown word " + r[0][1],
        { offset: r[0][2] },
        { offset: r[0][2] + r[0][1].length }
      );
    }
    unnamedAtrule(r, n) {
      throw this.input.error(
        "At-rule without name",
        { offset: n[2] },
        { offset: n[2] + n[1].length }
      );
    }
  }
  return qi = h, qi;
}
var es, cn;
function Ts() {
  if (cn) return es;
  cn = 1;
  let e = He(), t = qt(), s = ec();
  function l(c, u) {
    let f = new t(c, u), b = new s(f);
    try {
      b.parse();
    } catch (m) {
      throw process.env.NODE_ENV !== "production" && m.name === "CssSyntaxError" && u && u.from && (/\.scss$/i.test(u.from) ? m.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(u.from) ? m.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(u.from) && (m.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), m;
    }
    return b.root;
  }
  return es = l, l.default = l, e.registerParse(l), es;
}
var ts, un;
function yl() {
  if (un) return ts;
  un = 1;
  let e = He(), { my: t } = jt();
  class s {
    constructor(c, u = {}) {
      if (this.type = "warning", this.text = c, u.node && u.node.source) {
        u.node[t] || e.rebuild(u.node);
        let f = u.node.rangeBy(u);
        this.line = f.start.line, this.column = f.start.column, this.endLine = f.end.line, this.endColumn = f.end.column;
      }
      for (let f in u) this[f] = u[f];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return ts = s, s.default = s, ts;
}
var is, dn;
function Us() {
  if (dn) return is;
  dn = 1;
  let e = yl();
  class t {
    get content() {
      return this.css;
    }
    constructor(l, c, u) {
      this.processor = l, this.messages = [], this.root = c, this.opts = u, this.css = "", this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(l, c = {}) {
      c.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (c.plugin = this.lastPlugin.postcssPlugin);
      let u = new e(l, c);
      return this.messages.push(u), u;
    }
    warnings() {
      return this.messages.filter((l) => l.type === "warning");
    }
  }
  return is = t, t.default = t, is;
}
var ss, hn;
function Zl() {
  if (hn) return ss;
  hn = 1;
  let e = {};
  return ss = function(s) {
    e[s] || (e[s] = !0, typeof console != "undefined" && console.warn && console.warn(s));
  }, ss;
}
var rs, pn;
function gl() {
  if (pn) return rs;
  pn = 1;
  let e = He(), t = Ys(), s = bl(), l = Ts(), c = Us(), u = yt(), f = Dt(), { isClean: b, my: m } = jt(), h = Zl();
  const d = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, r = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, n = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, i = 0;
  function o(G) {
    return typeof G == "object" && typeof G.then == "function";
  }
  function a(G) {
    let g = !1, y = d[G.type];
    return G.type === "decl" ? g = G.prop.toLowerCase() : G.type === "atrule" && (g = G.name.toLowerCase()), g && G.append ? [
      y,
      y + "-" + g,
      i,
      y + "Exit",
      y + "Exit-" + g
    ] : g ? [y, y + "-" + g, y + "Exit", y + "Exit-" + g] : G.append ? [y, i, y + "Exit"] : [y, y + "Exit"];
  }
  function p(G) {
    let g;
    return G.type === "document" ? g = ["Document", i, "DocumentExit"] : G.type === "root" ? g = ["Root", i, "RootExit"] : g = a(G), {
      eventIndex: 0,
      events: g,
      iterator: 0,
      node: G,
      visitorIndex: 0,
      visitors: []
    };
  }
  function X(G) {
    let g = [G];
    for (; g.length > 0; ) {
      let y = g.pop();
      if (y[b] = !1, y.nodes)
        for (let R of y.nodes) g.push(R);
    }
    return G;
  }
  let Z = {};
  class S {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(g, y, R) {
      this.stringified = !1, this.processed = !1;
      let W;
      if (typeof y == "object" && y !== null && (y.type === "root" || y.type === "document"))
        W = X(y);
      else if (y instanceof S || y instanceof c)
        W = X(y.root), y.map && (typeof R.map == "undefined" && (R.map = {}), R.map.inline || (R.map.inline = !1), R.map.prev = y.map);
      else {
        let V = l;
        R.syntax && (V = R.syntax.parse), R.parser && (V = R.parser), V.parse && (V = V.parse);
        try {
          W = V(y, R);
        } catch (I) {
          this.processed = !0, this.error = I;
        }
        W && !W[m] && e.rebuild(W);
      }
      this.result = new c(g, W, R), this.helpers = he(K({}, Z), { postcss: Z, result: this.result }), this.plugins = this.processor.plugins.map((V) => typeof V == "object" && V.prepare ? K(K({}, V), V.prepare(this.result)) : V);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(g) {
      return this.async().catch(g);
    }
    finally(g) {
      return this.async().then(g, g);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(g, y) {
      let R = this.result.lastPlugin;
      try {
        if (y && y.addToError(g), this.error = g, g.name === "CssSyntaxError" && !g.plugin)
          g.plugin = R.postcssPlugin, g.setMessage();
        else if (R.postcssVersion && process.env.NODE_ENV !== "production") {
          let W = R.postcssPlugin, V = R.postcssVersion, I = this.result.processor.version, v = V.split("."), x = I.split(".");
          (v[0] !== x[0] || parseInt(v[1]) > parseInt(x[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + I + ", but " + W + " uses " + V + ". Perhaps this is the source of the error below."
          );
        }
      } catch (W) {
        console && console.error && console.error(W);
      }
      return g;
    }
    prepareVisitors() {
      this.listeners = {};
      let g = (y, R, W) => {
        this.listeners[R] || (this.listeners[R] = []), this.listeners[R].push([y, W]);
      };
      for (let y of this.plugins)
        if (typeof y == "object")
          for (let R in y) {
            if (!r[R] && /^[A-Z]/.test(R))
              throw new Error(
                `Unknown event ${R} in ${y.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!n[R])
              if (typeof y[R] == "object")
                for (let W in y[R])
                  W === "*" ? g(y, R, y[R][W]) : g(
                    y,
                    R + "-" + W.toLowerCase(),
                    y[R][W]
                  );
              else typeof y[R] == "function" && g(y, R, y[R]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    runAsync() {
      return pe(this, null, function* () {
        this.plugin = 0;
        for (let g = 0; g < this.plugins.length; g++) {
          let y = this.plugins[g], R = this.runOnRoot(y);
          if (o(R))
            try {
              yield R;
            } catch (W) {
              throw this.handleError(W);
            }
        }
        if (this.prepareVisitors(), this.hasListener) {
          let g = this.result.root;
          for (; !g[b]; ) {
            g[b] = !0;
            let y = [p(g)];
            for (; y.length > 0; ) {
              let R = this.visitTick(y);
              if (o(R))
                try {
                  yield R;
                } catch (W) {
                  let V = y[y.length - 1].node;
                  throw this.handleError(W, V);
                }
            }
          }
          if (this.listeners.OnceExit)
            for (let [y, R] of this.listeners.OnceExit) {
              this.result.lastPlugin = y;
              try {
                if (g.type === "document") {
                  let W = g.nodes.map(
                    (V) => R(V, this.helpers)
                  );
                  yield Promise.all(W);
                } else
                  yield R(g, this.helpers);
              } catch (W) {
                throw this.handleError(W);
              }
            }
        }
        return this.processed = !0, this.stringify();
      });
    }
    runOnRoot(g) {
      this.result.lastPlugin = g;
      try {
        if (typeof g == "object" && g.Once) {
          if (this.result.root.type === "document") {
            let y = this.result.root.nodes.map(
              (R) => g.Once(R, this.helpers)
            );
            return o(y[0]) ? Promise.all(y) : y;
          }
          return g.Once(this.result.root, this.helpers);
        } else if (typeof g == "function")
          return g(this.result.root, this.result);
      } catch (y) {
        throw this.handleError(y);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let g = this.result.opts, y = f;
      g.syntax && (y = g.syntax.stringify), g.stringifier && (y = g.stringifier), y.stringify && (y = y.stringify);
      let R = this.result.root.source;
      if (g.map === void 0 && !(R && R.input && R.input.map)) {
        let I = "";
        return y(this.result.root, (v) => {
          I += v;
        }), this.result.css = I, this.result;
      }
      let V = new s(y, this.result.root, this.result.opts).generate();
      return this.result.css = V[0], this.result.map = V[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let g of this.plugins) {
        let y = this.runOnRoot(g);
        if (o(y))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let g = this.result.root;
        for (; !g[b]; )
          g[b] = !0, this.walkSync(g);
        if (this.listeners.OnceExit)
          if (g.type === "document")
            for (let y of g.nodes)
              this.visitSync(this.listeners.OnceExit, y);
          else
            this.visitSync(this.listeners.OnceExit, g);
      }
      return this.result;
    }
    then(g, y) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || h(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(g, y);
    }
    toString() {
      return this.css;
    }
    visitSync(g, y) {
      for (let [R, W] of g) {
        this.result.lastPlugin = R;
        let V;
        try {
          V = W(y, this.helpers);
        } catch (I) {
          throw this.handleError(I, y.proxyOf);
        }
        if (y.type !== "root" && y.type !== "document" && !y.parent)
          return !0;
        if (o(V))
          throw this.getAsyncError();
      }
    }
    visitTick(g) {
      let y = g[g.length - 1], { node: R, visitors: W } = y;
      if (R.type !== "root" && R.type !== "document" && !R.parent) {
        g.pop();
        return;
      }
      if (W.length > 0 && y.visitorIndex < W.length) {
        let [I, v] = W[y.visitorIndex];
        y.visitorIndex += 1, y.visitorIndex === W.length && (y.visitors = [], y.visitorIndex = 0), this.result.lastPlugin = I;
        try {
          return v(R.toProxy(), this.helpers);
        } catch (x) {
          throw this.handleError(x, R);
        }
      }
      if (y.iterator !== 0) {
        let I = y.iterator;
        y.descending && (y.descending = !1, R.indexes[I] += 1);
        let v;
        for (; v = R.nodes[R.indexes[I]]; ) {
          if (!v[b]) {
            v[b] = !0, y.descending = !0, g.push(p(v));
            return;
          }
          R.indexes[I] += 1;
        }
        y.iterator = 0, delete R.indexes[I];
      }
      let V = y.events;
      for (; y.eventIndex < V.length; ) {
        let I = V[y.eventIndex];
        if (y.eventIndex += 1, I === i) {
          R.nodes && R.nodes.length && (R[b] = !0, y.iterator = R.getIterator());
          return;
        } else if (this.listeners[I]) {
          y.visitors = this.listeners[I];
          return;
        }
      }
      g.pop();
    }
    walkSync(g) {
      g[b] = !0;
      let y = [{ eventIndex: 0, events: a(g), iterator: 0, node: g }];
      for (; y.length > 0; ) {
        let R = y[y.length - 1], W = R.node;
        if (R.iterator !== 0) {
          let V = R.iterator;
          R.descending && (R.descending = !1, W.indexes[V] += 1);
          let I, v = !1;
          for (; I = W.nodes[W.indexes[V]]; ) {
            if (!I[b]) {
              I[b] = !0, R.descending = !0, y.push({
                eventIndex: 0,
                events: a(I),
                iterator: 0,
                node: I
              }), v = !0;
              break;
            }
            W.indexes[V] += 1;
          }
          if (v) continue;
          R.iterator = 0, delete W.indexes[V];
        }
        if (R.eventIndex < R.events.length) {
          let V = R.events[R.eventIndex];
          if (R.eventIndex += 1, V === i)
            W.nodes && W.nodes.length && (R.iterator = W.getIterator());
          else {
            let I = this.listeners[V];
            I && this.visitSync(I, W.toProxy()) && y.pop();
          }
          continue;
        }
        y.pop();
      }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return S.registerPostcss = (G) => {
    Z = G;
  }, rs = S, S.default = S, u.registerLazyResult(S), t.registerLazyResult(S), rs;
}
var ns, mn;
function tc() {
  if (mn) return ns;
  mn = 1;
  let e = bl(), t = Ts(), s = Us(), l = Dt(), c = Zl();
  class u {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let b, m = t;
      try {
        b = m(this._css, this._opts);
      } catch (h) {
        this.error = h;
      }
      if (this.error)
        throw this.error;
      return this._root = b, b;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(b, m, h) {
      m = m.toString(), this.stringified = !1, this._processor = b, this._css = m, this._opts = h, this._map = void 0;
      let d = l;
      this.result = new s(this._processor, void 0, this._opts), this.result.css = m;
      let r = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return r.root;
        }
      });
      let n = new e(d, void 0, this._opts, m);
      if (n.isMap()) {
        let [i, o] = n.generate();
        i && (this.result.css = i), o && (this.result.map = o);
      } else
        n.clearAnnotation(), this.result.css = n.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(b) {
      return this.async().catch(b);
    }
    finally(b) {
      return this.async().then(b, b);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(b, m) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || c(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(b, m);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return ns = u, u.default = u, ns;
}
var ls, fn;
function ic() {
  if (fn) return ls;
  fn = 1;
  let e = Ys(), t = gl(), s = tc(), l = yt();
  class c {
    constructor(f = []) {
      this.version = "8.5.26", this.plugins = this.normalize(f);
    }
    normalize(f) {
      let b = [];
      for (let m of f)
        if (m.postcss === !0 ? m = m() : m.postcss && (m = m.postcss), typeof m == "object" && Array.isArray(m.plugins))
          b = b.concat(m.plugins);
        else if (typeof m == "object" && m.postcssPlugin)
          b.push(m);
        else if (typeof m == "function")
          b.push(m);
        else if (typeof m == "object" && (m.parse || m.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(m + " is not a PostCSS plugin");
      return b;
    }
    process(f, b = {}) {
      return !this.plugins.length && !b.parser && !b.stringifier && !b.syntax ? new s(this, f, b) : new t(this, f, b);
    }
    use(f) {
      return this.plugins = this.plugins.concat(this.normalize([f])), this;
    }
  }
  return ls = c, c.default = c, l.registerProcessor(c), e.registerProcessor(c), ls;
}
var os, bn;
function sc() {
  if (bn) return os;
  bn = 1;
  let e = Js(), t = _t(), s = He(), l = ks(), c = $t(), u = Ys(), f = $a(), b = qt(), m = gl(), h = fl(), d = At(), r = Ts(), n = ic(), i = Us(), o = yt(), a = Ns(), p = Dt(), X = yl();
  function Z(...S) {
    return S.length === 1 && Array.isArray(S[0]) && (S = S[0]), new n(S);
  }
  return Z.plugin = function(G, g) {
    let y = !1;
    function R(...V) {
      console && console.warn && !y && (y = !0, console.warn(
        G + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        G + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let I = g(...V);
      return I.postcssPlugin = G, I.postcssVersion = new n().version, I;
    }
    let W;
    return Object.defineProperty(R, "postcss", {
      get() {
        return W || (W = R()), W;
      }
    }), R.process = function(V, I, v) {
      return Z([R(v)]).process(V, I);
    }, R;
  }, Z.stringify = p, Z.parse = r, Z.fromJSON = f, Z.list = h, Z.comment = (S) => new t(S), Z.atRule = (S) => new e(S), Z.decl = (S) => new c(S), Z.rule = (S) => new a(S), Z.root = (S) => new o(S), Z.document = (S) => new u(S), Z.CssSyntaxError = l, Z.Declaration = c, Z.Container = s, Z.Processor = n, Z.Document = u, Z.Comment = t, Z.Warning = X, Z.AtRule = e, Z.Result = i, Z.Input = b, Z.Rule = a, Z.Root = o, Z.Node = d, m.registerPostcss(Z), os = Z, Z.default = Z, os;
}
sc();
class Ks {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...t) {
    Ge(this, "parentElement", null), Ge(this, "parentNode", null), Ge(this, "ownerDocument"), Ge(this, "firstChild", null), Ge(this, "lastChild", null), Ge(this, "previousSibling", null), Ge(this, "nextSibling", null), Ge(this, "ELEMENT_NODE", 1), Ge(this, "TEXT_NODE", 3), Ge(this, "nodeType"), Ge(this, "nodeName"), Ge(this, "RRNodeType");
  }
  get childNodes() {
    const t = [];
    let s = this.firstChild;
    for (; s; )
      t.push(s), s = s.nextSibling;
    return t;
  }
  contains(t) {
    if (t instanceof Ks) {
      if (t.ownerDocument !== this.ownerDocument) return !1;
      if (t === this) return !0;
    } else return !1;
    for (; t.parentNode; ) {
      if (t.parentNode === this) return !0;
      t = t.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(t, s) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
Date.now().toString();
const Ct = /* @__PURE__ */ new Map(), yn = /* @__PURE__ */ new WeakSet();
function Zn(e) {
  return e !== null && typeof e == "object" && "complete" in e && "naturalWidth" in e && "naturalHeight" in e && "src" in e && "onload" in e;
}
function rc(e) {
  if (yn.has(e))
    return;
  yn.add(e);
  const t = e.drawImage.bind(e);
  e.drawImage = function(s, ...l) {
    const c = Ct.get(e);
    c && (c.cancelled = !0);
    const u = () => {
      l.length === 2 && Zn(s) && l.push(
        s.naturalWidth || s.width,
        s.naturalHeight || s.height
      ), t(s, ...l);
    };
    if (Zn(s) && !s.complete) {
      const f = { cancelled: !1 };
      Ct.set(e, f);
      const b = () => {
        f.cancelled || (Ct.delete(e), u());
      }, m = () => {
        if (!f.cancelled) {
          Ct.delete(e);
          try {
            u();
          } catch (h) {
          }
        }
      };
      s.onload = b, s.onerror = m;
    } else
      u();
  };
}
const gn = {
  Node: [
    "childNodes",
    "parentNode",
    "parentElement",
    "textContent",
    "ownerDocument"
  ],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, Sn = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, xt = {}, Sl = {}, nc = () => !!globalThis.Zone;
function Fs(e) {
  if (xt[e])
    return xt[e];
  const t = globalThis[e], s = t.prototype, l = e in gn ? gn[e] : void 0, c = !!(l && // @ts-expect-error 2345
  l.every(
    (b) => {
      var m, h;
      return !!((h = (m = Object.getOwnPropertyDescriptor(s, b)) == null ? void 0 : m.get) != null && h.toString().includes("[native code]"));
    }
  )), u = e in Sn ? Sn[e] : void 0, f = !!(u && u.every(
    // @ts-expect-error 2345
    (b) => {
      var m;
      return typeof s[b] == "function" && ((m = s[b]) == null ? void 0 : m.toString().includes("[native code]"));
    }
  ));
  if (c && f && !nc())
    return xt[e] = t.prototype, t.prototype;
  try {
    const b = document.createElement("iframe");
    b.style.display = "none", document.body.appendChild(b);
    const m = b.contentWindow;
    if (!m) return t.prototype;
    const h = m[e].prototype;
    if (!h)
      return b.remove(), s;
    const d = navigator.userAgent;
    return d.includes("Safari") && !d.includes("Chrome") ? (b.classList.add("rr-block"), b.setAttribute("__rrwebUntaintedMutationObserver", ""), Sl[e] = () => b.remove()) : b.remove(), xt[e] = h;
  } catch (b) {
    return s;
  }
}
const as = {};
function Ne(e, t, s) {
  var l;
  const c = `${e}.${String(s)}`;
  if (as[c])
    return as[c].call(
      t
    );
  const u = Fs(e), f = (l = Object.getOwnPropertyDescriptor(
    u,
    s
  )) == null ? void 0 : l.get;
  return f ? (as[c] = f, f.call(t)) : t[s];
}
const cs = {};
function Xl(e, t, s) {
  const l = `${e}.${String(s)}`;
  if (cs[l])
    return cs[l].bind(
      t
    );
  const u = Fs(e)[s];
  return typeof u != "function" ? t[s] : (cs[l] = u, u.bind(t));
}
function lc(e) {
  return Ne("Node", e, "ownerDocument");
}
function oc(e) {
  return Ne("Node", e, "childNodes");
}
function ac(e) {
  return Ne("Node", e, "parentNode");
}
function cc(e) {
  return Ne("Node", e, "parentElement");
}
function uc(e) {
  return Ne("Node", e, "textContent");
}
function dc(e, t) {
  return Xl("Node", e, "contains")(t);
}
function hc(e) {
  return Xl("Node", e, "getRootNode")();
}
function pc(e) {
  return !e || !("host" in e) ? null : Ne("ShadowRoot", e, "host");
}
function mc(e) {
  return e.styleSheets;
}
function fc(e) {
  return !e || !("shadowRoot" in e) ? null : Ne("Element", e, "shadowRoot");
}
function bc(e, t) {
  return Ne("Element", e, "querySelector")(t);
}
function yc(e, t) {
  return Ne("Element", e, "querySelectorAll")(t);
}
function Rl() {
  var e;
  return [
    Fs("MutationObserver").constructor,
    (e = Sl.MutationObserver) != null ? e : () => {
    }
  ];
}
let ht = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (ht = () => (/* @__PURE__ */ new Date()).getTime());
function Be(e, t, s) {
  try {
    if (!(t in e))
      return () => {
      };
    const l = e[t], c = s(l);
    return typeof c == "function" && (c.prototype = c.prototype || {}, Object.defineProperties(c, {
      __rrweb_original__: {
        enumerable: !1,
        value: l
      }
    })), e[t] = c, () => {
      e[t] = l;
    };
  } catch (l) {
    return () => {
    };
  }
}
const E = {
  ownerDocument: lc,
  childNodes: oc,
  parentNode: ac,
  parentElement: cc,
  textContent: uc,
  contains: dc,
  getRootNode: hc,
  host: pc,
  styleSheets: mc,
  shadowRoot: fc,
  querySelector: bc,
  querySelectorAll: yc,
  nowTimestamp: ht,
  mutationObserverCtor: Rl,
  patch: Be,
  wrapCanvasContextDrawImage: rc
};
function Ze(e, t, s = document) {
  const l = { capture: !0 };
  return s.addEventListener(e, t, l), () => s.removeEventListener(e, t, l);
}
const Ae = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Xn = {
  map: {},
  getId() {
    return console.error(Ae), -1;
  },
  getNode() {
    return console.error(Ae), null;
  },
  removeNodeFromMap() {
    console.error(Ae);
  },
  has() {
    return console.error(Ae), !1;
  },
  reset() {
    console.error(Ae);
  }
};
typeof window != "undefined" && window.Proxy && window.Reflect && (Xn = new Proxy(Xn, {
  get(e, t, s) {
    return t === "map" && console.error(Ae), Reflect.get(e, t, s);
  }
}));
function pt(e, t, s = {}) {
  let l = null, c = 0;
  return function(...u) {
    const f = Date.now();
    !c && s.leading === !1 && (c = f);
    const b = t - (f - c), m = this;
    b <= 0 || b > t ? (l && (clearTimeout(l), l = null), c = f, e.apply(m, u)) : !l && s.trailing !== !1 && (l = setTimeout(() => {
      c = s.leading === !1 ? 0 : Date.now(), l = null, e.apply(m, u);
    }, b));
  };
}
function ei(e, t, s, l, c = window) {
  const u = c.Object.getOwnPropertyDescriptor(e, t);
  return c.Object.defineProperty(
    e,
    t,
    l ? s : {
      set(f) {
        setTimeout(() => {
          s.set.call(this, f);
        }, 0), u && u.set && u.set.call(this, f);
      }
    }
  ), () => ei(e, t, u || {}, !0);
}
function Gl(e) {
  var t, s, l, c;
  const u = e.document;
  return {
    left: u.scrollingElement ? u.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : u.documentElement.scrollLeft || (u == null ? void 0 : u.body) && ((t = E.parentElement(u.body)) == null ? void 0 : t.scrollLeft) || ((s = u == null ? void 0 : u.body) == null ? void 0 : s.scrollLeft) || 0,
    top: u.scrollingElement ? u.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : (u == null ? void 0 : u.documentElement.scrollTop) || (u == null ? void 0 : u.body) && ((l = E.parentElement(u.body)) == null ? void 0 : l.scrollTop) || ((c = u == null ? void 0 : u.body) == null ? void 0 : c.scrollTop) || 0
  };
}
function Vl() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Wl() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function Il(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : E.parentElement(e) : null;
}
const Zc = (e) => {
  try {
    if (e instanceof HTMLElement)
      return e.tagName === "CANVAS";
  } catch (t) {
    return !1;
  }
  return !1;
};
function fe(e, t, s, l) {
  if (!e)
    return !1;
  const c = Il(e);
  if (!c)
    return !1;
  try {
    if (typeof t == "string") {
      if (c.classList.contains(t) || l && c.closest("." + t) !== null) return !0;
    } else if (Kt(c, t, l)) return !0;
  } catch (u) {
  }
  return !!(s && (c.matches(s) || l && c.closest(s) !== null));
}
function gc(e, t) {
  return t.getId(e) !== -1;
}
function us(e, t, s) {
  return e.tagName === "TITLE" && s.headTitleMutations ? !0 : t.getId(e) === dt;
}
function wl(e, t) {
  if (lt(e))
    return !1;
  const s = t.getId(e);
  if (!t.has(s))
    return !0;
  const l = E.parentNode(e);
  return l && l.nodeType === e.DOCUMENT_NODE ? !1 : l ? wl(l, t) : !0;
}
function bs(e) {
  return !!e.changedTouches;
}
function Sc(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach);
}
function Cl(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function xl(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function ys(e) {
  return e ? e instanceof Ks && "shadowRoot" in e ? !!e.shadowRoot : !!E.shadowRoot(e) : !1;
}
class Xc {
  constructor() {
    L(this, "id", 1), L(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), L(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  getId(t) {
    var s;
    return (s = this.styleIDMap.get(t)) != null ? s : -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(t, s) {
    if (this.has(t)) return this.getId(t);
    let l;
    return s === void 0 ? l = this.id++ : l = s, this.styleIDMap.set(t, l), this.idStyleMap.set(l, t), l;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function vl(e) {
  var t;
  let s = null;
  return "getRootNode" in e && ((t = E.getRootNode(e)) == null ? void 0 : t.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && E.host(E.getRootNode(e)) && (s = E.host(E.getRootNode(e))), s;
}
function Rc(e) {
  let t = e, s;
  for (; s = vl(t); )
    t = s;
  return t;
}
function Gc(e) {
  const t = E.ownerDocument(e);
  if (!t) return !1;
  const s = Rc(e);
  return E.contains(t, s);
}
function Ll(e) {
  const t = E.ownerDocument(e);
  return t ? E.contains(t, e) || Gc(e) : !1;
}
var $ = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e[e.Asset = 7] = "Asset", e))($ || {}), j = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(j || {}), ge = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(ge || {}), Fe = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Fe || {}), tt = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(tt || {}), _e = /* @__PURE__ */ ((e) => (e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e))(_e || {}), kl = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(kl || {});
function Rn(e) {
  return "__ln" in e;
}
class Vc {
  constructor() {
    L(this, "length", 0), L(this, "head", null), L(this, "tail", null);
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let s = this.head;
    for (let l = 0; l < t; l++)
      s = (s == null ? void 0 : s.next) || null;
    return s;
  }
  addNode(t) {
    const s = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = s, t.previousSibling && Rn(t.previousSibling)) {
      const l = t.previousSibling.__ln.next;
      s.next = l, s.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = s, l && (l.previous = s);
    } else if (t.nextSibling && Rn(t.nextSibling) && t.nextSibling.__ln.previous) {
      const l = t.nextSibling.__ln.previous;
      s.previous = l, s.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = s, l && (l.next = s);
    } else
      this.head && (this.head.previous = s), s.next = this.head, this.head = s;
    s.next === null && (this.tail = s), this.length++;
  }
  removeNode(t) {
    const s = t.__ln;
    this.head && (s.previous ? (s.previous.next = s.next, s.next ? s.next.previous = s.previous : this.tail = s.previous) : (this.head = s.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const Gn = (e, t) => `${e}@${t}`;
class Wc {
  constructor() {
    L(this, "frozen", !1), L(this, "locked", !1), L(this, "texts", []), L(this, "attributes", []), L(this, "attributeMap", /* @__PURE__ */ new WeakMap()), L(this, "removes", []), L(this, "mapRemoves", []), L(this, "movedMap", {}), L(this, "addedSet", /* @__PURE__ */ new Set()), L(this, "movedSet", /* @__PURE__ */ new Set()), L(this, "droppedSet", /* @__PURE__ */ new Set()), L(this, "removesSubTreeCache", /* @__PURE__ */ new Set()), L(this, "mutationCb"), L(this, "blockClass"), L(this, "blockSelector"), L(this, "maskTextClass"), L(this, "maskTextSelector"), L(this, "inlineStylesheet"), L(this, "maskInputOptions"), L(this, "maskTextFn"), L(this, "maskInputFn"), L(this, "keepIframeSrcFn"), L(this, "recordCanvas"), L(this, "inlineImages"), L(this, "inlineVideos"), L(this, "privacySetting"), L(this, "slimDOMOptions"), L(this, "dataURLOptions"), L(this, "doc"), L(this, "mirror"), L(this, "iframeManager"), L(this, "stylesheetManager"), L(this, "shadowDomManager"), L(this, "canvasManager"), L(this, "processedNodeManager"), L(this, "unattachedDoc"), L(this, "processMutations", (t) => {
      t.forEach(this.processMutation), this.emit();
    }), L(this, "emit", () => {
      if (this.frozen || this.locked)
        return;
      const t = [], s = /* @__PURE__ */ new Set(), l = new Vc(), c = (m) => {
        let h = m, d = dt;
        for (; d === dt; )
          h = h && h.nextSibling, d = h && this.mirror.getId(h);
        return d;
      }, u = (m) => {
        const h = E.parentNode(m);
        if (!h || !Ll(m))
          return;
        let d = !1;
        if (m.nodeType === Node.TEXT_NODE) {
          const o = h.tagName;
          if (o === "TEXTAREA")
            return;
          o === "STYLE" && this.addedSet.has(h) && (d = !0);
        }
        const r = lt(h) ? this.mirror.getId(vl(m)) : this.mirror.getId(h), n = c(m);
        if (r === -1 || n === -1)
          return l.addNode(m);
        const i = qe(m, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          privacySetting: this.privacySetting,
          onSerialize: (o) => {
            Cl(o, this.mirror) && this.iframeManager.addIframe(o), xl(o, this.mirror) && this.stylesheetManager.trackLinkElement(
              o
            ), ys(m) && this.shadowDomManager.addShadowRoot(E.shadowRoot(m), this.doc);
          },
          onIframeLoad: (o, a) => {
            this.iframeManager.attachIframe(o, a), this.shadowDomManager.observeAttachShadow(o);
          },
          onStylesheetLoad: (o, a) => {
            this.stylesheetManager.attachLinkElement(o, a);
          },
          cssCaptured: d
        });
        i && (t.push({
          parentId: r,
          nextId: n,
          node: i
        }), s.add(i.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const m of this.movedSet)
        Vn(this.removesSubTreeCache, m) && !this.movedSet.has(E.parentNode(m)) || u(m);
      for (const m of this.addedSet)
        !Wn(this.droppedSet, m) && !Vn(this.removesSubTreeCache, m) || Wn(this.movedSet, m) ? u(m) : this.droppedSet.add(m);
      let f = null;
      for (; l.length; ) {
        let m = null;
        if (f) {
          const h = this.mirror.getId(E.parentNode(f.value)), d = c(f.value);
          h !== -1 && d !== -1 && (m = f);
        }
        if (!m) {
          let h = l.tail;
          for (; h; ) {
            const d = h;
            if (h = h.previous, d) {
              const r = this.mirror.getId(E.parentNode(d.value));
              if (c(d.value) === -1) continue;
              if (r !== -1) {
                m = d;
                break;
              } else {
                const i = d.value, o = E.parentNode(i);
                if (o && o.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const a = E.host(o);
                  if (this.mirror.getId(a) !== -1) {
                    m = d;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!m) {
          for (; l.head; )
            l.removeNode(l.head.value);
          break;
        }
        f = m.previous, l.removeNode(m.value), u(m.value);
      }
      const b = {
        texts: this.texts.map((m) => {
          var h, d;
          const r = m.node, n = E.parentNode(r);
          n && n.tagName === "TEXTAREA" && this.genTextAreaValueMutation(n);
          let i = m.value;
          const o = this.privacySetting === "strict", a = this.privacySetting === "default" && qn(i), p = (d = (h = m.node) == null ? void 0 : h.parentElement) == null ? void 0 : d.getAttribute("data-hl-record");
          return (o || a) && !p && i && (i = Vs(i)), {
            id: this.mirror.getId(r),
            value: i
          };
        }).filter((m) => !s.has(m.id)).filter((m) => this.mirror.has(m.id)),
        attributes: this.attributes.map((m) => {
          const { attributes: h } = m;
          if (typeof h.style == "string") {
            const d = JSON.stringify(m.styleDiff), r = JSON.stringify(m._unchangedStyles);
            d.length < h.style.length && (d + r).split("var(").length === h.style.split("var(").length && (h.style = m.styleDiff);
          }
          return {
            id: this.mirror.getId(m.node),
            attributes: h
          };
        }).filter((m) => !s.has(m.id)).filter((m) => this.mirror.has(m.id)),
        removes: this.removes,
        adds: t
      };
      !b.texts.length && !b.attributes.length && !b.removes.length && !b.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.removesSubTreeCache = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(b));
    }), L(this, "genTextAreaValueMutation", (t) => {
      let s = this.attributeMap.get(t);
      s || (s = {
        node: t,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(s), this.attributeMap.set(t, s));
      const l = Array.from(
        E.childNodes(t),
        (c) => E.textContent(c) || ""
      ).join("");
      s.attributes.value = Nt({
        overwriteRecord: null,
        element: t,
        maskInputOptions: this.maskInputOptions,
        tagName: t.tagName,
        type: Tt(t),
        value: l,
        maskInputFn: this.maskInputFn
      });
    }), L(this, "processMutation", (t) => {
      if (!us(t.target, this.mirror, this.slimDOMOptions))
        switch (t.type) {
          case "characterData": {
            const s = E.textContent(t.target);
            !fe(t.target, this.blockClass, this.blockSelector, !1) && s !== t.oldValue && this.texts.push({
              value: rl(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                !0
                // checkAncestors
              ) && s ? this.maskTextFn ? this.maskTextFn(s, Il(t.target)) : s.replace(/[\S]/g, "*") : s,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const s = t.target;
            let l = t.attributeName, c = t.target.getAttribute(l);
            if (l === "value") {
              const f = Tt(s);
              c = Nt({
                element: s,
                maskInputOptions: this.maskInputOptions,
                tagName: s.tagName,
                type: f,
                value: c,
                overwriteRecord: s.getAttribute("data-hl-record"),
                maskInputFn: this.maskInputFn
              });
            }
            if (fe(t.target, this.blockClass, this.blockSelector, !1) || c === t.oldValue)
              return;
            let u = this.attributeMap.get(t.target);
            if (s.tagName === "IFRAME" && l === "src" && !this.keepIframeSrcFn(c))
              if (!s.contentDocument)
                l = "rr_src";
              else
                return;
            if (u || (u = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(u), this.attributeMap.set(t.target, u)), l === "type" && s.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && s.setAttribute("data-rr-is-password", "true"), !sl(s.tagName, l)) {
              if (t.target.tagName === "INPUT") {
                const b = t.target;
                if (b.type === "password") {
                  u.attributes.value = "*".repeat(b.value.length);
                  break;
                }
              }
              if (u.attributes[l] = il(
                this.doc,
                Ee(s.tagName),
                Ee(l),
                c
              ), l === "style") {
                if (!this.unattachedDoc)
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (m) {
                    this.unattachedDoc = this.doc;
                  }
                const b = this.unattachedDoc.createElement("span");
                t.oldValue && b.setAttribute("style", t.oldValue);
                for (const m of Array.from(s.style)) {
                  const h = s.style.getPropertyValue(m), d = s.style.getPropertyPriority(m);
                  h !== b.style.getPropertyValue(m) || d !== b.style.getPropertyPriority(m) ? d === "" ? u.styleDiff[m] = h : u.styleDiff[m] = [h, d] : u._unchangedStyles[m] = [h, d];
                }
                for (const m of Array.from(b.style))
                  s.style.getPropertyValue(m) === "" && (u.styleDiff[m] = !1);
              } else l === "open" && s.tagName === "DIALOG" && (s.matches("dialog:modal") ? u.attributes.rr_open_mode = "modal" : u.attributes.rr_open_mode = "non-modal");
            }
            break;
          }
          case "childList": {
            if (fe(t.target, this.blockClass, this.blockSelector, !0))
              return;
            if (t.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(t.target);
              return;
            }
            t.addedNodes.forEach((s) => this.genAdds(s, t.target)), t.removedNodes.forEach((s) => {
              const l = this.mirror.getId(s), c = lt(t.target) ? this.mirror.getId(E.host(t.target)) : this.mirror.getId(t.target);
              fe(t.target, this.blockClass, this.blockSelector, !1) || us(s, this.mirror, this.slimDOMOptions) || !gc(s, this.mirror) || (this.addedSet.has(s) ? (Zs(this.addedSet, s), this.droppedSet.add(s)) : this.addedSet.has(t.target) && l === -1 || wl(t.target, this.mirror) || (this.movedSet.has(s) && this.movedMap[Gn(l, c)] ? Zs(this.movedSet, s) : (this.removes.push({
                parentId: c,
                id: l,
                isShadow: lt(t.target) && ot(t.target) ? !0 : void 0
              }), Ic(s, this.removesSubTreeCache))), this.mapRemoves.push(s));
            });
            break;
          }
        }
    }), L(this, "genAdds", (t, s) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (us(t, this.mirror, this.slimDOMOptions))
            return;
          this.movedSet.add(t);
          let l = null;
          s && this.mirror.hasNode(s) && (l = this.mirror.getId(s)), l && l !== -1 && (this.movedMap[Gn(this.mirror.getId(t), l)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        fe(t, this.blockClass, this.blockSelector, !1) || (E.childNodes(t).forEach((l) => this.genAdds(l)), ys(t) && E.childNodes(E.shadowRoot(t)).forEach((l) => {
          this.processedNodeManager.add(l, this), this.genAdds(l, t);
        }));
      }
    });
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "inlineVideos",
      "privacySetting",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((s) => {
      this[s] = t[s];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function Zs(e, t) {
  e.delete(t), E.childNodes(t).forEach((s) => Zs(e, s));
}
function Ic(e, t) {
  const s = [e];
  for (; s.length; ) {
    const l = s.pop();
    t.has(l) || (t.add(l), E.childNodes(l).forEach((c) => s.push(c)));
  }
}
function Vn(e, t, s) {
  return e.size === 0 ? !1 : wc(e, t);
}
function wc(e, t, s) {
  const l = E.parentNode(t);
  return l ? e.has(l) : !1;
}
function Wn(e, t) {
  return e.size === 0 ? !1 : Jl(e, t);
}
function Jl(e, t) {
  const s = E.parentNode(t);
  return s ? e.has(s) ? !0 : Jl(e, s) : !1;
}
let at;
function Cc(e) {
  at = e;
}
function xc() {
  at = void 0;
}
const A = (e) => at ? (...s) => {
  try {
    return e(...s);
  } catch (l) {
    if (at && at(l) === !0)
      return;
    throw l;
  }
} : e, Oe = [];
function Zt(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch (t) {
  }
  return e && e.target;
}
function Yl(e, t) {
  const s = new Wc();
  Oe.push(s), s.init(e);
  const [l, c] = Rl(), u = new l(
    A(s.processMutations.bind(s))
  );
  return u.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), [u, c];
}
function vc({
  mousemoveCb: e,
  sampling: t,
  doc: s,
  mirror: l
}) {
  if (t.mousemove === !1)
    return () => {
    };
  const c = typeof t.mousemove == "number" ? t.mousemove : 50, u = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let f = [], b;
  const m = pt(
    A(
      (r) => {
        const n = Date.now() - b;
        e(
          f.map((i) => (i.timeOffset -= n, i)),
          r
        ), f = [], b = null;
      }
    ),
    u
  ), h = A(
    pt(
      A((r) => {
        const n = Zt(r), { clientX: i, clientY: o } = bs(r) ? r.changedTouches[0] : r;
        b || (b = ht()), f.push({
          x: i,
          y: o,
          id: l.getId(n),
          timeOffset: ht() - b
        }), m(
          typeof DragEvent != "undefined" && r instanceof DragEvent ? j.Drag : r instanceof MouseEvent ? j.MouseMove : j.TouchMove
        );
      }),
      c,
      {
        trailing: !1
      }
    )
  ), d = [
    Ze("mousemove", h, s),
    Ze("touchmove", h, s),
    Ze("drag", h, s)
  ];
  return A(() => {
    d.forEach((r) => r());
  });
}
function Lc({
  mouseInteractionCb: e,
  doc: t,
  mirror: s,
  blockClass: l,
  blockSelector: c,
  sampling: u
}) {
  if (u.mouseInteraction === !1)
    return () => {
    };
  const f = u.mouseInteraction === !0 || u.mouseInteraction === void 0 ? {} : u.mouseInteraction, b = [];
  let m = null;
  const h = (d) => (r) => {
    const n = Zt(r);
    if (fe(n, l, c, !0) || // We ignore canvas elements for rage click detection because we cannot infer what inside the canvas is getting interacted with.
    Zc(n))
      return;
    let i = null, o = d;
    if ("pointerType" in r) {
      switch (r.pointerType) {
        case "mouse":
          i = Fe.Mouse;
          break;
        case "touch":
          i = Fe.Touch;
          break;
        case "pen":
          i = Fe.Pen;
          break;
      }
      i === Fe.Touch && (ge[d] === ge.MouseDown ? o = "TouchStart" : ge[d] === ge.MouseUp && (o = "TouchEnd"));
    } else bs(r) && (i = Fe.Touch);
    i !== null ? (m = i, (o.startsWith("Touch") && i === Fe.Touch || o.startsWith("Mouse") && i === Fe.Mouse) && (i = null)) : ge[d] === ge.Click && (i = m, m = null);
    const a = bs(r) ? r.changedTouches[0] : r;
    if (!a)
      return;
    const p = s.getId(n), { clientX: X, clientY: Z } = a;
    A(e)(K({
      type: ge[o],
      id: p,
      x: X,
      y: Z
    }, i !== null && { pointerType: i }));
  };
  return Object.keys(ge).filter(
    (d) => Number.isNaN(Number(d)) && !d.endsWith("_Departed") && f[d] !== !1
  ).forEach((d) => {
    let r = Ee(d);
    const n = h(d);
    if (window.PointerEvent)
      switch (ge[d]) {
        case ge.MouseDown:
        case ge.MouseUp:
          r = r.replace(
            "mouse",
            "pointer"
          );
          break;
        case ge.TouchStart:
        case ge.TouchEnd:
          return;
      }
    b.push(Ze(r, n, t));
  }), A(() => {
    b.forEach((d) => d());
  });
}
function Nl({
  scrollCb: e,
  doc: t,
  mirror: s,
  blockClass: l,
  blockSelector: c,
  sampling: u
}) {
  const f = A(
    pt(
      A((b) => {
        const m = Zt(b);
        if (!m || fe(m, l, c, !0))
          return;
        const h = s.getId(m);
        if (m === t && t.defaultView) {
          const d = Gl(t.defaultView);
          e({
            id: h,
            x: d.left,
            y: d.top
          });
        } else
          e({
            id: h,
            x: m.scrollLeft,
            y: m.scrollTop
          });
      }),
      u.scroll || 100
    )
  );
  return Ze("scroll", f, t);
}
function kc({ viewportResizeCb: e }, { win: t }) {
  let s = -1, l = -1;
  const c = A(
    pt(
      A(() => {
        const u = Vl(), f = Wl();
        (s !== u || l !== f) && (e({
          width: Number(f),
          height: Number(u)
        }), s = u, l = f);
      }),
      200
    )
  );
  return Ze("resize", c, t);
}
const Jc = ["INPUT", "TEXTAREA", "SELECT"], In = /* @__PURE__ */ new WeakMap();
function Yc({
  inputCb: e,
  doc: t,
  mirror: s,
  blockClass: l,
  blockSelector: c,
  ignoreClass: u,
  ignoreSelector: f,
  maskInputOptions: b,
  maskInputFn: m,
  sampling: h,
  userTriggeredOnInput: d
}) {
  function r(Z) {
    let S = Zt(Z);
    const G = Z.isTrusted, g = S && S.tagName;
    if (S && g === "OPTION" && (S = E.parentElement(S)), !S || !g || Jc.indexOf(g) < 0 || fe(S, l, c, !0) || S.classList.contains(u) || f && S.matches(f))
      return;
    let y = S.value, R = !1;
    const W = Tt(S) || "", V = S.getAttribute("data-hl-record");
    W === "radio" || W === "checkbox" ? R = S.checked : el({
      maskInputOptions: b,
      type: W,
      tagName: g,
      overwriteRecord: V
    }) && (y = Nt({
      element: S,
      maskInputOptions: b,
      tagName: g,
      type: W,
      value: y,
      overwriteRecord: V,
      maskInputFn: m
    })), n(
      S,
      d ? { text: y, isChecked: R, userTriggered: G } : { text: y, isChecked: R }
    );
    const I = S.name;
    W === "radio" && I && R && t.querySelectorAll(`input[type="radio"][name="${I}"]`).forEach((v) => {
      if (v !== S) {
        const x = v.value;
        n(
          v,
          d ? { text: x, isChecked: !R, userTriggered: !1 } : { text: x, isChecked: !R }
        );
      }
    });
  }
  function n(Z, S) {
    const G = In.get(Z);
    if (!G || G.text !== S.text || G.isChecked !== S.isChecked) {
      In.set(Z, S);
      const g = s.getId(Z);
      A(e)(he(K({}, S), {
        id: g
      }));
    }
  }
  const o = (h.input === "last" ? ["change"] : ["input", "change"]).map(
    (Z) => Ze(Z, A(r), t)
  ), a = t.defaultView;
  if (!a)
    return () => {
      o.forEach((Z) => Z());
    };
  const p = a.Object.getOwnPropertyDescriptor(
    a.HTMLInputElement.prototype,
    "value"
  ), X = [
    [a.HTMLInputElement.prototype, "value"],
    [a.HTMLInputElement.prototype, "checked"],
    [a.HTMLSelectElement.prototype, "value"],
    [a.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [a.HTMLSelectElement.prototype, "selectedIndex"],
    [a.HTMLOptionElement.prototype, "selected"]
  ];
  return p && p.set && o.push(
    ...X.map(
      (Z) => ei(
        Z[0],
        Z[1],
        {
          set() {
            A(r)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        a
      )
    )
  ), A(() => {
    o.forEach((Z) => Z());
  });
}
function Ft(e) {
  const t = [];
  function s(l, c) {
    if (vt("CSSGroupingRule") && l.parentRule instanceof CSSGroupingRule || vt("CSSMediaRule") && l.parentRule instanceof CSSMediaRule || vt("CSSSupportsRule") && l.parentRule instanceof CSSSupportsRule || vt("CSSConditionRule") && l.parentRule instanceof CSSConditionRule) {
      const f = Array.from(
        l.parentRule.cssRules
      ).indexOf(l);
      return c.unshift(f), s(l.parentRule, c);
    } else if (l.parentStyleSheet) {
      const f = Array.from(l.parentStyleSheet.cssRules).indexOf(l);
      c.unshift(f);
    }
    return c;
  }
  return s(e, t);
}
function Me(e, t, s) {
  let l, c;
  return e ? (e.ownerNode ? l = t.getId(e.ownerNode) : c = s.getId(e), {
    styleId: c,
    id: l
  }) : {};
}
function Te(e, t, s, l) {
  e[t] === s && (e[t] = l);
}
const Nc = 5;
function Tc({
  styleSheetRuleCb: e,
  mirror: t,
  stylesheetManager: s,
  doc: l,
  styleSheetResyncInterval: c
}, { win: u }) {
  if (!u.CSSStyleSheet || !u.CSSStyleSheet.prototype)
    return () => {
    };
  const f = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakSet();
  let m = !1, h = !1, d = !1, r, n = !1, i = !1, o = !1;
  const a = (k, N) => {
    const Y = f.get(k);
    Y && (Y.reported = Math.max(0, Y.reported + N), Y.everSeen = Math.max(Y.everSeen, Y.reported));
  }, p = (k) => new Proxy(k, {
    apply: A(
      (N, Y, T) => {
        if (m)
          return h = !0, N.apply(Y, T);
        if (n || i)
          return N.apply(Y, T);
        const [H, B] = T, { id: ee, styleId: U } = Me(
          Y,
          t,
          s.styleMirror
        ), D = ee && ee !== -1 || U && U !== -1;
        D && e({
          id: ee,
          styleId: U,
          adds: [{ rule: H, index: B }]
        }), i = !0;
        let ue;
        try {
          ue = N.apply(Y, T);
        } finally {
          i = !1;
        }
        return D && a(Y, 1), ue;
      }
    )
  }), X = (k) => new Proxy(k, {
    apply: A(
      (N, Y, T) => {
        if (m)
          return d = !0, N.apply(Y, T);
        if (n || o)
          return N.apply(Y, T);
        const [H] = T, { id: B, styleId: ee } = Me(
          Y,
          t,
          s.styleMirror
        ), U = B && B !== -1 || ee && ee !== -1;
        U && e({
          id: B,
          styleId: ee,
          removes: [{ index: H }]
        }), o = !0;
        let D;
        try {
          D = N.apply(Y, T);
        } finally {
          o = !1;
        }
        return U && a(Y, -1), D;
      }
    )
  }), Z = u.CSSStyleSheet.prototype.insertRule;
  let S = p(Z), G = Z;
  u.CSSStyleSheet.prototype.insertRule = S;
  const g = u.CSSStyleSheet.prototype.addRule, y = function(k, N, Y = this.cssRules.length) {
    const T = `${k} { ${N} }`;
    return u.CSSStyleSheet.prototype.insertRule.apply(this, [T, Y]);
  };
  u.CSSStyleSheet.prototype.addRule = y;
  const R = u.CSSStyleSheet.prototype.deleteRule;
  let W = X(R), V = R;
  u.CSSStyleSheet.prototype.deleteRule = W;
  const I = u.CSSStyleSheet.prototype.removeRule, v = function(k) {
    return u.CSSStyleSheet.prototype.deleteRule.apply(this, [k]);
  };
  u.CSSStyleSheet.prototype.removeRule = v;
  let x, P;
  u.CSSStyleSheet.prototype.replace && (x = u.CSSStyleSheet.prototype.replace, P = new Proxy(x, {
    apply: A(
      (k, N, Y) => {
        if (n) return k.apply(N, Y);
        const [T] = Y, { id: H, styleId: B } = Me(
          N,
          t,
          s.styleMirror
        );
        return (H && H !== -1 || B && B !== -1) && e({
          id: H,
          styleId: B,
          replace: T
        }), k.apply(N, Y);
      }
    )
  }), u.CSSStyleSheet.prototype.replace = P);
  let O, w;
  u.CSSStyleSheet.prototype.replaceSync && (O = u.CSSStyleSheet.prototype.replaceSync, w = new Proxy(O, {
    apply: A(
      (k, N, Y) => {
        if (n) return k.apply(N, Y);
        const [T] = Y, { id: H, styleId: B } = Me(
          N,
          t,
          s.styleMirror
        );
        return (H && H !== -1 || B && B !== -1) && e({
          id: H,
          styleId: B,
          replaceSync: T
        }), k.apply(N, Y);
      }
    )
  }), u.CSSStyleSheet.prototype.replaceSync = w);
  const q = {};
  Lt("CSSGroupingRule") ? q.CSSGroupingRule = u.CSSGroupingRule : (Lt("CSSMediaRule") && (q.CSSMediaRule = u.CSSMediaRule), Lt("CSSConditionRule") && (q.CSSConditionRule = u.CSSConditionRule), Lt("CSSSupportsRule") && (q.CSSSupportsRule = u.CSSSupportsRule));
  const J = {}, F = {};
  Object.entries(q).forEach(([k, N]) => {
    J[k] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: N.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: N.prototype.deleteRule
    }, F[k] = {}, F[k].insertRule = new Proxy(
      J[k].insertRule,
      {
        apply: A(
          (Y, T, H) => {
            if (n) return Y.apply(T, H);
            const [B, ee] = H, { id: U, styleId: D } = Me(
              T.parentStyleSheet,
              t,
              s.styleMirror
            );
            return (U && U !== -1 || D && D !== -1) && e({
              id: U,
              styleId: D,
              adds: [
                {
                  rule: B,
                  index: [
                    ...Ft(T),
                    ee || 0
                    // defaults to 0
                  ]
                }
              ]
            }), Y.apply(T, H);
          }
        )
      }
    ), F[k].deleteRule = new Proxy(
      J[k].deleteRule,
      {
        apply: A(
          (Y, T, H) => {
            if (n) return Y.apply(T, H);
            const [B] = H, { id: ee, styleId: U } = Me(
              T.parentStyleSheet,
              t,
              s.styleMirror
            );
            return (ee && ee !== -1 || U && U !== -1) && e({
              id: ee,
              styleId: U,
              removes: [
                { index: [...Ft(T), B] }
              ]
            }), Y.apply(T, H);
          }
        )
      }
    ), N.prototype.insertRule = F[k].insertRule, N.prototype.deleteRule = F[k].deleteRule;
  });
  const _ = () => {
    m = !0, h = !1, d = !1;
    try {
      const k = r != null ? r : r = new u.CSSStyleSheet();
      k.insertRule(":root {}", 0), k.deleteRule(0);
    } catch (k) {
      return {
        insertRule: u.CSSStyleSheet.prototype.insertRule === S,
        deleteRule: u.CSSStyleSheet.prototype.deleteRule === W
      };
    } finally {
      m = !1;
    }
    return {
      insertRule: h,
      deleteRule: d
    };
  };
  let M = 0;
  const Q = (k) => {
    M >= Nc || (M += 1, k.insertRule || (G = u.CSSStyleSheet.prototype.insertRule, S = p(G), u.CSSStyleSheet.prototype.insertRule = S), k.deleteRule || (V = u.CSSStyleSheet.prototype.deleteRule, W = X(V), u.CSSStyleSheet.prototype.deleteRule = W));
  }, ne = (k) => {
    for (let N = 0; N < l.styleSheets.length; N++) {
      const Y = l.styleSheets[N];
      if (b.has(Y)) continue;
      const T = Y.ownerNode;
      if (!T || Ee(T.nodeName) !== "style" || (T.textContent || "").trim().length) continue;
      const H = t.getId(T);
      if (!H || H === -1) continue;
      let B;
      try {
        B = Y.cssRules;
      } catch (D) {
        continue;
      }
      const ee = B.length;
      let U = f.get(Y);
      if (!U) {
        if (Array.from(B).some((D) => An(D))) {
          b.add(Y);
          continue;
        }
        if (U = { reported: ee, everSeen: ee }, f.set(Y, U), k) continue;
        C(H, U, B);
        continue;
      }
      if (U.everSeen = Math.max(U.everSeen, ee), ee !== U.reported)
        if (ee > U.reported) {
          const D = [];
          for (let ue = U.reported; ue < ee; ue++)
            D.push({ rule: B[ue].cssText, index: ue });
          e({ id: H, adds: D }), U.reported = ee;
        } else
          C(H, U, B);
    }
  };
  function C(k, N, Y) {
    const T = [];
    for (let H = N.everSeen - 1; H >= 0; H--)
      T.push({ index: H });
    T.length && e({ id: k, removes: T }), e({
      id: k,
      adds: Array.from(Y, (H, B) => ({
        rule: H.cssText,
        index: B
      }))
    }), N.reported = Y.length, N.everSeen = Y.length;
  }
  let se;
  return c > 0 && (se = u.setInterval(
    A(() => {
      const k = _(), N = k.insertRule && k.deleteRule;
      N || Q(k), ne(N);
    }),
    c
  )), A(() => {
    se !== void 0 && u.clearInterval(se), n = !0;
    const k = u.CSSStyleSheet.prototype;
    Te(
      k,
      "insertRule",
      S,
      G
    ), Te(
      k,
      "deleteRule",
      W,
      V
    ), Te(k, "addRule", y, g), Te(k, "removeRule", v, I), P && Te(k, "replace", P, x), w && Te(k, "replaceSync", w, O), Object.entries(q).forEach(([N, Y]) => {
      Te(
        Y.prototype,
        "insertRule",
        F[N].insertRule,
        J[N].insertRule
      ), Te(
        Y.prototype,
        "deleteRule",
        F[N].deleteRule,
        J[N].deleteRule
      );
    });
  });
}
function Tl({
  mirror: e,
  stylesheetManager: t
}, s) {
  var l, c, u;
  let f = null;
  s.nodeName === "#document" ? f = e.getId(s) : f = e.getId(E.host(s));
  const b = s.nodeName === "#document" ? (l = s.defaultView) == null ? void 0 : l.Document : (u = (c = s.ownerDocument) == null ? void 0 : c.defaultView) == null ? void 0 : u.ShadowRoot, m = b != null && b.prototype ? Object.getOwnPropertyDescriptor(
    b == null ? void 0 : b.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return f === null || f === -1 || !b || !m ? () => {
  } : (Object.defineProperty(s, "adoptedStyleSheets", {
    configurable: m.configurable,
    enumerable: m.enumerable,
    get() {
      var h;
      return (h = m.get) == null ? void 0 : h.call(this);
    },
    set(h) {
      var d;
      const r = (d = m.set) == null ? void 0 : d.call(this, h);
      if (f !== null && f !== -1)
        try {
          t.adoptStyleSheets(h, f);
        } catch (n) {
        }
      return r;
    }
  }), A(() => {
    Object.defineProperty(s, "adoptedStyleSheets", {
      configurable: m.configurable,
      enumerable: m.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: m.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: m.set
    });
  }));
}
function Uc({
  styleDeclarationCb: e,
  mirror: t,
  ignoreCSSAttributes: s,
  stylesheetManager: l
}, { win: c }) {
  const u = c.CSSStyleDeclaration.prototype.setProperty;
  c.CSSStyleDeclaration.prototype.setProperty = new Proxy(u, {
    apply: A(
      (b, m, h) => {
        var d;
        const [r, n, i] = h;
        if (s.has(r))
          return u.apply(m, [r, n, i]);
        const { id: o, styleId: a } = Me(
          (d = m.parentRule) == null ? void 0 : d.parentStyleSheet,
          t,
          l.styleMirror
        );
        return (o && o !== -1 || a && a !== -1) && e({
          id: o,
          styleId: a,
          set: {
            property: r,
            value: n,
            priority: i
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: Ft(m.parentRule)
        }), b.apply(m, h);
      }
    )
  });
  const f = c.CSSStyleDeclaration.prototype.removeProperty;
  return c.CSSStyleDeclaration.prototype.removeProperty = new Proxy(f, {
    apply: A(
      (b, m, h) => {
        var d;
        const [r] = h;
        if (s.has(r))
          return f.apply(m, [r]);
        const { id: n, styleId: i } = Me(
          (d = m.parentRule) == null ? void 0 : d.parentStyleSheet,
          t,
          l.styleMirror
        );
        return (n && n !== -1 || i && i !== -1) && e({
          id: n,
          styleId: i,
          remove: {
            property: r
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: Ft(m.parentRule)
        }), b.apply(m, h);
      }
    )
  }), A(() => {
    c.CSSStyleDeclaration.prototype.setProperty = u, c.CSSStyleDeclaration.prototype.removeProperty = f;
  });
}
function Kc({
  mediaInteractionCb: e,
  blockClass: t,
  blockSelector: s,
  mirror: l,
  sampling: c,
  doc: u
}) {
  const f = A(
    (m) => pt(
      A((h) => {
        const d = Zt(h);
        if (!d || fe(d, t, s, !0))
          return;
        const { currentTime: r, volume: n, muted: i, playbackRate: o, loop: a } = d;
        e({
          type: m,
          id: l.getId(d),
          currentTime: r,
          volume: n,
          muted: i,
          playbackRate: o,
          loop: a
        });
      }),
      c.media || 500
    )
  ), b = [
    Ze("play", f(_e.Play), u),
    Ze("pause", f(_e.Pause), u),
    Ze("seeked", f(_e.Seeked), u),
    Ze("volumechange", f(_e.VolumeChange), u),
    Ze("ratechange", f(_e.RateChange), u)
  ];
  return A(() => {
    b.forEach((m) => m());
  });
}
function Fc({ fontCb: e, doc: t }) {
  const s = t.defaultView;
  if (!s)
    return () => {
    };
  const l = [], c = /* @__PURE__ */ new WeakMap(), u = s.FontFace;
  s.FontFace = function(m, h, d) {
    const r = new u(
      m,
      h,
      d
    );
    return c.set(r, {
      family: m,
      buffer: typeof h != "string",
      descriptors: d,
      fontSource: typeof h == "string" ? h : JSON.stringify(Array.from(new Uint8Array(h)))
    }), r;
  };
  const f = Be(
    t.fonts,
    "add",
    function(b) {
      return function(m) {
        return setTimeout(
          A(() => {
            const h = c.get(m);
            h && (e(h), c.delete(m));
          }),
          0
        ), b.apply(this, [m]);
      };
    }
  );
  return l.push(() => {
    s.FontFace = u;
  }), l.push(f), A(() => {
    l.forEach((b) => b());
  });
}
function Mc(e) {
  const { doc: t, mirror: s, blockClass: l, blockSelector: c, selectionCb: u } = e;
  let f = !0;
  const b = A(() => {
    const m = t.getSelection();
    if (!m || f && (m != null && m.isCollapsed)) return;
    f = m.isCollapsed || !1;
    const h = [], d = m.rangeCount || 0;
    for (let r = 0; r < d; r++) {
      const n = m.getRangeAt(r), { startContainer: i, startOffset: o, endContainer: a, endOffset: p } = n;
      fe(i, l, c, !0) || fe(a, l, c, !0) || h.push({
        start: s.getId(i),
        startOffset: o,
        end: s.getId(a),
        endOffset: p
      });
    }
    u({ ranges: h });
  });
  return b(), Ze("selectionchange", b);
}
function zc({
  doc: e,
  customElementCb: t
}) {
  const s = e.defaultView;
  return !s || !s.customElements ? () => {
  } : Be(
    s.customElements,
    "define",
    function(c) {
      return function(u, f, b) {
        try {
          t({
            define: {
              name: u
            }
          });
        } catch (m) {
          console.warn(`Custom element callback failed for ${u}`);
        }
        return c.apply(this, [u, f, b]);
      };
    }
  );
}
function Hc(e, t) {
  const {
    mutationCb: s,
    mousemoveCb: l,
    mouseInteractionCb: c,
    scrollCb: u,
    viewportResizeCb: f,
    inputCb: b,
    mediaInteractionCb: m,
    styleSheetRuleCb: h,
    styleDeclarationCb: d,
    canvasMutationCb: r,
    fontCb: n,
    selectionCb: i,
    customElementCb: o
  } = e;
  e.mutationCb = (...a) => {
    t.mutation && t.mutation(...a), s(...a);
  }, e.mousemoveCb = (...a) => {
    t.mousemove && t.mousemove(...a), l(...a);
  }, e.mouseInteractionCb = (...a) => {
    t.mouseInteraction && t.mouseInteraction(...a), c(...a);
  }, e.scrollCb = (...a) => {
    t.scroll && t.scroll(...a), u(...a);
  }, e.viewportResizeCb = (...a) => {
    t.viewportResize && t.viewportResize(...a), f(...a);
  }, e.inputCb = (...a) => {
    t.input && t.input(...a), b(...a);
  }, e.mediaInteractionCb = (...a) => {
    t.mediaInteaction && t.mediaInteaction(...a), m(...a);
  }, e.styleSheetRuleCb = (...a) => {
    t.styleSheetRule && t.styleSheetRule(...a), h(...a);
  }, e.styleDeclarationCb = (...a) => {
    t.styleDeclaration && t.styleDeclaration(...a), d(...a);
  }, e.canvasMutationCb = (...a) => {
    t.canvasMutation && t.canvasMutation(...a), r(...a);
  }, e.fontCb = (...a) => {
    t.font && t.font(...a), n(...a);
  }, e.selectionCb = (...a) => {
    t.selection && t.selection(...a), i(...a);
  }, e.customElementCb = (...a) => {
    t.customElement && t.customElement(...a), o(...a);
  };
}
function Oc(e, t = {}) {
  const s = e.doc.defaultView;
  if (!s)
    return () => {
    };
  Hc(e, t);
  let l, c = () => {
  };
  e.recordDOM && ([l, c] = Yl(e, e.doc));
  const u = vc(e), f = Lc(e), b = Nl(e), m = kc(e, {
    win: s
  }), h = Yc(e), d = Kc(e);
  let r = () => {
  }, n = () => {
  }, i = () => {
  }, o = () => {
  };
  e.recordDOM && (r = Tc(e, { win: s }), n = Tl(e, e.doc), i = Uc(e, {
    win: s
  }), e.collectFonts && (o = Fc(e)));
  const a = Mc(e), p = zc(e), X = [];
  for (const Z of e.plugins)
    X.push(
      Z.observer(Z.callback, s, Z.options)
    );
  return A(() => {
    Oe.forEach((Z) => Z.reset()), l == null || l.disconnect(), c(), u(), f(), b(), m(), h(), d(), r(), n(), i(), o(), a(), p(), X.forEach((Z) => Z());
  });
}
function vt(e) {
  return typeof window[e] != "undefined";
}
function Lt(e) {
  return !!(typeof window[e] != "undefined" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class wn {
  constructor(t) {
    L(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap()), L(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap()), this.generateIdFn = t;
  }
  getId(t, s, l, c) {
    const u = l || this.getIdToRemoteIdMap(t), f = c || this.getRemoteIdToIdMap(t);
    let b = u.get(s);
    return b || (b = this.generateIdFn(), u.set(s, b), f.set(b, s)), b;
  }
  getIds(t, s) {
    const l = this.getIdToRemoteIdMap(t), c = this.getRemoteIdToIdMap(t);
    return s.map(
      (u) => this.getId(t, u, l, c)
    );
  }
  getRemoteId(t, s, l) {
    const c = l || this.getRemoteIdToIdMap(t);
    if (typeof s != "number") return s;
    const u = c.get(s);
    return u || -1;
  }
  getRemoteIds(t, s) {
    const l = this.getRemoteIdToIdMap(t);
    return s.map((c) => this.getRemoteId(t, c, l));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let s = this.iframeIdToRemoteIdMap.get(t);
    return s || (s = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, s)), s;
  }
  getRemoteIdToIdMap(t) {
    let s = this.iframeRemoteIdToIdMap.get(t);
    return s || (s = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, s)), s;
  }
}
class Pc {
  constructor(t) {
    L(this, "iframes", /* @__PURE__ */ new WeakMap()), L(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap()), L(this, "crossOriginIframeMirror", new wn(tl)), L(this, "crossOriginIframeStyleMirror"), L(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap()), L(this, "mirror"), L(this, "mutationCb"), L(this, "wrappedEmit"), L(this, "loadListener"), L(this, "stylesheetManager"), L(this, "recordCrossOriginIframes"), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new wn(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, s) {
    var l, c;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: s
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((l = t.contentWindow) == null || l.addEventListener(
      "message",
      this.handleMessage.bind(this)
    )), (c = this.loadListener) == null || c.call(this, t), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      t.contentDocument.adoptedStyleSheets,
      this.mirror.getId(t.contentDocument)
    );
  }
  handleMessage(t) {
    const s = t;
    if (s.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    s.origin !== s.data.origin)
      return;
    const l = t.source;
    if (!l) return;
    const c = this.crossOriginIframeMap.get(l);
    if (!c) return;
    const u = this.transformCrossOriginEvent(
      c,
      s.data.event
    );
    u && this.wrappedEmit(
      u,
      s.data.isCheckout
    );
  }
  transformCrossOriginEvent(t, s) {
    var l;
    switch (s.type) {
      case $.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(s.data.node, t);
        const c = s.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, c), this.patchRootIdOnNode(s.data.node, c), {
          timestamp: s.timestamp,
          type: $.IncrementalSnapshot,
          data: {
            source: j.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: s.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case $.Meta:
      case $.Load:
      case $.DomContentLoaded:
        return !1;
      case $.Plugin:
        return s;
      case $.Custom:
        return this.replaceIds(
          s.data.payload,
          t,
          ["id", "parentId", "previousId", "nextId"]
        ), s;
      case $.IncrementalSnapshot:
        switch (s.data.source) {
          case j.Mutation:
            return s.data.adds.forEach((c) => {
              this.replaceIds(c, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(c.node, t);
              const u = this.crossOriginIframeRootIdMap.get(t);
              u && this.patchRootIdOnNode(c.node, u);
            }), s.data.removes.forEach((c) => {
              this.replaceIds(c, t, ["parentId", "id"]);
            }), s.data.attributes.forEach((c) => {
              this.replaceIds(c, t, ["id"]);
            }), s.data.texts.forEach((c) => {
              this.replaceIds(c, t, ["id"]);
            }), s;
          case j.Drag:
          case j.TouchMove:
          case j.MouseMove:
            return s.data.positions.forEach((c) => {
              this.replaceIds(c, t, ["id"]);
            }), s;
          case j.ViewportResize:
            return !1;
          case j.MediaInteraction:
          case j.MouseInteraction:
          case j.Scroll:
          case j.CanvasMutation:
          case j.Input:
            return this.replaceIds(s.data, t, ["id"]), s;
          case j.StyleSheetRule:
          case j.StyleDeclaration:
            return this.replaceIds(s.data, t, ["id"]), this.replaceStyleIds(s.data, t, ["styleId"]), s;
          case j.Font:
            return s;
          case j.Selection:
            return s.data.ranges.forEach((c) => {
              this.replaceIds(c, t, ["start", "end"]);
            }), s;
          case j.AdoptedStyleSheet:
            return this.replaceIds(s.data, t, ["id"]), this.replaceStyleIds(s.data, t, ["styleIds"]), (l = s.data.styles) == null || l.forEach((c) => {
              this.replaceStyleIds(c, t, ["styleId"]);
            }), s;
        }
    }
    return !1;
  }
  replace(t, s, l, c) {
    for (const u of c)
      !Array.isArray(s[u]) && typeof s[u] != "number" || (Array.isArray(s[u]) ? s[u] = t.getIds(
        l,
        s[u]
      ) : s[u] = t.getId(l, s[u]));
    return s;
  }
  replaceIds(t, s, l) {
    return this.replace(this.crossOriginIframeMirror, t, s, l);
  }
  replaceStyleIds(t, s, l) {
    return this.replace(this.crossOriginIframeStyleMirror, t, s, l);
  }
  replaceIdOnNode(t, s) {
    this.replaceIds(t, s, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((l) => {
      this.replaceIdOnNode(l, s);
    });
  }
  patchRootIdOnNode(t, s) {
    t.type !== kl.Document && !t.rootId && (t.rootId = s), "childNodes" in t && t.childNodes.forEach((l) => {
      this.patchRootIdOnNode(l, s);
    });
  }
}
class Ec {
  constructor(t) {
    L(this, "shadowDoms", /* @__PURE__ */ new WeakSet()), L(this, "mutationCb"), L(this, "scrollCb"), L(this, "bypassOptions"), L(this, "mirror"), L(this, "restoreHandlers", []), this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, s) {
    if (!ot(t) || this.shadowDoms.has(t)) return;
    this.shadowDoms.add(t);
    const [l] = Yl(
      he(K({}, this.bypassOptions), {
        doc: s,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }),
      t
    );
    this.restoreHandlers.push(() => l.disconnect()), this.restoreHandlers.push(
      Nl(he(K({}, this.bypassOptions), {
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: t,
        mirror: this.mirror
      }))
    ), setTimeout(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        t.adoptedStyleSheets,
        this.mirror.getId(E.host(t))
      ), this.restoreHandlers.push(
        Tl(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          t
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(
      t.contentWindow.Element,
      t.contentDocument
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(t, s) {
    const l = this;
    this.restoreHandlers.push(
      Be(
        t.prototype,
        "attachShadow",
        function(c) {
          return function(u) {
            const f = c.call(this, u), b = E.shadowRoot(this);
            return b && Ll(this) && l.addShadowRoot(b, s), f;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch (s) {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
var et = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Qc = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var kt = 0; kt < et.length; kt++)
  Qc[et.charCodeAt(kt)] = kt;
var Bc = function(e) {
  var t = new Uint8Array(e), s, l = t.length, c = "";
  for (s = 0; s < l; s += 3)
    c += et[t[s] >> 2], c += et[(t[s] & 3) << 4 | t[s + 1] >> 4], c += et[(t[s + 1] & 15) << 2 | t[s + 2] >> 6], c += et[t[s + 2] & 63];
  return l % 3 === 2 ? c = c.substring(0, c.length - 1) + "=" : l % 3 === 1 && (c = c.substring(0, c.length - 2) + "=="), c;
};
const Cn = /* @__PURE__ */ new Map();
function Dc(e, t) {
  let s = Cn.get(e);
  return s || (s = /* @__PURE__ */ new Map(), Cn.set(e, s)), s.has(t) || s.set(t, []), s.get(t);
}
const Ul = (e, t, s) => {
  if (!e || !(Fl(e, t) || typeof e == "object"))
    return;
  const l = e.constructor.name, c = Dc(s, l);
  let u = c.indexOf(e);
  return u === -1 && (u = c.length, c.push(e)), u;
};
function Jt(e, t, s) {
  if (e instanceof Array)
    return e.map((l) => Jt(l, t, s));
  if (e === null)
    return e;
  if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray)
    return {
      rr_type: e.constructor.name,
      args: [Object.values(e)]
    };
  if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    e instanceof ArrayBuffer
  ) {
    const l = e.constructor.name, c = Bc(e);
    return {
      rr_type: l,
      base64: c
    };
  } else {
    if (e instanceof DataView)
      return {
        rr_type: e.constructor.name,
        args: [
          Jt(e.buffer, t, s),
          e.byteOffset,
          e.byteLength
        ]
      };
    if (e instanceof HTMLImageElement) {
      const l = e.constructor.name, { src: c } = e;
      return {
        rr_type: l,
        src: c
      };
    } else if (e instanceof HTMLCanvasElement) {
      const l = "HTMLImageElement", c = e.toDataURL();
      return {
        rr_type: l,
        src: c
      };
    } else {
      if (e instanceof ImageData)
        return {
          rr_type: e.constructor.name,
          args: [Jt(e.data, t, s), e.width, e.height]
        };
      if (Fl(e, t) || typeof e == "object") {
        const l = e.constructor.name, c = Ul(e, t, s);
        return {
          rr_type: l,
          index: c
        };
      }
    }
  }
  return e;
}
const Kl = (e, t, s) => e.map((l) => Jt(l, t, s)), Fl = (e, t) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"
].filter(
  (c) => typeof t[c] == "function"
).find(
  (c) => e instanceof t[c]
);
function jc(e, t, s, l) {
  const c = [], u = Object.getOwnPropertyNames(
    t.CanvasRenderingContext2D.prototype
  );
  for (const f of u)
    try {
      if (typeof t.CanvasRenderingContext2D.prototype[f] != "function")
        continue;
      const b = Be(
        t.CanvasRenderingContext2D.prototype,
        f,
        function(m) {
          return function(...h) {
            return fe(this.canvas, s, l, !0) || setTimeout(() => {
              const d = Kl(h, t, this);
              e(this.canvas, {
                type: tt["2D"],
                property: f,
                args: d
              });
            }, 0), m.apply(this, h);
          };
        }
      );
      c.push(b);
    } catch (b) {
      const m = ei(
        t.CanvasRenderingContext2D.prototype,
        f,
        {
          set(h) {
            e(this.canvas, {
              type: tt["2D"],
              property: f,
              args: [h],
              setter: !0
            });
          }
        }
      );
      c.push(m);
    }
  return () => {
    c.forEach((f) => f());
  };
}
function Ac(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function xn(e, t, s, l) {
  const c = [];
  try {
    const u = Be(
      e.HTMLCanvasElement.prototype,
      "getContext",
      function(f) {
        return function(b, ...m) {
          if (!fe(this, t, s, !0)) {
            const h = Ac(b);
            if ("__context" in this || (this.__context = h), l && ["webgl", "webgl2"].includes(h))
              if (m[0] && typeof m[0] == "object") {
                const d = m[0];
                d.preserveDrawingBuffer || (d.preserveDrawingBuffer = !0);
              } else
                m.splice(0, 1, {
                  preserveDrawingBuffer: !0
                });
          }
          return f.apply(this, [b, ...m]);
        };
      }
    );
    c.push(u);
  } catch (u) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    c.forEach((u) => u());
  };
}
function vn(e, t, s, l, c, u) {
  const f = [], b = Object.getOwnPropertyNames(e);
  for (const m of b)
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      ![
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(m)
    )
      try {
        if (typeof e[m] != "function")
          continue;
        const h = Be(
          e,
          m,
          function(d) {
            return function(...r) {
              const n = d.apply(this, r);
              if (Ul(n, u, this), "tagName" in this.canvas && !fe(this.canvas, l, c, !0)) {
                const i = Kl(r, u, this), o = {
                  type: t,
                  property: m,
                  args: i
                };
                s(this.canvas, o);
              }
              return n;
            };
          }
        );
        f.push(h);
      } catch (h) {
        const d = ei(e, m, {
          set(r) {
            s(this.canvas, {
              type: t,
              property: m,
              args: [r],
              setter: !0
            });
          }
        });
        f.push(d);
      }
  return f;
}
function _c(e, t, s, l) {
  const c = [];
  return typeof t.WebGLRenderingContext != "undefined" && c.push(
    ...vn(
      t.WebGLRenderingContext.prototype,
      tt.WebGL,
      e,
      s,
      l,
      t
    )
  ), typeof t.WebGL2RenderingContext != "undefined" && c.push(
    ...vn(
      t.WebGL2RenderingContext.prototype,
      tt.WebGL2,
      e,
      s,
      l,
      t
    )
  ), () => {
    c.forEach((u) => u());
  };
}
const Ml = `(function() {
  "use strict";
  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }
  var encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for (i2 = 0; i2 < len; i2 += 3) {
      base64 += chars[bytes[i2] >> 2];
      base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
      base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
      base64 += chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }
    return base64;
  };
  const lastBlobMap = /* @__PURE__ */ new Map();
  const transparentBlobMap = /* @__PURE__ */ new Map();
  async function getTransparentBlobFor(width, height, dataURLOptions) {
    const id = \`\${width}-\${height}\`;
    if ("OffscreenCanvas" in globalThis) {
      if (transparentBlobMap.has(id)) return transparentBlobMap.get(id);
      const offscreen = new OffscreenCanvas(width, height);
      offscreen.getContext("2d");
      const blob = await offscreen.convertToBlob(dataURLOptions);
      const arrayBuffer = await blob.arrayBuffer();
      const base64 = encode(arrayBuffer);
      transparentBlobMap.set(id, base64);
      return base64;
    } else {
      return "";
    }
  }
  const worker = self;
  let logDebug = false;
  const debug = (...args) => {
    if (logDebug) {
      console.debug(...args);
    }
  };
  worker.onmessage = async function(e) {
    logDebug = !!e.data.logDebug;
    if ("OffscreenCanvas" in globalThis) {
      const { id, bitmap, width, height, dx, dy, dw, dh, dataURLOptions } = e.data;
      const transparentBase64 = getTransparentBlobFor(
        width,
        height,
        dataURLOptions
      );
      const offscreen = new OffscreenCanvas(width, height);
      const ctx = offscreen.getContext("2d");
      ctx.drawImage(bitmap, 0, 0, width, height);
      bitmap.close();
      const blob = await offscreen.convertToBlob(dataURLOptions);
      const type = blob.type;
      const arrayBuffer = await blob.arrayBuffer();
      const base64 = encode(arrayBuffer);
      if (!lastBlobMap.has(id) && await transparentBase64 === base64) {
        debug("[highlight-worker] canvas bitmap is transparent", {
          id,
          base64
        });
        lastBlobMap.set(id, base64);
        return worker.postMessage({ id, status: "transparent" });
      }
      if (lastBlobMap.get(id) === base64) {
        debug("[highlight-worker] canvas bitmap is unchanged", {
          id,
          base64
        });
      }
      const msg = {
        id,
        type,
        base64,
        width,
        height,
        dx,
        dy,
        dw,
        dh
      };
      debug("[highlight-worker] canvas bitmap processed", msg);
      worker.postMessage(msg);
      lastBlobMap.set(id, base64);
    } else {
      debug("[highlight-worker] no offscreencanvas support", {
        id: e.data.id
      });
      return worker.postMessage({ id: e.data.id, status: "unsupported" });
    }
  };
})();
//# sourceMappingURL=image-bitmap-data-url-worker-DwtK8A0z.js.map
`, Ln = typeof self != "undefined" && self.Blob && new Blob([Ml], { type: "text/javascript;charset=utf-8" });
function $c(e) {
  let t;
  try {
    if (t = Ln && (self.URL || self.webkitURL).createObjectURL(Ln), !t) throw "";
    const s = new Worker(t, {
      name: e == null ? void 0 : e.name
    });
    return s.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), s;
  } catch (s) {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(Ml),
      {
        name: e == null ? void 0 : e.name
      }
    );
  } finally {
    t && (self.URL || self.webkitURL).revokeObjectURL(t);
  }
}
class qc {
  constructor(t) {
    L(this, "pendingCanvasMutations", /* @__PURE__ */ new Map()), L(this, "rafStamps", { latestId: 0, invokeId: null }), L(this, "mirror"), L(this, "logger"), L(this, "worker"), L(this, "snapshotInProgressMap", /* @__PURE__ */ new Map()), L(this, "lastSnapshotTime", /* @__PURE__ */ new Map()), L(this, "options"), L(this, "mutationCb"), L(this, "resetObservers"), L(this, "frozen", !1), L(this, "locked", !1), L(this, "processMutation", (r, n) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(r) || this.pendingCanvasMutations.set(r, []), this.pendingCanvasMutations.get(r).push(n);
    });
    const {
      sampling: s,
      win: l,
      blockClass: c,
      blockSelector: u,
      recordCanvas: f,
      recordLocalVideos: b,
      recordRemoteVideos: m,
      initialSnapshotDelay: h,
      dataURLOptions: d
    } = t;
    this.mutationCb = t.mutationCb, this.mirror = t.mirror, this.logger = t.logger, this.worker = new $c(), this.worker.onmessage = (r) => {
      const { id: n } = r.data;
      if (this.snapshotInProgressMap.set(n, !1), !("base64" in r.data)) {
        this.debug(null, "canvas worker received empty message", {
          id: n,
          data: r.data,
          status: r.data.status
        });
        return;
      }
      const { base64: i, type: o, dx: a, dy: p, dw: X, dh: Z } = r.data, S = {
        id: n,
        type: tt["2D"],
        commands: [
          {
            property: "clearRect",
            // wipe canvas
            args: [a, p, X, Z]
          },
          {
            property: "drawImage",
            // draws (semi-transparent) image
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: i }],
                    type: o
                  }
                ]
              },
              a,
              p,
              X,
              Z
            ]
          }
        ]
      };
      this.debug(null, "canvas worker recording mutation", S), this.mutationCb(S);
    }, this.options = t, f && s === "all" ? (this.debug(null, "initializing canvas mutation observer", { sampling: s }), this.initCanvasMutationObserver(l, c, u)) : f && typeof s == "number" && (this.debug(null, "initializing canvas fps observer", { sampling: s }), this.initCanvasFPSObserver(
      b,
      m,
      s,
      l,
      c,
      u,
      {
        initialSnapshotDelay: h,
        dataURLOptions: d
      },
      t.resizeFactor,
      t.maxSnapshotDimension
    ));
  }
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  debug(t, ...s) {
    if (!this.logger) return;
    const l = this.mirror.getId(t);
    let c = "[highlight-canvas-manager]";
    t && (c = `[highlight-canvas] [id:${l}]`, t.tagName.toLowerCase() === "canvas" && (c += ` [ctx:${t.__context}]`)), this.logger.debug(c, t, ...s);
  }
  snapshot(t) {
    return pe(this, null, function* () {
      var s;
      const l = this.mirror.getId(t);
      if (this.snapshotInProgressMap.get(l)) {
        this.debug(t, "snapshotting already in progress for", l);
        return;
      }
      const c = 1e3 / (typeof this.options.samplingManual == "number" ? this.options.samplingManual : 1), u = this.lastSnapshotTime.get(l);
      if (!(u && (/* @__PURE__ */ new Date()).getTime() - u < c)) {
        if (this.debug(t, "starting snapshotting"), t.width === 0 || t.height === 0) {
          this.debug(t, "not yet ready", {
            width: t.width,
            height: t.height
          });
          return;
        }
        this.lastSnapshotTime.set(l, (/* @__PURE__ */ new Date()).getTime()), this.snapshotInProgressMap.set(l, !0);
        try {
          if (this.options.clearWebGLBuffer !== !1 && ["webgl", "webgl2"].includes(t.__context)) {
            const d = t.getContext(t.__context);
            ((s = d == null ? void 0 : d.getContextAttributes()) == null ? void 0 : s.preserveDrawingBuffer) === !1 && (d.clear(d.COLOR_BUFFER_BIT), this.debug(t, "cleared webgl canvas to load it into memory", {
              attributes: d == null ? void 0 : d.getContextAttributes()
            }));
          }
          if (t.width === 0 || t.height === 0) {
            this.debug(t, "not yet ready", {
              width: t.width,
              height: t.height
            });
            return;
          }
          let f = this.options.resizeFactor || 1;
          if (this.options.maxSnapshotDimension) {
            const d = Math.max(t.width, t.height);
            f = Math.min(f, this.options.maxSnapshotDimension / d);
          }
          const b = t.width * f, m = t.height * f, h = yield createImageBitmap(t, {
            resizeWidth: b,
            resizeHeight: m
          });
          this.debug(t, "created image bitmap", {
            width: h.width,
            height: h.height
          }), this.worker.postMessage(
            {
              id: l,
              bitmap: h,
              width: b,
              height: m,
              dx: 0,
              dy: 0,
              dw: t.width,
              dh: t.height,
              dataURLOptions: this.options.dataURLOptions,
              logDebug: !!this.logger
            },
            [h]
          ), this.debug(t, "sent message");
        } catch (f) {
          this.debug(t, "failed to snapshot", f);
        } finally {
          this.snapshotInProgressMap.set(l, !1);
        }
      }
    });
  }
  initCanvasFPSObserver(t, s, l, c, u, f, b, m, h) {
    const d = xn(
      c,
      u,
      f,
      !0
    ), r = 1e3 / l;
    let n = 0, i;
    const o = /* @__PURE__ */ new Map(), a = (S, G) => {
      const g = [];
      S.querySelectorAll(G).forEach((W) => g.push(W));
      const y = document.createNodeIterator(S, Node.ELEMENT_NODE);
      let R;
      for (; R = y.nextNode(); )
        R != null && R.shadowRoot && g.push(...a(R.shadowRoot, G));
      return g;
    }, p = (S) => {
      const G = [];
      return a(c.document, "canvas").forEach((g) => {
        if (!fe(g, u, f, !0)) {
          this.debug(g, "discovered canvas"), G.push(g);
          const y = this.mirror.getId(g);
          o.has(y) || o.set(y, S);
        }
      }), G;
    }, X = (S) => {
      const G = [];
      return (t || s) && a(c.document, "video").forEach((g) => {
        if (!(!s && g.src !== "" && g.src.indexOf("blob:") === -1) && !(!t && (g.src === "" || g.src.indexOf("blob:") !== -1)) && !fe(g, u, f, !0)) {
          G.push(g);
          const y = this.mirror.getId(g);
          o.has(y) || o.set(y, S);
        }
      }), G;
    }, Z = (S) => pe(this, null, function* () {
      if (n && S - n < r) {
        i = requestAnimationFrame((y) => void Z(y));
        return;
      }
      n = S;
      const G = (y) => {
        const R = this.mirror.getId(y), W = o.get(R), V = !b.initialSnapshotDelay || S - W > b.initialSnapshotDelay;
        return this.debug(y, {
          delay: b.initialSnapshotDelay,
          delta: S - W,
          hadLoadingTime: V
        }), V;
      }, g = [];
      g.push(
        ...p(S).filter(G).map((y) => this.snapshot(y))
      ), g.push(
        ...X(S).filter(G).map((y) => pe(this, null, function* () {
          this.debug(y, "starting video snapshotting");
          const R = this.mirror.getId(y);
          if (this.snapshotInProgressMap.get(R)) {
            this.debug(
              y,
              "video snapshotting already in progress for",
              R
            );
            return;
          }
          this.snapshotInProgressMap.set(R, !0);
          try {
            const { width: W, height: V } = y.getBoundingClientRect(), { actualWidth: I, actualHeight: v } = {
              actualWidth: y.videoWidth,
              actualHeight: y.videoHeight
            }, x = Math.max(I, v);
            if (x === 0) {
              this.debug(y, "not yet ready", {
                width: y.width,
                height: y.height,
                actualWidth: I,
                actualHeight: v,
                boxWidth: W,
                boxHeight: V
              });
              return;
            }
            let P = m || 1;
            h && (P = Math.min(P, h / x));
            const O = I * P, w = v * P, q = yield createImageBitmap(y, {
              resizeWidth: O,
              resizeHeight: w
            }), J = Math.max(W, V) / x, F = I * J, _ = v * J, M = (W - F) / 2, Q = (V - _) / 2;
            this.debug(y, "created image bitmap", {
              actualWidth: I,
              actualHeight: v,
              boxWidth: W,
              boxHeight: V,
              outputWidth: F,
              outputHeight: _,
              resizeWidth: O,
              resizeHeight: w,
              scale: P,
              outputScale: J,
              offsetX: M,
              offsetY: Q
            }), this.worker.postMessage(
              {
                id: R,
                bitmap: q,
                width: O,
                height: w,
                dx: M,
                dy: Q,
                dw: F,
                dh: _,
                dataURLOptions: b.dataURLOptions,
                logDebug: !!this.logger
              },
              [q]
            ), this.debug(y, "send message");
          } catch (W) {
            this.debug(y, "failed to snapshot", W);
          } finally {
            this.snapshotInProgressMap.set(R, !1);
          }
        }))
      ), yield Promise.all(g).catch(console.error), i = requestAnimationFrame((y) => void Z(y));
    });
    i = requestAnimationFrame((S) => void Z(S)), this.resetObservers = () => {
      d(), i && cancelAnimationFrame(i);
    };
  }
  initCanvasMutationObserver(t, s, l) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const c = xn(
      t,
      s,
      l,
      !1
    ), u = jc(
      this.processMutation.bind(this),
      t,
      s,
      l
    ), f = _c(
      this.processMutation.bind(this),
      t,
      s,
      l
    );
    this.resetObservers = () => {
      c(), u(), f();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const t = (s) => {
      this.rafStamps.latestId = s, requestAnimationFrame(t);
    };
    requestAnimationFrame(t);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach(
      (t, s) => {
        const l = this.mirror.getId(s);
        this.flushPendingCanvasMutationFor(s, l);
      }
    ), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(t, s) {
    if (this.frozen || this.locked)
      return;
    const l = this.pendingCanvasMutations.get(t);
    if (!l || s === -1) return;
    const c = l.map((f) => {
      const h = f, { type: b } = h;
      return it(h, ["type"]);
    }), { type: u } = l[0];
    this.mutationCb({ id: s, type: u, commands: c }), this.pendingCanvasMutations.delete(t);
  }
}
class eu {
  constructor(t) {
    L(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet()), L(this, "mutationCb"), L(this, "adoptedStyleSheetCb"), L(this, "styleMirror", new Xc()), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, s) {
    "_cssText" in s.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: s.id,
          attributes: s.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, s) {
    if (t.length === 0) return;
    const l = {
      id: s,
      styleIds: []
    }, c = [];
    for (const u of t) {
      let f;
      this.styleMirror.has(u) ? f = this.styleMirror.getId(u) : (f = this.styleMirror.add(u), c.push({
        styleId: f,
        rules: Array.from(u.rules || CSSRule, (b, m) => ({
          rule: jn(b, u.href),
          index: m
        }))
      })), l.styleIds.push(f);
    }
    c.length > 0 && (l.styles = c), this.adoptedStyleSheetCb(l);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(t) {
  }
}
class tu {
  constructor() {
    L(this, "nodeMap", /* @__PURE__ */ new WeakMap()), L(this, "active", !1);
  }
  inOtherBuffer(t, s) {
    const l = this.nodeMap.get(t);
    return l && Array.from(l).some((c) => c !== s);
  }
  add(t, s) {
    this.active || (this.active = !0, requestAnimationFrame(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(s));
  }
  destroy() {
  }
}
let ce, Yt, ct, Mt = !1;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = ((ir = e.contentWindow) == null ? void 0 : ir.Array.from) || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
const We = ia();
function Je(e = {}) {
  var t;
  const {
    emit: s,
    checkoutEveryNms: l,
    checkoutEveryNth: c,
    blockClass: u = "highlight-block",
    blockSelector: f = null,
    ignoreClass: b = "highlight-ignore",
    ignoreSelector: m = null,
    maskTextClass: h = "highlight-mask",
    maskTextSelector: d = null,
    inlineStylesheet: r = !0,
    maskAllInputs: n,
    maskInputOptions: i,
    slimDOMOptions: o,
    maskInputFn: a,
    maskTextFn: p = Vs,
    hooks: X,
    packFn: Z,
    sampling: S = {},
    mousemoveWait: G,
    recordDOM: g = !0,
    recordCanvas: y = !1,
    recordCrossOriginIframes: R = !1,
    recordAfter: W = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load",
    userTriggeredOnInput: V = !1,
    collectFonts: I = !1,
    inlineImages: v = !1,
    inlineVideos: x = !1,
    plugins: P,
    keepIframeSrcFn: O = () => !1,
    privacySetting: w = "default",
    ignoreCSSAttributes: q = /* @__PURE__ */ new Set([]),
    styleSheetResyncInterval: J = 2e3,
    errorHandler: F,
    logger: _
  } = e, M = K(K({}, e.dataURLOptions), typeof ((t = e.sampling) == null ? void 0 : t.canvas) == "object" ? e.sampling.canvas.dataURLOptions : void 0);
  Cc(F);
  const Q = R ? window.parent === window : !0;
  let ne = !1;
  if (!Q)
    try {
      window.parent.document && (ne = !1);
    } catch (te) {
      ne = !0;
    }
  if (Q && !s)
    throw new Error("emit function is required");
  if (!Q && !ne)
    return () => {
    };
  G !== void 0 && S.mousemove === void 0 && (S.mousemove = G), We.reset();
  const C = n === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : i !== void 0 ? i : { password: !0 }, se = nl(o);
  Sc();
  let k, N = 0;
  const Y = (te) => {
    for (const Ve of P || [])
      Ve.eventProcessor && (te = Ve.eventProcessor(te));
    return Z && // Disable packing events which will be emitted to parent frames.
    !ne && (te = Z(te)), te;
  };
  ce = (te, Ve) => {
    var oe;
    const ae = te;
    if (ae.timestamp = ht(), (oe = Oe[0]) != null && oe.isFrozen() && ae.type !== $.FullSnapshot && !(ae.type === $.IncrementalSnapshot && ae.data.source === j.Mutation) && Oe.forEach((Se) => Se.unfreeze()), Q)
      s == null || s(Y(ae), Ve);
    else if (ne) {
      const Se = {
        type: "rrweb",
        event: Y(ae),
        origin: window.location.origin,
        isCheckout: Ve
      };
      window.parent.postMessage(Se, "*");
    }
    if (ae.type === $.FullSnapshot)
      k = ae, N = 0;
    else if (ae.type === $.IncrementalSnapshot) {
      if (ae.data.source === j.Mutation && ae.data.isAttachIframe)
        return;
      N++;
      const Se = c && N >= c, ie = l && ae.timestamp - k.timestamp > l;
      (Se || ie) && Yt(!0);
    }
  };
  const T = (te) => {
    ce({
      type: $.IncrementalSnapshot,
      data: K({
        source: j.Mutation
      }, te)
    });
  }, H = (te) => ce({
    type: $.IncrementalSnapshot,
    data: K({
      source: j.Scroll
    }, te)
  }), B = (te) => ce({
    type: $.IncrementalSnapshot,
    data: K({
      source: j.CanvasMutation
    }, te)
  }), ee = (te) => ce({
    type: $.IncrementalSnapshot,
    data: K({
      source: j.AdoptedStyleSheet
    }, te)
  }), U = new eu({
    mutationCb: T,
    adoptedStyleSheetCb: ee
  }), D = new Pc({
    mirror: We,
    mutationCb: T,
    stylesheetManager: U,
    recordCrossOriginIframes: R,
    wrappedEmit: ce
  });
  for (const te of P || [])
    te.getMirror && te.getMirror({
      nodeMirror: We,
      crossOriginIframeMirror: D.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: D.crossOriginIframeStyleMirror
    });
  const ue = new tu(), De = typeof (S == null ? void 0 : S.canvas) == "object" ? S.canvas : { fps: S == null ? void 0 : S.canvas };
  ct = new qc({
    recordCanvas: y,
    recordLocalVideos: v,
    recordRemoteVideos: x,
    mutationCb: B,
    win: window,
    blockClass: u,
    blockSelector: f,
    mirror: We,
    sampling: De.fps,
    samplingManual: De.fpsManual,
    clearWebGLBuffer: De.clearWebGLBuffer,
    initialSnapshotDelay: De.initialSnapshotDelay,
    dataURLOptions: M,
    resizeFactor: De.resizeFactor,
    maxSnapshotDimension: De.maxSnapshotDimension,
    logger: _
  });
  const gt = new Ec({
    mutationCb: T,
    scrollCb: H,
    bypassOptions: {
      blockClass: u,
      blockSelector: f,
      maskTextClass: h,
      maskTextSelector: d,
      inlineStylesheet: r,
      maskInputOptions: C,
      dataURLOptions: M,
      maskTextFn: p,
      maskInputFn: a,
      recordCanvas: y,
      inlineImages: v,
      inlineVideos: x,
      privacySetting: w,
      sampling: S,
      slimDOMOptions: se,
      iframeManager: D,
      stylesheetManager: U,
      canvasManager: ct,
      keepIframeSrcFn: O,
      processedNodeManager: ue
    },
    mirror: We
  });
  Yt = (te = !1) => {
    if (!g)
      return;
    ce(
      {
        type: $.Meta,
        data: {
          href: window.location.href,
          width: Wl(),
          height: Vl()
        }
      },
      te
    ), U.reset(), gt.init(), Oe.forEach((oe) => oe.lock());
    const Ve = Ja(document, {
      mirror: We,
      blockClass: u,
      blockSelector: f,
      maskTextClass: h,
      maskTextSelector: d,
      inlineStylesheet: r,
      maskAllInputs: C,
      maskTextFn: p,
      maskInputFn: a,
      slimDOM: se,
      dataURLOptions: M,
      recordCanvas: y,
      inlineImages: v,
      inlineVideos: x,
      privacySetting: w,
      onSerialize: (oe) => {
        Cl(oe, We) && D.addIframe(oe), xl(oe, We) && U.trackLinkElement(oe), ys(oe) && gt.addShadowRoot(E.shadowRoot(oe), document);
      },
      onIframeLoad: (oe, ae) => {
        D.attachIframe(oe, ae), gt.observeAttachShadow(oe);
      },
      onStylesheetLoad: (oe, ae) => {
        U.attachLinkElement(oe, ae);
      },
      keepIframeSrcFn: O
    });
    if (!Ve)
      return console.warn("Failed to snapshot the document");
    ce(
      {
        type: $.FullSnapshot,
        data: {
          node: Ve,
          initialOffset: Gl(window)
        }
      },
      te
    ), Oe.forEach((oe) => oe.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && U.adoptStyleSheets(
      document.adoptedStyleSheets,
      We.getId(document)
    );
  };
  try {
    const te = [], Ve = (ae) => {
      var Se;
      return A(Oc)(
        {
          mutationCb: T,
          mousemoveCb: (ie, ti) => ce({
            type: $.IncrementalSnapshot,
            data: {
              source: ti,
              positions: ie
            }
          }),
          mouseInteractionCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.MouseInteraction
            }, ie)
          }),
          scrollCb: H,
          viewportResizeCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.ViewportResize
            }, ie)
          }),
          inputCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.Input
            }, ie)
          }),
          mediaInteractionCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.MediaInteraction
            }, ie)
          }),
          styleSheetRuleCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.StyleSheetRule
            }, ie)
          }),
          styleDeclarationCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.StyleDeclaration
            }, ie)
          }),
          canvasMutationCb: B,
          fontCb: (ie) => ce({
            type: $.IncrementalSnapshot,
            data: K({
              source: j.Font
            }, ie)
          }),
          selectionCb: (ie) => {
            ce({
              type: $.IncrementalSnapshot,
              data: K({
                source: j.Selection
              }, ie)
            });
          },
          customElementCb: (ie) => {
            ce({
              type: $.IncrementalSnapshot,
              data: K({
                source: j.CustomElement
              }, ie)
            });
          },
          blockClass: u,
          ignoreClass: b,
          ignoreSelector: m,
          maskTextClass: h,
          maskTextSelector: d,
          maskInputOptions: C,
          inlineStylesheet: r,
          sampling: S,
          recordDOM: g,
          recordCanvas: y,
          inlineImages: v,
          inlineVideos: x,
          userTriggeredOnInput: V,
          collectFonts: I,
          doc: ae,
          maskInputFn: a,
          maskTextFn: p,
          keepIframeSrcFn: O,
          blockSelector: f,
          slimDOMOptions: se,
          dataURLOptions: M,
          mirror: We,
          iframeManager: D,
          stylesheetManager: U,
          shadowDomManager: gt,
          processedNodeManager: ue,
          canvasManager: ct,
          ignoreCSSAttributes: q,
          styleSheetResyncInterval: J,
          privacySetting: w,
          plugins: ((Se = P == null ? void 0 : P.filter((ie) => ie.observer)) == null ? void 0 : Se.map((ie) => ({
            observer: ie.observer,
            options: ie.options,
            callback: (ti) => ce({
              type: $.Plugin,
              data: {
                plugin: ie.name,
                payload: ti
              }
            })
          }))) || []
        },
        X
      );
    };
    D.addLoadListener((ae) => {
      try {
        te.push(Ve(ae.contentDocument));
      } catch (Se) {
        console.warn(Se);
      }
    });
    const oe = () => {
      Yt(), te.push(Ve(document)), Mt = !0;
    };
    return ["interactive", "complete"].includes(document.readyState) ? oe() : (te.push(
      Ze("DOMContentLoaded", () => {
        ce({
          type: $.DomContentLoaded,
          data: {}
        }), W === "DOMContentLoaded" && oe();
      })
    ), te.push(
      Ze(
        "load",
        () => {
          ce({
            type: $.Load,
            data: {}
          }), W === "load" && oe();
        },
        window
      )
    )), () => {
      te.forEach((ae) => {
        try {
          ae();
        } catch (Se) {
          String(Se).toLowerCase().includes("cross-origin") || console.warn(Se);
        }
      }), ue.destroy(), Mt = !1, xc();
    };
  } catch (te) {
    console.warn(te);
  }
}
Je.addCustomEvent = (e, t) => {
  Mt && ce({
    type: $.Custom,
    data: {
      tag: e,
      payload: t
    }
  });
};
Je.freezePage = () => {
  Oe.forEach((e) => e.freeze());
};
Je.takeFullSnapshot = (e) => {
  if (!Mt)
    throw new Error("please take full snapshot after start recording");
  Yt(e);
};
Je.snapshotCanvas = (e) => pe(void 0, null, function* () {
  if (!ct)
    throw new Error("canvas manager is not initialized");
  yield ct.snapshot(e);
});
Je.mirror = We;
var kn;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(kn || (kn = {}));
const { addCustomEvent: Jn } = Je, iu = (e, t, s) => {
  switch (e) {
    case "strict":
      return [!0, void 0];
    case "default":
      return [!0, void 0];
    case "none":
      return [!!t, he(K({}, s), { password: !0 })];
  }
}, su = (e) => {
  const t = (l) => {
    if (l.target) {
      const c = l.target, u = Pn(c);
      e(u, l);
    }
  }, s = { capture: !0 };
  return window.addEventListener("click", t, s), () => window.removeEventListener("click", t, s);
}, ru = (e) => {
  const t = (s) => {
    if (s.target) {
      const l = Pn(s.target);
      e(l);
    }
  };
  return window.addEventListener("focusin", t), () => window.removeEventListener("focusin", t);
}, nu = (e) => {
  let t, s;
  if (typeof document.hidden != "undefined" ? (t = "hidden", s = "visibilitychange") : typeof document.msHidden != "undefined" ? (t = "msHidden", s = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (t = "webkitHidden", s = "webkitvisibilitychange"), s === void 0)
    return () => {
    };
  if (t === void 0)
    return () => {
    };
  const l = t, c = () => {
    const f = document[l];
    e(!!f);
  };
  document.addEventListener(s, c);
  const u = s;
  return () => document.removeEventListener(u, c);
}, lu = (e) => {
  e(window.location.href);
  var t = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(u) {
    setTimeout(() => {
      var b;
      var f;
      try {
        f = JSON.parse((b = u == null ? void 0 : u.toString()) != null ? b : "");
      } catch (m) {
        return;
      }
      (f.type === "track" || f.type === "identify") && ds(f) && e(f);
    }, 100), t.call(this, u);
  };
  const s = (u) => {
    if (u.key === "ajs_user_id" || u.key === "ajs_anonymous_id" || u.key === "ajs_user_traits") {
      const { userId: f, userTraits: b } = Yn();
      if (f) {
        let m = {};
        b && (m = JSON.parse(b));
        const h = {
          type: "identify",
          userId: f.toString(),
          traits: m
        };
        ds(h) && e(h);
      }
    }
  }, { userId: l, userTraits: c } = Yn();
  if (l) {
    let u = {};
    c && (u = JSON.parse(c));
    const f = {
      type: "identify",
      userId: l.toString(),
      traits: u
    };
    ds(f) && e(f);
  }
  return window.addEventListener("storage", s), $l(({ keyName: u }) => {
    s({
      key: u
    });
  }), () => {
    window.removeEventListener("storage", s), XMLHttpRequest.prototype.send = t;
  };
}, Yn = () => {
  const e = ve(
    "ajs_user_id"
    /* USER_ID */
  ), t = ve(
    "ajs_user_traits"
    /* USER_TRAITS */
  ), s = ve(
    "ajs_anonymous_id"
    /* ANONYMOUS_ID */
  );
  return {
    userId: e,
    userTraits: t,
    anonymousId: s
  };
}, ds = (e) => {
  if (!e)
    return !1;
  let t = "";
  try {
    t = JSON.stringify(e);
  } catch (c) {
    return !1;
  }
  const s = ou(t), l = ve(
    ke.SEGMENT_LAST_SENT_HASH_KEY
  );
  return l === void 0 ? (Pe(ke.SEGMENT_LAST_SENT_HASH_KEY, s), !0) : s !== l ? (Pe(ke.SEGMENT_LAST_SENT_HASH_KEY, s), !0) : !1;
}, ou = (e) => {
  var t = 0, s = e.length, l = 0;
  if (s > 0) for (; l < s; ) t = (t << 5) - t + e.charCodeAt(l++) | 0;
  return t.toString();
}, au = (e, t) => {
  const s = cu(e);
  let l = [];
  const c = !1, u = !0;
  for (let f = 0; f < s.length; f++) {
    let b = s[f].split("+");
    l = [], b.length > 1 && (l = hu(zl, b)), b = b[b.length - 1], b = b === "*" ? "*" : du(b), b in xe || (xe[b] = []), xe[b].push({
      mods: l,
      shortcut: s[f],
      key: s[f],
      method: t,
      keyup: c,
      keydown: u,
      scope: "all",
      splitKey: "+"
    });
  }
  pu(document, "keydown", (f) => {
    fu(f);
  });
};
let be = [];
function cu(e) {
  typeof e != "string" && (e = ""), e = e.replace(/\s/g, "");
  const t = e.split(",");
  let s = t.lastIndexOf("");
  for (; s >= 0; )
    t[s - 1] += ",", t.splice(s, 1), s = t.lastIndexOf("");
  return t;
}
const xe = {}, hs = typeof navigator != "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1, uu = {
  backspace: 8,
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": hs ? 173 : 189,
  "=": hs ? 61 : 187,
  ";": hs ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, Nn = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, ye = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, zl = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, du = (e) => (
  // @ts-expect-error
  uu[e.toLowerCase()] || // @ts-expect-error
  zl[e.toLowerCase()] || e.toUpperCase().charCodeAt(0)
);
function hu(e, t) {
  const s = t.slice(0, t.length - 1);
  for (let l = 0; l < s.length; l++)
    s[l] = e[s[l].toLowerCase()];
  return s;
}
function pu(e, t, s) {
  e.addEventListener ? e.addEventListener(t, s, !1) : e.attachEvent && e.attachEvent(`on${t}`, () => {
    s(window.event);
  });
}
function mu(e, t, s) {
  let l;
  if (t.scope === s || t.scope === "all") {
    l = t.mods.length > 0;
    for (const c in ye)
      Object.prototype.hasOwnProperty.call(ye, c) && // @ts-expect-error
      (!ye[c] && t.mods.indexOf(+c) > -1 || // @ts-expect-error
      ye[c] && t.mods.indexOf(+c) === -1) && (l = !1);
    (t.mods.length === 0 && !ye[16] && !ye[18] && !ye[17] && !ye[91] || l || t.shortcut === "*") && t.method(e, t) === !1 && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, e.stopPropagation && e.stopPropagation(), e.cancelBubble && (e.cancelBubble = !0));
  }
}
function fu(e) {
  const t = xe["*"];
  let s = e.keyCode || e.which || e.charCode;
  if ((s === 93 || s === 224) && (s = 91), be.indexOf(s) === -1 && s !== 229 && be.push(s), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((l) => {
    const c = Nn[l];
    e[l] && be.indexOf(c) === -1 ? be.push(c) : !e[l] && be.indexOf(c) > -1 ? be.splice(be.indexOf(c), 1) : l === "metaKey" && e[l] && be.length === 3 && (e.ctrlKey || e.shiftKey || e.altKey || (be = be.slice(be.indexOf(c))));
  }), !(s in ye && (ye[s] = !0, !t))) {
    for (const l in ye)
      Object.prototype.hasOwnProperty.call(ye, l) && (ye[l] = e[Nn[l]]);
    if (e.getModifierState && !(e.altKey && !e.ctrlKey) && e.getModifierState("AltGraph") && (be.indexOf(17) === -1 && be.push(17), be.indexOf(18) === -1 && be.push(18), ye[17] = !0, ye[18] = !0), s in xe) {
      for (let l = 0; l < xe[s].length; l++)
        if (
          // @ts-expect-error
          (e.type === "keydown" && xe[s][l].keydown || // @ts-expect-error
          e.type === "keyup" && xe[s][l].keyup) && xe[s][l].key
        ) {
          const c = xe[s][l];
          mu(e, c, "all");
        }
    }
  }
}
const Tn = "iframe parent ready", Un = "iframe ok", mt = "highlightLogs", bu = (e) => {
  let t = ve(mt) || "";
  t = t + "[" + (/* @__PURE__ */ new Date()).getTime() + "] " + e + `
`, Pe(mt, t);
}, yu = () => ve(mt) || "", Zu = (e) => {
  if (!e)
    return;
  let t = ve(mt) || "";
  t && (t.startsWith(e) ? (t = t.slice(e.length), Pe(mt, t)) : bu(
    "Unable to clear logs " + e.replace(`
`, " ") + " from " + t.replace(`
`, " ")
  ));
};
var Re = Uint8Array, Xe = Uint16Array, Ms = Int32Array, zs = new Re([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), Hs = new Re([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), Kn = new Re([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Hl = function(e, t) {
  for (var s = new Xe(31), l = 0; l < 31; ++l)
    s[l] = t += 1 << e[l - 1];
  for (var c = new Ms(s[30]), l = 1; l < 30; ++l)
    for (var u = s[l]; u < s[l + 1]; ++u)
      c[u] = u - s[l] << 5 | l;
  return { b: s, r: c };
}, Ol = Hl(zs, 2), gu = Ol.b, gs = Ol.r;
gu[28] = 258, gs[258] = 28;
var Su = Hl(Hs, 0), Fn = Su.r, Ss = new Xe(32768);
for (var le = 0; le < 32768; ++le) {
  var Ue = (le & 43690) >> 1 | (le & 21845) << 1;
  Ue = (Ue & 52428) >> 2 | (Ue & 13107) << 2, Ue = (Ue & 61680) >> 4 | (Ue & 3855) << 4, Ss[le] = ((Ue & 65280) >> 8 | (Ue & 255) << 8) >> 1;
}
var ut = function(e, t, s) {
  for (var l = e.length, c = 0, u = new Xe(t); c < l; ++c)
    e[c] && ++u[e[c] - 1];
  var f = new Xe(t);
  for (c = 1; c < t; ++c)
    f[c] = f[c - 1] + u[c - 1] << 1;
  var b;
  if (s) {
    b = new Xe(1 << t);
    var m = 15 - t;
    for (c = 0; c < l; ++c)
      if (e[c])
        for (var h = c << 4 | e[c], d = t - e[c], r = f[e[c] - 1]++ << d, n = r | (1 << d) - 1; r <= n; ++r)
          b[Ss[r] >> m] = h;
  } else
    for (b = new Xe(l), c = 0; c < l; ++c)
      e[c] && (b[c] = Ss[f[e[c] - 1]++] >> 15 - e[c]);
  return b;
}, Qe = new Re(288);
for (var le = 0; le < 144; ++le)
  Qe[le] = 8;
for (var le = 144; le < 256; ++le)
  Qe[le] = 9;
for (var le = 256; le < 280; ++le)
  Qe[le] = 7;
for (var le = 280; le < 288; ++le)
  Qe[le] = 8;
var zt = new Re(32);
for (var le = 0; le < 32; ++le)
  zt[le] = 5;
var Xu = /* @__PURE__ */ ut(Qe, 9, 0), Ru = /* @__PURE__ */ ut(zt, 5, 0), Pl = function(e) {
  return (e + 7) / 8 | 0;
}, El = function(e, t, s) {
  return (s == null || s > e.length) && (s = e.length), new Re(e.subarray(t, s));
}, Le = function(e, t, s) {
  s <<= t & 7;
  var l = t / 8 | 0;
  e[l] |= s, e[l + 1] |= s >> 8;
}, rt = function(e, t, s) {
  s <<= t & 7;
  var l = t / 8 | 0;
  e[l] |= s, e[l + 1] |= s >> 8, e[l + 2] |= s >> 16;
}, ps = function(e, t) {
  for (var s = [], l = 0; l < e.length; ++l)
    e[l] && s.push({ s: l, f: e[l] });
  var c = s.length, u = s.slice();
  if (!c)
    return { t: Bl, l: 0 };
  if (c == 1) {
    var f = new Re(s[0].s + 1);
    return f[s[0].s] = 1, { t: f, l: 1 };
  }
  s.sort(function(g, y) {
    return g.f - y.f;
  }), s.push({ s: -1, f: 25001 });
  var b = s[0], m = s[1], h = 0, d = 1, r = 2;
  for (s[0] = { s: -1, f: b.f + m.f, l: b, r: m }; d != c - 1; )
    b = s[s[h].f < s[r].f ? h++ : r++], m = s[h != d && s[h].f < s[r].f ? h++ : r++], s[d++] = { s: -1, f: b.f + m.f, l: b, r: m };
  for (var n = u[0].s, l = 1; l < c; ++l)
    u[l].s > n && (n = u[l].s);
  var i = new Xe(n + 1), o = Xs(s[d - 1], i, 0);
  if (o > t) {
    var l = 0, a = 0, p = o - t, X = 1 << p;
    for (u.sort(function(y, R) {
      return i[R.s] - i[y.s] || y.f - R.f;
    }); l < c; ++l) {
      var Z = u[l].s;
      if (i[Z] > t)
        a += X - (1 << o - i[Z]), i[Z] = t;
      else
        break;
    }
    for (a >>= p; a > 0; ) {
      var S = u[l].s;
      i[S] < t ? a -= 1 << t - i[S]++ - 1 : ++l;
    }
    for (; l >= 0 && a; --l) {
      var G = u[l].s;
      i[G] == t && (--i[G], ++a);
    }
    o = t;
  }
  return { t: new Re(i), l: o };
}, Xs = function(e, t, s) {
  return e.s == -1 ? Math.max(Xs(e.l, t, s + 1), Xs(e.r, t, s + 1)) : t[e.s] = s;
}, Mn = function(e) {
  for (var t = e.length; t && !e[--t]; )
    ;
  for (var s = new Xe(++t), l = 0, c = e[0], u = 1, f = function(m) {
    s[l++] = m;
  }, b = 1; b <= t; ++b)
    if (e[b] == c && b != t)
      ++u;
    else {
      if (!c && u > 2) {
        for (; u > 138; u -= 138)
          f(32754);
        u > 2 && (f(u > 10 ? u - 11 << 5 | 28690 : u - 3 << 5 | 12305), u = 0);
      } else if (u > 3) {
        for (f(c), --u; u > 6; u -= 6)
          f(8304);
        u > 2 && (f(u - 3 << 5 | 8208), u = 0);
      }
      for (; u--; )
        f(c);
      u = 1, c = e[b];
    }
  return { c: s.subarray(0, l), n: t };
}, nt = function(e, t) {
  for (var s = 0, l = 0; l < t.length; ++l)
    s += e[l] * t[l];
  return s;
}, Ql = function(e, t, s) {
  var l = s.length, c = Pl(t + 2);
  e[c] = l & 255, e[c + 1] = l >> 8, e[c + 2] = e[c] ^ 255, e[c + 3] = e[c + 1] ^ 255;
  for (var u = 0; u < l; ++u)
    e[c + u + 4] = s[u];
  return (c + 4 + l) * 8;
}, zn = function(e, t, s, l, c, u, f, b, m, h, d) {
  Le(t, d++, s), ++c[256];
  for (var r = ps(c, 15), n = r.t, i = r.l, o = ps(u, 15), a = o.t, p = o.l, X = Mn(n), Z = X.c, S = X.n, G = Mn(a), g = G.c, y = G.n, R = new Xe(19), W = 0; W < Z.length; ++W)
    ++R[Z[W] & 31];
  for (var W = 0; W < g.length; ++W)
    ++R[g[W] & 31];
  for (var V = ps(R, 7), I = V.t, v = V.l, x = 19; x > 4 && !I[Kn[x - 1]]; --x)
    ;
  var P = h + 5 << 3, O = nt(c, Qe) + nt(u, zt) + f, w = nt(c, n) + nt(u, a) + f + 14 + 3 * x + nt(R, I) + 2 * R[16] + 3 * R[17] + 7 * R[18];
  if (m >= 0 && P <= O && P <= w)
    return Ql(t, d, e.subarray(m, m + h));
  var q, J, F, _;
  if (Le(t, d, 1 + (w < O)), d += 2, w < O) {
    q = ut(n, i, 0), J = n, F = ut(a, p, 0), _ = a;
    var M = ut(I, v, 0);
    Le(t, d, S - 257), Le(t, d + 5, y - 1), Le(t, d + 10, x - 4), d += 14;
    for (var W = 0; W < x; ++W)
      Le(t, d + 3 * W, I[Kn[W]]);
    d += 3 * x;
    for (var Q = [Z, g], ne = 0; ne < 2; ++ne)
      for (var C = Q[ne], W = 0; W < C.length; ++W) {
        var se = C[W] & 31;
        Le(t, d, M[se]), d += I[se], se > 15 && (Le(t, d, C[W] >> 5 & 127), d += C[W] >> 12);
      }
  } else
    q = Xu, J = Qe, F = Ru, _ = zt;
  for (var W = 0; W < b; ++W) {
    var k = l[W];
    if (k > 255) {
      var se = k >> 18 & 31;
      rt(t, d, q[se + 257]), d += J[se + 257], se > 7 && (Le(t, d, k >> 23 & 31), d += zs[se]);
      var N = k & 31;
      rt(t, d, F[N]), d += _[N], N > 3 && (rt(t, d, k >> 5 & 8191), d += Hs[N]);
    } else
      rt(t, d, q[k]), d += J[k];
  }
  return rt(t, d, q[256]), d + J[256];
}, Gu = /* @__PURE__ */ new Ms([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), Bl = /* @__PURE__ */ new Re(0), Vu = function(e, t, s, l, c, u) {
  var f = u.z || e.length, b = new Re(l + f + 5 * (1 + Math.ceil(f / 7e3)) + c), m = b.subarray(l, b.length - c), h = u.l, d = (u.r || 0) & 7;
  if (t) {
    d && (m[0] = u.r >> 3);
    for (var r = Gu[t - 1], n = r >> 13, i = r & 8191, o = (1 << s) - 1, a = u.p || new Xe(32768), p = u.h || new Xe(o + 1), X = Math.ceil(s / 3), Z = 2 * X, S = function(ue) {
      return (e[ue] ^ e[ue + 1] << X ^ e[ue + 2] << Z) & o;
    }, G = new Ms(25e3), g = new Xe(288), y = new Xe(32), R = 0, W = 0, V = u.i || 0, I = 0, v = u.w || 0, x = 0; V + 2 < f; ++V) {
      var P = S(V), O = V & 32767, w = p[P];
      if (a[O] = w, p[P] = O, v <= V) {
        var q = f - V;
        if ((R > 7e3 || I > 24576) && (q > 423 || !h)) {
          d = zn(e, m, 0, G, g, y, W, I, x, V - x, d), I = R = W = 0, x = V;
          for (var J = 0; J < 286; ++J)
            g[J] = 0;
          for (var J = 0; J < 30; ++J)
            y[J] = 0;
        }
        var F = 2, _ = 0, M = i, Q = O - w & 32767;
        if (q > 2 && P == S(V - Q))
          for (var ne = Math.min(n, q) - 1, C = Math.min(32767, V), se = Math.min(258, q); Q <= C && --M && O != w; ) {
            if (e[V + F] == e[V + F - Q]) {
              for (var k = 0; k < se && e[V + k] == e[V + k - Q]; ++k)
                ;
              if (k > F) {
                if (F = k, _ = Q, k > ne)
                  break;
                for (var N = Math.min(Q, k - 2), Y = 0, J = 0; J < N; ++J) {
                  var T = V - Q + J & 32767, H = a[T], B = T - H & 32767;
                  B > Y && (Y = B, w = T);
                }
              }
            }
            O = w, w = a[O], Q += O - w & 32767;
          }
        if (_) {
          G[I++] = 268435456 | gs[F] << 18 | Fn[_];
          var ee = gs[F] & 31, U = Fn[_] & 31;
          W += zs[ee] + Hs[U], ++g[257 + ee], ++y[U], v = V + F, ++R;
        } else
          G[I++] = e[V], ++g[e[V]];
      }
    }
    for (V = Math.max(V, v); V < f; ++V)
      G[I++] = e[V], ++g[e[V]];
    d = zn(e, m, h, G, g, y, W, I, x, V - x, d), h || (u.r = d & 7 | m[d / 8 | 0] << 3, d -= 7, u.h = p, u.p = a, u.i = V, u.w = v);
  } else {
    for (var V = u.w || 0; V < f + h; V += 65535) {
      var D = V + 65535;
      D >= f && (m[d / 8 | 0] = h, D = f), d = Ql(m, d + 1, e.subarray(V, D));
    }
    u.i = f;
  }
  return El(b, 0, l + Pl(d) + c);
}, Wu = /* @__PURE__ */ function() {
  for (var e = new Int32Array(256), t = 0; t < 256; ++t) {
    for (var s = t, l = 9; --l; )
      s = (s & 1 && -306674912) ^ s >>> 1;
    e[t] = s;
  }
  return e;
}(), Iu = function() {
  var e = -1;
  return {
    p: function(t) {
      for (var s = e, l = 0; l < t.length; ++l)
        s = Wu[s & 255 ^ t[l]] ^ s >>> 8;
      e = s;
    },
    d: function() {
      return ~e;
    }
  };
}, wu = function(e, t, s, l, c) {
  if (!c && (c = { l: 1 }, t.dictionary)) {
    var u = t.dictionary.subarray(-32768), f = new Re(u.length + e.length);
    f.set(u), f.set(e, u.length), e = f, c.w = u.length;
  }
  return Vu(e, t.level == null ? 6 : t.level, t.mem == null ? c.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 20 : 12 + t.mem, s, l, c);
}, Rs = function(e, t, s) {
  for (; s; ++t)
    e[t] = s, s >>>= 8;
}, Cu = function(e, t) {
  var s = t.filename;
  if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : t.level == 9 ? 2 : 0, e[9] = 3, t.mtime != 0 && Rs(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), s) {
    e[3] = 8;
    for (var l = 0; l <= s.length; ++l)
      e[l + 10] = s.charCodeAt(l);
  }
}, xu = function(e) {
  return 10 + (e.filename ? e.filename.length + 1 : 0);
};
function vu(e, t) {
  t || (t = {});
  var s = Iu(), l = e.length;
  s.p(e);
  var c = wu(e, t, xu(t), 8), u = c.length;
  return Cu(c, t), Rs(c, u - 8, s.d()), Rs(c, u - 4, l), c;
}
var Hn = typeof TextEncoder != "undefined" && /* @__PURE__ */ new TextEncoder(), Lu = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
try {
  Lu.decode(Bl, { stream: !0 });
} catch (e) {
}
function ku(e, t) {
  var s;
  if (Hn)
    return Hn.encode(e);
  for (var l = e.length, c = new Re(e.length + (e.length >> 1)), u = 0, f = function(h) {
    c[u++] = h;
  }, s = 0; s < l; ++s) {
    if (u + 5 > c.length) {
      var b = new Re(u + 8 + (l - s << 1));
      b.set(c), c = b;
    }
    var m = e.charCodeAt(s);
    m < 128 || t ? f(m) : m < 2048 ? (f(192 | m >> 6), f(128 | m & 63)) : m > 55295 && m < 57344 ? (m = 65536 + (m & 1047552) | e.charCodeAt(++s) & 1023, f(240 | m >> 18), f(128 | m >> 12 & 63), f(128 | m >> 6 & 63), f(128 | m & 63)) : (f(224 | m >> 12), f(128 | m >> 6 & 63), f(128 | m & 63));
  }
  return El(c, 0, u);
}
function Ju(e) {
  return pe(this, null, function* () {
    const t = ku(JSON.stringify(e)), s = vu(t), l = yield new Promise((c) => {
      const u = new FileReader();
      u.onload = () => c(u.result), u.readAsDataURL(new Blob([new Uint8Array(s)]));
    });
    return {
      compressedBase64: l.slice(l.indexOf(",") + 1),
      compressedSize: s.length,
      bufferLength: t.length
    };
  });
}
const Dl = "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", Yu = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), On = typeof self != "undefined" && self.Blob && new Blob([Yu(Dl)], { type: "text/javascript;charset=utf-8" });
function Nu(e) {
  let t;
  try {
    if (t = On && (self.URL || self.webkitURL).createObjectURL(On), !t) throw "";
    const s = new Worker(t, {
      name: e == null ? void 0 : e.name
    });
    return s.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), s;
  } catch (s) {
    return new Worker(
      "data:text/javascript;base64," + Dl,
      {
        name: e == null ? void 0 : e.name
      }
    );
  } finally {
    t && (self.URL || self.webkitURL).revokeObjectURL(t);
  }
}
var Ce = /* @__PURE__ */ ((e) => (e[e.Initialize = 0] = "Initialize", e[e.Reset = 1] = "Reset", e[e.AsyncEvents = 2] = "AsyncEvents", e[e.Identify = 3] = "Identify", e[e.Properties = 4] = "Properties", e[e.Metrics = 5] = "Metrics", e[e.Feedback = 6] = "Feedback", e[e.CustomEvent = 7] = "CustomEvent", e[e.Stop = 8] = "Stop", e[e.GetStatus = 9] = "GetStatus", e))(Ce || {});
const Tu = ({
  apiKey: e
}) => {
  (function(t, s) {
    var l = t.amplitude || { _q: [], _iq: {} }, c = s.createElement("script");
    c.type = "text/javascript", c.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", c.crossOrigin = "anonymous", c.async = !0, c.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", c.onload = function() {
      t.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(e);
    };
    var u = s.getElementsByTagName("script")[0];
    u.parentNode.insertBefore(c, u);
    function f(a, p) {
      a.prototype[p] = function() {
        return this._q.push(
          [p].concat(Array.prototype.slice.call(arguments, 0))
        ), this;
      };
    }
    for (var b = function() {
      return this._q = [], this;
    }, m = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], h = 0; h < m.length; h++)
      f(b, m[h]);
    l.Identify = b;
    for (var d = function() {
      return this._q = [], this;
    }, r = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], n = 0; n < r.length; n++)
      f(d, r[n]);
    l.Revenue = d;
    var i = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function o(a) {
      function p(Z) {
        a[Z] = function() {
          a._q.push(
            [Z].concat(Array.prototype.slice.call(arguments, 0))
          );
        };
      }
      for (var X = 0; X < i.length; X++)
        p(i[X]);
    }
    o(l), l.getInstance = function(a) {
      return a = (!a || a.length === 0 ? "$default_instance" : a).toLowerCase(), Object.prototype.hasOwnProperty.call(l._iq, a) || (l._iq[a] = { _q: [] }, o(l._iq[a])), l._iq[a];
    }, t.amplitude = l;
  })(window, document);
}, Uu = ({
  projectToken: e
}) => {
  if (window.mixpanel)
    return;
  (function(s, l) {
    if (!l.__SV) {
      var c, u;
      window.mixpanel = l, l._i = [], l.init = function(f, b, m) {
        function h(n, i) {
          var o = i.split(".");
          o.length == 2 && (n = n[o[0]], i = o[1]), n[i] = function() {
            n.push(
              [i].concat(
                Array.prototype.slice.call(arguments, 0)
              )
            );
          };
        }
        var d = l;
        for (typeof m != "undefined" ? d = l[m] = [] : m = "mixpanel", d.people = d.people || [], d.toString = function(n) {
          var i = "mixpanel";
          return m !== "mixpanel" && (i += "." + m), n || (i += " (stub)"), i;
        }, d.people.toString = function() {
          return d.toString(1) + ".people (stub)";
        }, c = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(
          " "
        ), u = 0; u < c.length; u++) h(d, c[u]);
        var r = "set set_once union unset remove delete".split(" ");
        d.get_group = function() {
          function n(p) {
            i[p] = function() {
              call2_args = arguments, call2 = [p].concat(
                Array.prototype.slice.call(call2_args, 0)
              ), d.push([o, call2]);
            };
          }
          for (var i = {}, o = ["get_group"].concat(
            Array.prototype.slice.call(arguments, 0)
          ), a = 0; a < r.length; a++)
            n(r[a]);
          return i;
        }, l._i.push([f, b, m]);
      }, l.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const t = document.createElement("script");
  t.src = Ku, document.head.appendChild(t), t.addEventListener("load", () => {
    var s;
    (s = window.mixpanel) == null || s.init(e);
  });
}, Ku = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
var ft;
class Fu {
  constructor(t) {
    z(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    z(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    z(this, "organizationID");
    // ECMAScript-private (#) so the internal GraphQL SDK type — which
    // references graphql-request / graphql — does not leak into the published
    // declaration file and break consumer type-checking.
    Ds(this, ft);
    z(this, "events");
    z(this, "sessionData");
    z(this, "ready");
    z(this, "manualStopped");
    z(this, "state");
    z(this, "logger");
    z(this, "enableSegmentIntegration");
    z(this, "privacySetting");
    z(this, "enableCanvasRecording");
    z(this, "samplingStrategy");
    z(this, "inlineImages");
    z(this, "inlineVideos");
    z(this, "inlineStylesheet");
    z(this, "debugOptions");
    z(this, "listeners");
    z(this, "firstloadVersion");
    z(this, "environment");
    z(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    z(this, "appVersion");
    z(this, "serviceName");
    z(this, "_worker");
    z(this, "_optionsInternal");
    z(this, "_backendUrl");
    z(this, "_recordingStartTime");
    z(this, "_isOnLocalHost");
    z(this, "_onToggleFeedbackFormVisibility");
    z(this, "_isCrossOriginIframe");
    z(this, "_eventBytesSinceSnapshot");
    z(this, "_lastSnapshotTime");
    z(this, "_lastVisibilityChangeTime");
    z(this, "pushPayloadTimerId");
    z(this, "hasSessionUnloaded");
    z(this, "hasPushedData");
    z(this, "reloaded");
    z(this, "_hasPreviouslyInitialized");
    z(this, "_recordStop");
    z(this, "_integrations", []);
    var l, c, u, f, b;
    this.options = t, typeof ((l = this.options) == null ? void 0 : l.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (u = (c = this.options) == null ? void 0 : c.debug) != null ? u : {}, this.logger = new wo(this.debugOptions.clientInteractions), this._worker = new Nu(), this._worker.onmessage = (m) => {
      var h, d, r;
      ((h = m.data.response) == null ? void 0 : h.type) === Ce.AsyncEvents ? (this._eventBytesSinceSnapshot += m.data.response.eventsSize, this.logger.log(
        `Web worker sent payloadID ${m.data.response.id} size ${m.data.response.eventsSize} bytes, compression ratio ${m.data.response.eventsSize / m.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`
      )) : ((d = m.data.response) == null ? void 0 : d.type) === Ce.CustomEvent ? this.addCustomEvent(
        m.data.response.tag,
        m.data.response.payload
      ) : ((r = m.data.response) == null ? void 0 : r.type) === Ce.Stop && (Ke(
        "worker.onmessage",
        "warn",
        "Stopping recording due to worker failure",
        m.data.response
      ), this.stop(!1));
    };
    let s = si();
    if (this.reloaded = !1, !((f = this.sessionData) != null && f.sessionSecureID) && (s != null && s.sessionSecureID))
      this.sessionData = s, this.options.sessionSecureID = s.sessionSecureID, this.reloaded = !0, this.logger.log(
        `Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`
      );
    else {
      for (const m of Object.values(ke))
        As(m);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1;
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (m) {
      this._isCrossOriginIframe = (b = this.options.recordCrossOriginIframe) != null ? b : !0;
    }
    this._initMembers(this.options);
  }
  // Start a new session
  _reset(l) {
    return pe(this, arguments, function* ({
      forceNew: t,
      sessionKey: s
    }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let c, u;
      if (!t)
        try {
          c = ve(ke.USER_IDENTIFIER);
          const f = ve(
            ke.USER_OBJECT
          );
          f && (u = JSON.parse(f));
        } catch (f) {
        }
      for (const f of Object.values(ke))
        As(f);
      this.sessionData.sessionSecureID = s ? ri(`${this.organizationID}-${s}`) : ri(), this.sessionData.sessionKey = s, this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stop(), this._worker.postMessage({ message: { type: Ce.Reset } }), yield this.start(), c && u && this.identify(c, u);
    });
  }
  _initMembers(t) {
    var u, f, b, m, h, d, r, n, i;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!t.enableSegmentIntegration, this.privacySetting = (u = t.privacySetting) != null ? u : "default", this.enableCanvasRecording = (f = t.enableCanvasRecording) != null ? f : !1, this.inlineImages = (b = t.inlineImages) != null ? b : this._isOnLocalHost, this.inlineVideos = (m = t.inlineVideos) != null ? m : this._isOnLocalHost, this.inlineStylesheet = (h = t.inlineStylesheet) != null ? h : this._isOnLocalHost, this.samplingStrategy = K({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: ql()
    }, (d = t.samplingStrategy) != null ? d : {
      canvas: 2
    }), this._backendUrl = (r = t == null ? void 0 : t.backendUrl) != null ? r : "https://pub.observability.app.launchdarkly.com", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const s = new io(`${this._backendUrl}`, {
      headers: {}
    });
    js(this, ft, eo(s, to())), this.environment = (n = t.environment) != null ? n : "production", this.appVersion = t.appVersion, this.serviceName = (i = t.serviceName) != null ? i : "browser", typeof t.organizationID == "string" ? this.organizationID = t.organizationID : this.organizationID = t.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = t.firstloadVersion || "unknown", this.sessionShortcut = t.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const o = t, { firstloadVersion: l } = o, c = it(o, ["firstloadVersion"]);
    this._optionsInternal = c, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(t, s = {}, l) {
    if (!t || t === "") {
      Ke(
        "identify",
        "warn",
        "Highlight's identify() call was passed an empty identifier.",
        { user_identifier: t, user_object: s }
      );
      return;
    }
    this.sessionData.userIdentifier = t.toString(), this.sessionData.userObject = s, Pe(
      ke.USER_IDENTIFIER,
      t.toString()
    ), Pe(ke.USER_OBJECT, JSON.stringify(s)), this._worker.postMessage({
      message: {
        type: Ce.Identify,
        userIdentifier: t,
        userObject: s,
        source: l
      }
    });
  }
  track(t, s) {
    this.addProperties(he(K({}, s), { event: t }));
  }
  addProperties(t = {}, s) {
    const l = K({}, t);
    Object.entries(l).forEach(([c, u]) => {
      try {
        structuredClone(u);
      } catch (f) {
        delete l[c];
      }
    }), this._worker.postMessage({
      message: {
        type: Ce.Properties,
        propertiesObject: l,
        propertyType: s
      }
    });
  }
  /**
   * Add custom session-level properties. These are attached to the current session
   * and are searchable, but do not create timeline Track events.
   */
  addSessionProperties(t) {
    this.addProperties(t, { type: "session" });
  }
  start(t) {
    return pe(this, null, function* () {
      var s, l, c, u, f, b, m, h, d, r;
      if (!((s = navigator == null ? void 0 : navigator.userAgent) != null && s.includes("Googlebot") || (l = navigator == null ? void 0 : navigator.userAgent) != null && l.includes("AdsBot")))
        try {
          if (t != null && t.forceNew) {
            yield this._reset(t);
            return;
          }
          if (t != null && t.sessionKey && (t == null ? void 0 : t.sessionKey) !== this.sessionData.sessionKey) {
            yield this._reset(he(K({}, t), { forceNew: !0 }));
            return;
          }
          this.logger.log(
            "Initializing...",
            t,
            this.sessionData,
            this.options
          ), this.sessionData = (c = si(this.sessionData.sessionSecureID)) != null ? c : this.sessionData, (u = this.sessionData) != null && u.sessionStartTime ? this._recordingStartTime = (f = this.sessionData) == null ? void 0 : f.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime);
          let n = ve(_s.CLIENT_ID);
          n || (n = ri(), Pe(_s.CLIENT_ID, n));
          let i;
          this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? i = !1 : i = ((b = this.options.networkRecording) == null ? void 0 : b.recordHeadersAndBody) || !1;
          let o = [];
          if (typeof this.options.networkRecording == "object" && ((m = this.options.networkRecording.destinationDomains) != null && m.length) && (o = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
            yield this._setupCrossOriginIframe();
          else {
            const S = yield Bs(this, ft).initializeSession({
              organization_verbose_id: this.organizationID,
              enable_strict_privacy: this.privacySetting === "strict",
              privacy_setting: this.privacySetting,
              enable_recording_network_contents: i,
              clientVersion: this.firstloadVersion,
              firstloadVersion: this.firstloadVersion,
              clientConfig: JSON.stringify(this._optionsInternal),
              environment: this.environment,
              id: n,
              appVersion: this.appVersion,
              serviceName: this.serviceName,
              session_secure_id: this.sessionData.sessionSecureID,
              session_key: this.sessionData.sessionKey,
              client_id: n,
              network_recording_domains: o,
              disable_session_recording: this.options.disableSessionRecording
            });
            if (S.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(
              `Unexpected secure id returned by initializeSession: ${S.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`
            ), this.sessionData.sessionSecureID = S.initializeSession.secure_id, this.sessionData.projectID = parseInt(
              ((h = S == null ? void 0 : S.initializeSession) == null ? void 0 : h.project_id) || "0"
            ), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
              console.error(
                "Failed to initialize Highlight; an error occurred on our end.",
                this.sessionData
              );
              return;
            }
          }
          ni(""), st(this.sessionData), this.logger.log(
            `Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
          ), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
            message: {
              type: Ce.Initialize,
              sessionSecureID: this.sessionData.sessionSecureID,
              backend: this._backendUrl,
              debug: !!this.debugOptions.clientInteractions,
              recordingStartTime: this._recordingStartTime
            }
          });
          for (const S of this._integrations)
            S.init(this.sessionData.sessionSecureID);
          if (this.sessionData.userIdentifier && this.identify(
            this.sessionData.userIdentifier,
            this.sessionData.userObject
          ), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
            this._save();
          }, $s)), this.options.disableSessionRecording) {
            this.logger.log(
              "Highlight is NOT RECORDING a session replay per H.init setting."
            ), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
            return;
          }
          const a = (S, G) => {
            G && this.logger.log("received isCheckout emit", { event: S }), this.events.push(S);
          };
          a.bind(this);
          const p = !!this._recordStop;
          this._recordStop && (this._recordStop(), this._recordStop = void 0);
          const [X, Z] = iu(
            this.privacySetting,
            this.options.maskAllInputs,
            this.options.maskInputOptions
          );
          this._recordStop = Je({
            ignoreClass: (d = this.options.ignoreClass) != null ? d : "highlight-ignore",
            ignoreSelector: this.options.ignoreSelector,
            blockClass: (r = this.options.blockClass) != null ? r : "highlight-block",
            blockSelector: this.options.blockSelector,
            emit: a,
            recordCrossOriginIframes: this.options.recordCrossOriginIframe,
            privacySetting: this.privacySetting,
            maskAllInputs: X,
            maskInputOptions: Z,
            maskTextClass: this.options.maskTextClass,
            maskTextSelector: this.options.maskTextSelector,
            recordCanvas: this.enableCanvasRecording,
            sampling: {
              canvas: {
                fps: this.samplingStrategy.canvas,
                fpsManual: this.samplingStrategy.canvasManualSnapshot,
                resizeFactor: this.samplingStrategy.canvasFactor,
                clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
                initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
                dataURLOptions: this.samplingStrategy.dataUrlOptions,
                maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
              }
            },
            keepIframeSrcFn: (S) => !this.options.recordCrossOriginIframe,
            inlineImages: this.inlineImages,
            inlineVideos: this.inlineVideos,
            collectFonts: this.inlineImages,
            inlineStylesheet: this.inlineStylesheet,
            plugins: [Lo()],
            logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
              debug: this.logger.log,
              warn: Ke.bind("RecordSDK", "warn")
            } : void 0
          }), p || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties(
            { referrer: document.referrer },
            { type: "session" }
          ))), this.sessionData.sessionKey && this.addProperties(
            {
              sessionKey: this.sessionData.sessionKey
            },
            { type: "session" }
          ), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
        } catch (n) {
          Ke("initializeSession _setupWindowListeners", "warn", n);
        }
    });
  }
  _visibilityHandler(t) {
    return pe(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < so || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${t ? "hidden" : "visible"}.`), t ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stop()) : (this.options.disableBackgroundRecording && (yield this.start()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return pe(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((t) => {
        const s = (l) => {
          if (l.data.highlight === Tn) {
            const c = l.data;
            this.logger.log("highlight got window message ", c), this.sessionData.projectID = c.projectID, this.sessionData.sessionSecureID = c.sessionSecureID, window.parent.postMessage(
              {
                highlight: Un
              },
              "*"
            ), window.removeEventListener("message", s), t();
          }
        };
        window.addEventListener("message", s);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log(
      "highlight setting up cross origin iframe parent notification"
    ), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((t) => {
        var s;
        (s = t.contentWindow) == null || s.postMessage(
          {
            highlight: Tn,
            projectID: this.sessionData.projectID,
            sessionSecureID: this.sessionData.sessionSecureID
          },
          "*"
        );
      });
    }, $s), window.addEventListener("message", (t) => {
      t.data.highlight === Un && this.logger.log(
        "highlight got response from initialized iframe"
      );
    });
  }
  _setupWindowListeners() {
    var l;
    try {
      const c = this;
      this.enableSegmentIntegration && this.listeners.push(
        lu((f) => {
          if (f.type === "track") {
            const b = {};
            b["segment-event"] = f.event, c.addProperties(b, {
              type: "track",
              source: "segment"
            });
          } else if (f.type === "identify") {
            const b = f.userId.replace(
              /^"(.*)"$/,
              "$1"
            );
            c.identify(
              b,
              f.traits,
              "segment"
            );
          }
        })
      ), this.listeners.push(
        ro((f) => {
          this.reloaded ? (this.addCustomEvent("Reload", f), this.reloaded = !1, c.addProperties(
            { reload: !0 },
            { type: "session" }
          )) : this.addCustomEvent("Navigate", f);
        })
      ), this.listeners.push(
        no(
          (f) => {
            this.addCustomEvent("Viewport", f);
          }
        )
      ), this.listeners.push(
        su((f, b) => {
          let m = null, h = null;
          if (b && b.target) {
            const d = b.target;
            m = lo(d), h = d.textContent, h && h.length > 2e3 && (h = h.substring(0, 2e3));
          }
          this.addCustomEvent("Click", {
            clickTarget: f,
            clickTextContent: h,
            clickSelector: m
          });
        })
      ), this.listeners.push(
        ru((f) => {
          f && this.addCustomEvent("Focus", f);
        })
      ), this.sessionShortcut && au(this.sessionShortcut, () => {
        window.open(
          this.getCurrentSessionURLWithTimestamp(),
          "_blank"
        );
      }), this._hasPreviouslyInitialized || ((l = window.electron) != null && l.ipcRenderer ? (window.electron.ipcRenderer.on(
        "highlight.run",
        ({ visible: f }) => {
          this._visibilityHandler(!f);
        }
      ), this.logger.log("Set up Electron highlight.run events.")) : (nu(
        (f) => this._visibilityHandler(f)
      ), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const u = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", u), this.listeners.push(
        () => window.removeEventListener("beforeunload", u)
      );
    } catch (c) {
      Ke("initializeSession _setupWindowListeners", "warn", c);
    }
    const t = () => {
      this.addCustomEvent("Page Unload", ""), ni(this.sessionData.sessionSecureID), st(this.sessionData);
    };
    if (window.addEventListener("beforeunload", t), this.listeners.push(
      () => window.removeEventListener("beforeunload", t)
    ), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const c = () => {
        this.addCustomEvent("Page Unload", ""), ni(this.sessionData.sessionSecureID), st(this.sessionData);
      };
      window.addEventListener("pagehide", c), this.listeners.push(
        () => window.removeEventListener("beforeunload", c)
      );
    }
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stop(t) {
    this.manualStopped = !!t, this.manualStopped && this.addCustomEvent(
      "Stop",
      "H.stop() was called which stops Highlight from recording."
    ), this.state = "NotRecording", t && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((s) => s()), this.listeners = [];
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const t = (/* @__PURE__ */ new Date()).getTime(), { projectID: s, sessionSecureID: l } = this.sessionData, c = (t - this._recordingStartTime) / 1e3;
    return `https://${qs}/${s}/sessions/${l}?ts=${c}`;
  }
  getCurrentSessionURL() {
    const t = this.sessionData.projectID, s = this.sessionData.sessionSecureID;
    return t && s ? `https://${qs}/${t}/sessions/${s}` : null;
  }
  snapshot(t) {
    return pe(this, null, function* () {
      yield Je.snapshotCanvas(t);
    });
  }
  addSessionFeedback({
    timestamp: t,
    verbatim: s,
    user_email: l,
    user_name: c
  }) {
    var u;
    this._worker.postMessage({
      message: {
        type: Ce.Feedback,
        verbatim: s,
        timestamp: t,
        userName: c || this.sessionData.userIdentifier,
        userEmail: l || ((u = this.sessionData.userObject) == null ? void 0 : u.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return pe(this, null, function* () {
      var t;
      try {
        this.state === "Recording" && this.listeners && !this.sessionData.sessionKey && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > oo && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let s;
        ((t = this.options) == null ? void 0 : t.sendMode) === "local" && (s = (l) => pe(this, null, function* () {
          let c = new Blob(
            [
              JSON.stringify({
                query: bo(yo),
                variables: l
              })
            ],
            {
              type: "application/json"
            }
          );
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: c
          }), 0;
        })), yield this._sendPayload({ sendFn: s }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), st(this.sessionData);
      } catch (s) {
        Ke("_save", "warn", s);
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, ao));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(t, s) {
    if (this.state === "NotRecording") {
      let l;
      const c = () => {
        clearInterval(l), this.state === "Recording" && this.events.length > 0 ? Jn(t, s) : l = setTimeout(c, 500);
      };
      l = setTimeout(c, 500);
    } else this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && Jn(t, s);
  }
  _sendPayload(s) {
    return pe(this, arguments, function* ({
      sendFn: t
    }) {
      const l = [...this.events], { bytes: c, time: u } = this.enableCanvasRecording ? er.canvas : er.normal;
      this._eventBytesSinceSnapshot >= c && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= u && this.takeFullSnapshot(), this.logger.log(
        `Sending: ${l.length} events, 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
      );
      const f = (/* @__PURE__ */ new Date()).getTime(), b = yu();
      if (t) {
        const m = {
          session_secure_id: this.sessionData.sessionSecureID,
          payload_id: f.toString(),
          events: { events: l },
          messages: co({ messages: [] }),
          resources: JSON.stringify({ resources: [] }),
          web_socket_events: JSON.stringify({
            webSocketEvents: []
          }),
          errors: [],
          is_beacon: !1,
          has_session_unloaded: this.hasSessionUnloaded,
          highlight_logs: b || void 0
        }, { compressedBase64: h } = yield Ju(m);
        yield t({
          session_secure_id: this.sessionData.sessionSecureID,
          payload_id: f.toString(),
          data: h
        });
      } else
        this._worker.postMessage({
          message: {
            type: Ce.AsyncEvents,
            id: f,
            events: l,
            messages: [],
            errors: [],
            resourcesString: JSON.stringify({ resources: [] }),
            webSocketEventsString: JSON.stringify({
              webSocketEvents: []
            }),
            hasSessionUnloaded: this.hasSessionUnloaded,
            highlightLogs: b
          }
        });
      st(this.sessionData), this.events = this.events.slice(l.length), Zu(b);
    });
  }
  takeFullSnapshot() {
    if (!this._recordStop) {
      this.logger.log("skipping full snapshot as rrweb is not running");
      return;
    }
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), Je.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
  register(t, s) {
    this._integrations.push(new uo(t, s));
  }
  getHooks(t) {
    return this._integrations.flatMap((s) => {
      var l, c;
      return (c = (l = s.getHooks) == null ? void 0 : l.call(s, t)) != null ? c : [];
    });
  }
  getRecordingState() {
    var t;
    return (t = this == null ? void 0 : this.state) != null ? t : "NotRecording";
  }
  getSession() {
    const t = this.sessionData.sessionSecureID, s = si(t);
    if (!s)
      return null;
    const l = `${this.getFrontendUrl()}/sessions/${t}`;
    if (!l || !(s == null ? void 0 : s.sessionStartTime))
      return null;
    const u = (/* @__PURE__ */ new Date()).getTime();
    let f;
    try {
      f = new URL(l);
    } catch (h) {
      return Ke(
        "identify",
        "warn",
        `failed to construct session url from ${l}`,
        h
      ), null;
    }
    const b = new URL(f), m = (u - this._recordingStartTime) / 1e3;
    return b.searchParams.set("ts", m.toString()), {
      url: f.toString(),
      urlWithTimestamp: b.toString(),
      sessionSecureID: t
    };
  }
  getFrontendUrl() {
    var s, l;
    const t = this._backendUrl.match(ho);
    if (t && ((s = t == null ? void 0 : t.groups) != null && s.domain)) {
      const c = (l = t.groups.domain) != null ? l : "";
      return `https://${po[c]}${mo}`;
    }
    return fo;
  }
}
ft = new WeakMap();
class Pu extends Zo {
  constructor(s) {
    super(s);
    z(this, "record");
    z(this, "options");
    this.options = s;
  }
  initialize(s, l) {
    var c, u, f, b, m, h, d, r, n;
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/session-replay is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (typeof Worker == "undefined") {
        console.warn(
          "@launchdarkly/session-replay is not initializing because Worker is not supported."
        );
        return;
      }
      if (!s) {
        console.warn(
          "@launchdarkly/session-replay is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(s, l);
      const i = he(K({}, l), {
        organizationID: s,
        firstloadVersion: go,
        environment: (l == null ? void 0 : l.environment) || "production",
        appVersion: l == null ? void 0 : l.version,
        sessionSecureID: this.sessionSecureID,
        privacySetting: (c = l == null ? void 0 : l.privacySetting) != null ? c : "strict"
      });
      this.record = new Fu(i), l != null && l.manualStart || this.record.start(), Co.load(this.record), !((f = (u = l == null ? void 0 : l.integrations) == null ? void 0 : u.mixpanel) != null && f.disabled) && ((m = (b = l == null ? void 0 : l.integrations) == null ? void 0 : b.mixpanel) != null && m.projectToken) && Uu(l.integrations.mixpanel), !((d = (h = l == null ? void 0 : l.integrations) == null ? void 0 : h.amplitude) != null && d.disabled) && ((n = (r = l == null ? void 0 : l.integrations) == null ? void 0 : r.amplitude) != null && n.apiKey) && Tu(l.integrations.amplitude);
    } catch (i) {
      Ke(
        "Error initializing @launchdarkly/session-replay SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/session-replay"
    };
  }
  register(s, l) {
    var c;
    (c = this.record) == null || c.register(s, l);
  }
  getHooks(s) {
    var c, u, f, b;
    const l = K(K({
      [Io]: s.sdk.name,
      [Wo]: s.sdk.version,
      [Vo]: s.clientSideId,
      [Go]: "LaunchDarkly"
    }, (c = s.application) != null && c.id ? { [Ro]: s.application.id } : {}), (u = s.application) != null && u.version ? {
      [Xo]: s.application.version
    } : {});
    return this.initialize(
      (b = (f = s.sdkKey) != null ? f : s.mobileKey) != null ? b : s.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/session-replay/hooks"
        }),
        afterIdentify: (m, h, d) => {
          var r, n, i, o, a, p, X, Z;
          for (const S of (i = (n = (r = this.record) == null ? void 0 : r.getHooks) == null ? void 0 : n.call(r, s)) != null ? i : [])
            (o = S.afterIdentify) == null || o.call(S, m, h, d);
          if (d.status === "completed") {
            const S = he(K({}, So(m.context)), {
              key: (X = (p = (a = this.options) == null ? void 0 : a.contextFriendlyName) == null ? void 0 : p.call(
                a,
                m.context
              )) != null ? X : tr(m.context),
              canonicalKey: tr(m.context)
            });
            (Z = this.record) == null || Z.identify(
              S.key,
              K(K({}, l), S),
              "LaunchDarkly"
            );
          }
          return h;
        },
        afterEvaluation: (m, h, d) => {
          var r, n, i, o;
          for (const a of (i = (n = (r = this.record) == null ? void 0 : r.getHooks) == null ? void 0 : n.call(r, s)) != null ? i : [])
            (o = a.afterEvaluation) == null || o.call(a, m, h, d);
          return h;
        },
        afterTrack: (m) => {
          var h, d, r, n, i;
          for (const o of (r = (d = (h = this.record) == null ? void 0 : h.getHooks) == null ? void 0 : d.call(h, s)) != null ? r : [])
            (n = o.afterTrack) == null || n.call(o, m);
          (i = this.record) == null || i.track(m.key, {
            data: m.data,
            value: m.metricValue
          });
        }
      }
    ];
  }
}
export {
  su as C,
  ru as F,
  Tn as I,
  Ce as M,
  nu as P,
  Pu as R,
  lu as S,
  Nu as W,
  Un as a,
  au as b,
  Jn as c,
  Zu as d,
  Lo as e,
  iu as f,
  yu as g,
  Tu as h,
  Ju as p,
  Je as r,
  Uu as s
};
//# sourceMappingURL=record-DqhnSAj7.js.map
